{
  "type": "FlowRoot",
  "version": "1.0",
  "subs": [],
  "main": [
    {
      "id": "ybyse",
      "type": "Group",
      "category": "Section",
      "alias": "Schnelltest",
      "block": [
        {
          "id": "lng2s",
          "type": "Question",
          "alias": "Typ",
          "text": "Was möchtest du überprüfen?",
          "info": null,
          "answer": {
            "type": "ChoiceAnswer",
            "options": [
              {
                "id": "wb3w3",
                "alias": "Miete",
                "text": "Miete für aktuelle oder neue Wohnung"
              },
              {
                "id": "4uoj6",
                "alias": "Mieterhöhung",
                "text": "Mieterhöhung"
              }
            ]
          },
          "required": true
        },
        {
          "id": "0w5a7",
          "type": "Question",
          "alias": "Adresse",
          "text": "Wie lautet die Adresse der Wohnung?",
          "info": null,
          "answer": {
            "type": "TextAnswer"
          },
          "required": true
        },
        {
          "id": "k6fty",
          "type": "Question",
          "alias": "Wohnlage",
          "text": "[Hidden Question]",
          "info": null,
          "answer": {
            "type": "ChoiceAnswer",
            "options": [
              {
                "id": "8ktp",
                "alias": "einfach",
                "text": "einfach"
              },
              {
                "id": "pi77s",
                "alias": "mittel",
                "text": "mittel"
              },
              {
                "id": "v4s5m",
                "alias": "gut",
                "text": "gut"
              }
            ]
          },
          "required": false,
          "note": "Diese Frage wird nicht angezeigt"
        },
        {
          "id": "qwlyh",
          "type": "Question",
          "alias": "Ost",
          "text": "[Hidden Question]",
          "info": null,
          "answer": {
            "type": "BooleanAnswer"
          },
          "required": false,
          "note": "Diese Frage wird nicht angezeigt"
        },
        {
          "id": "sxmb3g",
          "type": "If",
          "cases": [
            {
              "id": "rnj3d",
              "type": "IfCase",
              "test": {
                "id": "doi7w",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Typ"
                },
                "negated": false,
                "type": "AnswerOptionComparison",
                "operator": "is",
                "comparands": [
                  "wb3w3"
                ]
              },
              "block": [
                {
                  "id": "23mp9",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Miete",
                  "block": [
                    {
                      "id": "atgzp",
                      "type": "Question",
                      "alias": "Unterschrieben",
                      "text": "Hast du den Mietvertrag für die Wohnung bereits unterschrieben?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "or4h3j",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "128cg",
                            "alias": "Nein",
                            "text": "Nein"
                          }
                        ]
                      },
                      "required": true
                    },
                    {
                      "id": "xxk9qk",
                      "type": "If",
                      "cases": [
                        {
                          "id": "v5xerf",
                          "type": "IfCase",
                          "test": {
                            "id": "5buxc",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Unterschrieben"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "or4h3j"
                            ]
                          },
                          "block": [
                            {
                              "id": "wkj67",
                              "type": "Question",
                              "alias": "Mietart",
                              "text": "Ist in dem Mietvertrag eine Staffelmiete oder Indexmiete vereinbart?",
                              "info": "Wenn eine Staffelmiete oder Indexmiete vereinbart ist, muss dies explizit in deinem Mietvertrag angegeben sein.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "8dx4p",
                                    "alias": "Staffelmiete",
                                    "text": "Staffelmiete"
                                  },
                                  {
                                    "id": "jwmlg",
                                    "alias": "Indexmiete",
                                    "text": "Indexmiete"
                                  },
                                  {
                                    "id": "h1ddm",
                                    "alias": "Normal",
                                    "text": "Keins von beiden"
                                  }
                                ]
                              },
                              "required": true
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "mcpull",
                          "type": "Question",
                          "alias": "Mietart",
                          "text": "Ist in dem Mietvertrag eine Staffelmiete oder Indexmiete vorgesehen?",
                          "info": "Wenn eine Staffelmiete oder Indexmiete vereinbart ist, muss dies explizit in deinem Mietvertrag angegeben sein.",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "8dx4p",
                                "alias": "Staffelmiete",
                                "text": "Staffelmiete"
                              },
                              {
                                "id": "jwmlg",
                                "alias": "Indexmiete",
                                "text": "Indexmiete"
                              },
                              {
                                "id": "h1ddm",
                                "alias": "Normal",
                                "text": "Keins von beiden"
                              }
                            ]
                          },
                          "required": true
                        }
                      ]
                    },
                    {
                      "id": "knhg9",
                      "type": "If",
                      "cases": [
                        {
                          "id": "0gu8e",
                          "type": "IfCase",
                          "test": {
                            "id": "p1ab7",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Unterschrieben"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "or4h3j"
                            ]
                          },
                          "block": [
                            {
                              "id": "0a7wh",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "0ya0n",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "ryezt",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Mietart"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "jwmlg"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "ti6pc",
                                      "type": "Question",
                                      "alias": "Vertragsdatum",
                                      "text": "Wann hast du den Mietvertrag unterschrieben?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "08tnb",
                                            "alias": "<2015",
                                            "text": "Vor 01.06.2015"
                                          },
                                          {
                                            "id": "wejo0k",
                                            "alias": "2015-2016",
                                            "text": "Zwischen 01.06.2015 und 31.08.2016"
                                          },
                                          {
                                            "id": "7np1",
                                            "alias": "2016-2018",
                                            "text": "Zwischen 01.09.2016 und 31.08.2018"
                                          },
                                          {
                                            "id": "m2jo",
                                            "alias": "2018-2020",
                                            "text": "Zwischen 01.09.2018 und 31.08.2020"
                                          },
                                          {
                                            "id": "4obam",
                                            "alias": "2020-2022",
                                            "text": "Zwischen 01.09.2020 und 31.08.2022"
                                          },
                                          {
                                            "id": "oqyrs",
                                            "alias": "2022-2024",
                                            "text": "Zwischen 01.09.2022 und 31.08.2023"
                                          },
                                          {
                                            "id": "ve0tek",
                                            "alias": "2024-2026",
                                            "text": "Zwischen 01.09.2023 und 31.08.2025"
                                          },
                                          {
                                            "id": "im8h1",
                                            "alias": ">2026",
                                            "text": "Ab 01.09.2025"
                                          }
                                        ]
                                      },
                                      "required": true
                                    }
                                  ]
                                },
                                {
                                  "id": "ly5r4",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "jwf18",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Mietart"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "8dx4p"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "v1lkyk",
                                      "type": "Question",
                                      "alias": "Neue Mietstaffel seit Vertragsabschluss",
                                      "text": "Ist seit Abschluss des Mietvertrages bereits eine neue Mietstaffel in Kraft getreten?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "7hl5h",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "iggd0j",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          }
                                        ]
                                      },
                                      "required": true
                                    },
                                    {
                                      "id": "wtjt2",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "uhi2g",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "gl7rn",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Neue Mietstaffel seit Vertragsabschluss"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "7hl5h"
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "fl3gm",
                                              "type": "Question",
                                              "alias": "Vertragsdatum",
                                              "text": "Wann ist die letzte Mietstaffel in Kraft getreten? ",
                                              "info": "Du findest diese Information in deinem Mietvertrag.",
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "08tnb",
                                                    "alias": "<2015",
                                                    "text": "Vor 01.06.2015"
                                                  },
                                                  {
                                                    "id": "wejo0k",
                                                    "alias": "2015-2016",
                                                    "text": "Zwischen 01.06.2015 und 31.08.2016"
                                                  },
                                                  {
                                                    "id": "7np1",
                                                    "alias": "2016-2018",
                                                    "text": "Zwischen 01.09.2016 und 31.08.2018"
                                                  },
                                                  {
                                                    "id": "m2jo",
                                                    "alias": "2018-2020",
                                                    "text": "Zwischen 01.09.2018 und 31.08.2020"
                                                  },
                                                  {
                                                    "id": "4obam",
                                                    "alias": "2020-2022",
                                                    "text": "Zwischen 01.09.2020 und 31.08.2022"
                                                  },
                                                  {
                                                    "id": "oqyrs",
                                                    "alias": "2022-2024",
                                                    "text": "Zwischen 01.09.2022 und 31.08.2023"
                                                  },
                                                  {
                                                    "id": "ve0tek",
                                                    "alias": "2024-2026",
                                                    "text": "Zwischen 01.09.2023 und 31.08.2025"
                                                  },
                                                  {
                                                    "id": "im8h1",
                                                    "alias": ">2026",
                                                    "text": "Ab 01.09.2025"
                                                  }
                                                ]
                                              },
                                              "required": true
                                            }
                                          ]
                                        }
                                      ],
                                      "alternate": [
                                        {
                                          "id": "ldv6p",
                                          "type": "Question",
                                          "alias": "Vertragsdatum",
                                          "text": "Wann hast du den Mietvertrag unterschrieben?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "08tnb",
                                                "alias": "<2015",
                                                "text": "Vor 01.06.2015"
                                              },
                                              {
                                                "id": "wejo0k",
                                                "alias": "2015-2016",
                                                "text": "Zwischen 01.06.2015 und 31.08.2016"
                                              },
                                              {
                                                "id": "7np1",
                                                "alias": "2016-2018",
                                                "text": "Zwischen 01.09.2016 und 31.08.2018"
                                              },
                                              {
                                                "id": "m2jo",
                                                "alias": "2018-2020",
                                                "text": "Zwischen 01.09.2018 und 31.08.2020"
                                              },
                                              {
                                                "id": "4obam",
                                                "alias": "2020-2022",
                                                "text": "Zwischen 01.09.2020 und 31.08.2022"
                                              },
                                              {
                                                "id": "oqyrs",
                                                "alias": "2022-2024",
                                                "text": "Zwischen 01.09.2022 und 31.08.2023"
                                              },
                                              {
                                                "id": "ve0tek",
                                                "alias": "2024-2026",
                                                "text": "Zwischen 01.09.2023 und 31.08.2025"
                                              },
                                              {
                                                "id": "im8h1",
                                                "alias": ">2026",
                                                "text": "Ab 01.09.2025"
                                              }
                                            ]
                                          },
                                          "required": true
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "qp1m7",
                                  "type": "Question",
                                  "alias": "Vertragsdatum",
                                  "text": "Wann hast du den Mietvertrag unterschrieben?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "08tnb",
                                        "alias": "<2015",
                                        "text": "Vor 01.06.2015"
                                      },
                                      {
                                        "id": "wejo0k",
                                        "alias": "2015-2016",
                                        "text": "Zwischen 01.06.2015 und 31.08.2016"
                                      },
                                      {
                                        "id": "7np1",
                                        "alias": "2016-2018",
                                        "text": "Zwischen 01.09.2016 und 31.08.2018"
                                      },
                                      {
                                        "id": "m2jo",
                                        "alias": "2018-2020",
                                        "text": "Zwischen 01.09.2018 und 31.08.2020"
                                      },
                                      {
                                        "id": "4obam",
                                        "alias": "2020-2022",
                                        "text": "Zwischen 01.09.2020 und 31.08.2022"
                                      },
                                      {
                                        "id": "oqyrs",
                                        "alias": "2022-2024",
                                        "text": "Zwischen 01.09.2022 und 31.08.2023"
                                      },
                                      {
                                        "id": "ve0tek",
                                        "alias": "2024-2026",
                                        "text": "Zwischen 01.09.2023 und 31.08.2025"
                                      },
                                      {
                                        "id": "im8h1",
                                        "alias": ">2026",
                                        "text": "Ab 01.09.2025"
                                      }
                                    ]
                                  },
                                  "required": true
                                }
                              ]
                            },
                            {
                              "id": "5naua",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "2sjvt",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "47j65l",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "08tnb"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "fh0n1",
                                      "alias": "Exit: Mietvertrag zu alt",
                                      "text": "",
                                      "type": "Exit"
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            },
                            {
                              "id": "ph0pdg",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "k1qwh",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "ws2qdl",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Wohnlage"
                                    },
                                    "negated": true,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "8ktp",
                                      "pi77s",
                                      "v4s5m"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "vslt1",
                                      "alias": "Exit: Keine Wohnlage gefunden",
                                      "text": "",
                                      "type": "Exit"
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    },
                    {
                      "id": "swbz3",
                      "type": "If",
                      "cases": [
                        {
                          "id": "zq5he",
                          "type": "IfCase",
                          "test": {
                            "id": "f3gzh",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Unterschrieben"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "or4h3j"
                            ]
                          },
                          "block": [
                            {
                              "id": "j27fb",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "fxig5",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "8gza6",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Mietart"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "jwmlg"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "9txveh",
                                      "type": "Question",
                                      "alias": "Nettokaltmiete",
                                      "text": "Wie hoch war die Nettokaltmiete bei Abschluss des Mietvertrages?",
                                      "info": "Wichtig: Die Nettokaltmiete  ist unterschiedlich zur \"normalen\" Kaltmiete. Sie beinhaltet keine Betriebskosten, wie z.B. Heizung oder Wasser. Du findest diesen Wert in deinem Mietvertrag.",
                                      "answer": {
                                        "type": "NumberAnswer"
                                      },
                                      "required": true
                                    }
                                  ]
                                },
                                {
                                  "id": "tixk8",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "7fpd6",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Mietart"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "8dx4p"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "xewaw",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "g9bc5f",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "76u6gf",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Neue Mietstaffel seit Vertragsabschluss"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "7hl5h"
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "bfllsl",
                                              "type": "Question",
                                              "alias": "Nettokaltmiete",
                                              "text": "Auf welchen Betrag ist die Nettokaltmiete mit der letzten Mietstaffel gestiegen?",
                                              "info": "Wichtig: Die Nettokaltmiete  ist unterschiedlich zur \"normalen\" Kaltmiete. Sie beinhaltet keine Betriebskosten, wie z.B. Heizung oder Wasser. Du findest diesen Wert in deinem Mietvertrag.",
                                              "answer": {
                                                "type": "NumberAnswer"
                                              },
                                              "required": true
                                            }
                                          ]
                                        }
                                      ],
                                      "alternate": [
                                        {
                                          "id": "6ng88h",
                                          "type": "Question",
                                          "alias": "Nettokaltmiete",
                                          "text": "Wie hoch war die Nettokaltmiete bei Abschluss des Mietvertrages?",
                                          "info": "Wichtig: Die Nettokaltmiete  ist unterschiedlich zur \"normalen\" Kaltmiete. Sie beinhaltet keine Betriebskosten, wie z.B. Heizung oder Wasser. Du findest diesen Wert in deinem Mietvertrag.",
                                          "answer": {
                                            "type": "NumberAnswer"
                                          },
                                          "required": true
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "ee4a3",
                                  "type": "Question",
                                  "alias": "Nettokaltmiete",
                                  "text": "Wie hoch war die Nettokaltmiete bei Abschluss des Mietvertrages?",
                                  "info": "Wichtig: Die Nettokaltmiete  ist unterschiedlich zur \"normalen\" Kaltmiete. Sie beinhaltet keine Betriebskosten, wie z.B. Heizung oder Wasser. Du findest diesen Wert in deinem Mietvertrag.",
                                  "answer": {
                                    "type": "NumberAnswer"
                                  },
                                  "required": true
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "ysmlo",
                          "type": "Question",
                          "alias": "Nettokaltmiete",
                          "text": "Wie hoch ist die vorgesehene Nettokaltmiete?",
                          "info": "Wichtig: Die Nettokaltmiete  ist unterschiedlich zur \"normalen\" Kaltmiete. Sie beinhaltet keine Betriebskosten, wie z.B. Heizung oder Wasser. Du findest diesen Wert in deinem Mietvertrag.",
                          "answer": {
                            "type": "NumberAnswer"
                          },
                          "required": true
                        }
                      ]
                    },
                    {
                      "id": "xtskl",
                      "type": "If",
                      "cases": [
                        {
                          "id": "xmxp2k",
                          "type": "IfCase",
                          "test": {
                            "id": "pvvwy",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Unterschrieben"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "or4h3j"
                            ]
                          },
                          "block": [
                            {
                              "id": "plqoi",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "lujjb",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "3h8mw",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Mietart"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "jwmlg"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "aofdh",
                                      "type": "Question",
                                      "alias": "Vorherige Mieterhöhung",
                                      "text": "Hat sich deine Miete seit Abschluss des Mietvertrages mindestens einmal erhöht?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "9pjj1",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "3vq3gh",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          }
                                        ]
                                      },
                                      "required": true
                                    },
                                    {
                                      "id": "mfape",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "td20z",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "0pffsg",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Vorherige Mieterhöhung"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "9pjj1"
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "afspbj",
                                              "type": "Question",
                                              "alias": "Vorherige Mieterhöhung Grund (Indexmiete)",
                                              "text": "Wie wurden die Mieterhöhung begründet?",
                                              "info": "Beachte: Falls die Miete mehrfach erhöht wurde, wähle alle angegebenen Gründe aus.",
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "b2t6n",
                                                    "alias": "Indexmiete",
                                                    "text": "Indexmiete, Verbraucherpreisindex oder VPI (§ 557b BGB)"
                                                  },
                                                  {
                                                    "id": "808h4",
                                                    "alias": "Modernisierung",
                                                    "text": "Modernisierung oder bauliche Maßnahmen (§ 559 BGB)"
                                                  },
                                                  {
                                                    "id": "1jbj5",
                                                    "alias": "Betriebskostenerhöhung",
                                                    "text": "Gestiegene Betriebskosten (§ 560 BGB)"
                                                  },
                                                  {
                                                    "id": "0jaa7",
                                                    "alias": "Freiwillig",
                                                    "text": "Freiwillige Mieterhöhung (§ 557 BGB)"
                                                  },
                                                  {
                                                    "id": "7oedm",
                                                    "alias": "Anderer Grund",
                                                    "text": "Andere Begründung"
                                                  }
                                                ]
                                              },
                                              "required": true
                                            },
                                            {
                                              "id": "8g6w6h",
                                              "type": "If",
                                              "cases": [
                                                {
                                                  "id": "d87xm",
                                                  "type": "IfCase",
                                                  "test": {
                                                    "id": "9rnw3",
                                                    "questionRef": {
                                                      "type": "AliasRef",
                                                      "value": "Vorherige Mieterhöhung Grund (Indexmiete)"
                                                    },
                                                    "negated": false,
                                                    "type": "AnswerMultiOptionComparison",
                                                    "operator": "is",
                                                    "comparands": [
                                                      "0jaa7"
                                                    ]
                                                  },
                                                  "block": [
                                                    {
                                                      "id": "jofrvi",
                                                      "alias": "Exit: Vorherige Mieterhöhung bei Indexmiete (Freiwillig)",
                                                      "text": "",
                                                      "type": "Exit"
                                                    }
                                                  ]
                                                },
                                                {
                                                  "id": "ifqvl",
                                                  "type": "IfCase",
                                                  "test": {
                                                    "id": "4h8q9j",
                                                    "questionRef": {
                                                      "type": "AliasRef",
                                                      "value": "Vorherige Mieterhöhung Grund (Indexmiete)"
                                                    },
                                                    "negated": false,
                                                    "type": "AnswerMultiOptionComparison",
                                                    "operator": "is",
                                                    "comparands": [
                                                      "7oedm"
                                                    ]
                                                  },
                                                  "block": [
                                                    {
                                                      "id": "b1mq1",
                                                      "alias": "Exit: Vorherige Mieterhöhung bei Indexmiete (Anderer Grund)",
                                                      "text": "",
                                                      "type": "Exit"
                                                    }
                                                  ]
                                                }
                                              ],
                                              "alternate": []
                                            }
                                          ]
                                        }
                                      ],
                                      "alternate": []
                                    }
                                  ]
                                },
                                {
                                  "id": "x88iy",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "kkfqy",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Mietart"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "8dx4p"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "wmmsv",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "y8093",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "ph6gq",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Neue Mietstaffel seit Vertragsabschluss"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "7hl5h"
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "e280m",
                                              "type": "Question",
                                              "alias": "Vorherige Mieterhöhung",
                                              "text": "Hat sich deine Miete seit Beginn der letzten Mietstaffel mindestens einmal erhöht?",
                                              "info": null,
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "9pjj1",
                                                    "alias": "Ja",
                                                    "text": "Ja"
                                                  },
                                                  {
                                                    "id": "3vq3gh",
                                                    "alias": "Nein",
                                                    "text": "Nein"
                                                  }
                                                ]
                                              },
                                              "required": true
                                            }
                                          ]
                                        }
                                      ],
                                      "alternate": [
                                        {
                                          "id": "bbkix",
                                          "type": "Question",
                                          "alias": "Vorherige Mieterhöhung",
                                          "text": "Hat sich deine Miete seit Abschluss des Mietvertrages mindestens einmal erhöht?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "9pjj1",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "3vq3gh",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              }
                                            ]
                                          },
                                          "required": true
                                        }
                                      ]
                                    },
                                    {
                                      "id": "s46vy",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "6g2uk",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "9mnx7",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Vorherige Mieterhöhung"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "9pjj1"
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "q3vzy",
                                              "type": "Question",
                                              "alias": "Vorherige Mieterhöhung Grund (Staffelmiete)",
                                              "text": "Wie wurden die Mieterhöhung begründet?",
                                              "info": "Beachte: Falls die Miete mehrfach erhöht wurde, wähle alle angegebenen Gründe an.",
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "808h4",
                                                    "alias": "Modernisierung",
                                                    "text": "Modernisierung oder bauliche Maßnahmen (§ 559 BGB)"
                                                  },
                                                  {
                                                    "id": "1jbj5",
                                                    "alias": "Betriebskostenerhöhung",
                                                    "text": "Gestiegene Betriebskosten (§ 560 BGB)"
                                                  },
                                                  {
                                                    "id": "qkdhx",
                                                    "alias": "Freiwillig",
                                                    "text": "Freiwillige Mieterhöhung (§ 557 BGB)"
                                                  },
                                                  {
                                                    "id": "7oedm",
                                                    "alias": "Anderer Grund",
                                                    "text": "Andere Begründung"
                                                  }
                                                ]
                                              },
                                              "required": true
                                            },
                                            {
                                              "id": "0flyn",
                                              "type": "If",
                                              "cases": [
                                                {
                                                  "id": "y3esv",
                                                  "type": "IfCase",
                                                  "test": {
                                                    "id": "qenby",
                                                    "questionRef": {
                                                      "type": "AliasRef",
                                                      "value": "Vorherige Mieterhöhung Grund (Staffelmiete)"
                                                    },
                                                    "negated": false,
                                                    "type": "AnswerMultiOptionComparison",
                                                    "operator": "is",
                                                    "comparands": [
                                                      "qkdhx"
                                                    ]
                                                  },
                                                  "block": [
                                                    {
                                                      "id": "0uznh",
                                                      "alias": "Exit: Vorherige Mieterhöhung bei Staffelmiete (Freiwillig)",
                                                      "text": "",
                                                      "type": "Exit"
                                                    }
                                                  ]
                                                },
                                                {
                                                  "id": "anrqeg",
                                                  "type": "IfCase",
                                                  "test": {
                                                    "id": "v0lpgg",
                                                    "questionRef": {
                                                      "type": "AliasRef",
                                                      "value": "Vorherige Mieterhöhung Grund (Staffelmiete)"
                                                    },
                                                    "negated": false,
                                                    "type": "AnswerOptionComparison",
                                                    "operator": "is",
                                                    "comparands": [
                                                      "7oedm"
                                                    ]
                                                  },
                                                  "block": [
                                                    {
                                                      "id": "elylr",
                                                      "alias": "Exit: Vorherige Mieterhöhung bei Staffelmiete (Anderer Grund)",
                                                      "text": "",
                                                      "type": "Exit"
                                                    }
                                                  ]
                                                }
                                              ],
                                              "alternate": []
                                            }
                                          ]
                                        }
                                      ],
                                      "alternate": []
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "xlvbb",
                                  "type": "Question",
                                  "alias": "Vorherige Mieterhöhung",
                                  "text": "Hat sich deine Miete seit Abschluss des Mietvertrages mindestens einmal erhöht?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "9pjj1",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "3vq3gh",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      }
                                    ]
                                  },
                                  "required": true
                                },
                                {
                                  "id": "jxj3r",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "9iiq7h",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "75b77",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Vorherige Mieterhöhung"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "9pjj1"
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "rfkj9",
                                          "type": "Question",
                                          "alias": "Vorherige Mieterhöhung Grund",
                                          "text": "Wie wurden die Mieterhöhungen begründet?",
                                          "info": "Beachte: Falls die Miete mehrfach erhöht wurde, wähle alle angegebenen Gründe an.",
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "a2giz",
                                                "alias": "Mietspiegel",
                                                "text": "Mietspiegel oder Vergleichsmieten (§ 558 BGB)"
                                              },
                                              {
                                                "id": "808h4",
                                                "alias": "Modernisierung",
                                                "text": "Modernisierung oder bauliche Maßnahmen (§ 559 BGB)"
                                              },
                                              {
                                                "id": "1jbj5",
                                                "alias": "Betriebskostenerhöhung",
                                                "text": "Gestiegene Betriebskosten (§ 560 BGB)"
                                              },
                                              {
                                                "id": "4bi9j",
                                                "alias": "Freiwillig",
                                                "text": "Freiwillige Mieterhöhung (§ 557 BGB)"
                                              },
                                              {
                                                "id": "7oedm",
                                                "alias": "Anderer Grund",
                                                "text": "Andere Begründung"
                                              }
                                            ]
                                          },
                                          "required": true
                                        },
                                        {
                                          "id": "xgpjs",
                                          "type": "If",
                                          "cases": [
                                            {
                                              "id": "2os37",
                                              "type": "IfCase",
                                              "test": {
                                                "id": "qhsdp",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Vorherige Mieterhöhung Grund"
                                                },
                                                "negated": false,
                                                "type": "AnswerMultiOptionComparison",
                                                "operator": "is",
                                                "comparands": [
                                                  "4bi9j"
                                                ]
                                              },
                                              "block": [
                                                {
                                                  "id": "lc8g3",
                                                  "alias": "Exit: Vorherige Mieterhöhung (Freiwillig)",
                                                  "text": "",
                                                  "type": "Exit"
                                                }
                                              ]
                                            },
                                            {
                                              "id": "pilcd",
                                              "type": "IfCase",
                                              "test": {
                                                "id": "gp6pvj",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Vorherige Mieterhöhung Grund"
                                                },
                                                "negated": false,
                                                "type": "AnswerMultiOptionComparison",
                                                "operator": "is",
                                                "comparands": [
                                                  "7oedm"
                                                ]
                                              },
                                              "block": [
                                                {
                                                  "id": "dfoox",
                                                  "alias": "Exit: Vorherige Mieterhöhung (Anderer Grund)",
                                                  "text": "",
                                                  "type": "Exit"
                                                }
                                              ]
                                            }
                                          ],
                                          "alternate": []
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                }
              ]
            }
          ],
          "alternate": [
            {
              "id": "ccn8",
              "type": "Group",
              "category": null,
              "alias": "Mieterhöhung",
              "block": [
                {
                  "id": "dzhcml",
                  "type": "Question",
                  "alias": "Datum Mieterhöhungsschreiben",
                  "text": "An welchem Datum hast du das Schreiben zur Mieterhöhung erhalten?",
                  "info": null,
                  "answer": {
                    "type": "DateAnswer"
                  },
                  "required": true
                },
                {
                  "id": "g4o2",
                  "type": "Question",
                  "alias": "Vertragsdatum",
                  "text": "",
                  "info": null,
                  "answer": {
                    "type": "ChoiceAnswer",
                    "options": [
                      {
                        "id": "08tnb",
                        "alias": "<2015",
                        "text": "Vor 01.06.2015"
                      },
                      {
                        "id": "wejo0k",
                        "alias": "2015-2016",
                        "text": "Zwischen 01.06.2015 und 31.08.2016"
                      },
                      {
                        "id": "7np1",
                        "alias": "2016-2018",
                        "text": "Zwischen 01.09.2016 und 31.08.2018"
                      },
                      {
                        "id": "m2jo",
                        "alias": "2018-2020",
                        "text": "Zwischen 01.09.2018 und 31.08.2020"
                      },
                      {
                        "id": "4obam",
                        "alias": "2020-2022",
                        "text": "Zwischen 01.09.2020 und 31.08.2022"
                      },
                      {
                        "id": "oqyrs",
                        "alias": "2022-2024",
                        "text": "Zwischen 01.09.2022 und 31.08.2023"
                      },
                      {
                        "id": "ve0tek",
                        "alias": "2024-2026",
                        "text": "Zwischen 01.09.2023 und 31.08.2025"
                      },
                      {
                        "id": "im8h1",
                        "alias": ">2026",
                        "text": "Ab 01.09.2025"
                      }
                    ]
                  },
                  "required": true
                },
                {
                  "id": "xiwyi",
                  "type": "If",
                  "cases": [
                    {
                      "id": "zrm1",
                      "type": "IfCase",
                      "test": {
                        "id": "bducw",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Wohnlage"
                        },
                        "negated": true,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "pi77s",
                          "8ktp",
                          "v4s5m"
                        ]
                      },
                      "block": [
                        {
                          "id": "apctg",
                          "alias": "Exit: Mietvertrag zu alt",
                          "text": "",
                          "type": "Exit"
                        }
                      ]
                    }
                  ],
                  "alternate": []
                },
                {
                  "id": "gbo6w",
                  "type": "Question",
                  "alias": "Mieterhöhung Grund",
                  "text": "Welcher Grund für die Mieterhöhung ist im Schreiben  angegeben?",
                  "info": "Beachte: Falls mehrere Gründe angegeben sind, überprüfe bitte jeden Grund einzeln.",
                  "answer": {
                    "type": "ChoiceAnswer",
                    "options": [
                      {
                        "id": "a2giz",
                        "alias": "Mietspiegel",
                        "text": "Mietspiegel oder Vergleichsmieten (§ 558 BGB)"
                      },
                      {
                        "id": "bkyug",
                        "alias": "Staffelmiete",
                        "text": "Staffelmiete (§ 557a BGB)"
                      },
                      {
                        "id": "k7vmz",
                        "alias": "Indexmiete",
                        "text": "Indexmiete, Verbraucherpreisindex oder VPI (§ 557b BGB)"
                      },
                      {
                        "id": "808h4",
                        "alias": "Modernisierung",
                        "text": "Modernisierung oder bauliche Maßnahmen (§ 559 BGB)"
                      },
                      {
                        "id": "1jbj5",
                        "alias": "Betriebskosten",
                        "text": "Gestiegene Betriebskosten (§ 560 BGB)"
                      },
                      {
                        "id": "0jaa7",
                        "alias": "Freiwillig",
                        "text": "Freiwillige Mieterhöhung (§ 557 BGB) oder keine Begründung"
                      },
                      {
                        "id": "7oedm",
                        "alias": "Anderer Grund",
                        "text": "Keine der Optionen"
                      }
                    ]
                  },
                  "required": true
                },
                {
                  "id": "p897el",
                  "type": "Question",
                  "alias": "Mieterhöhung zugestimmt",
                  "text": "Hast du der Mieterhöhung bereits zugestimmt?",
                  "info": "Beachte: Wenn du die neue geforderte Miete bereits drei Mal überwiesen hast, gilt dies rechtlich als Zustimmung.",
                  "answer": {
                    "type": "ChoiceAnswer",
                    "options": [
                      {
                        "id": "ggo2s",
                        "alias": "Ja",
                        "text": "Ja"
                      },
                      {
                        "id": "b8nwa",
                        "alias": "Nein",
                        "text": "Nein"
                      }
                    ]
                  },
                  "required": true
                },
                {
                  "id": "jp3gij",
                  "type": "If",
                  "cases": [
                    {
                      "id": "enkni",
                      "type": "IfCase",
                      "test": {
                        "id": "pbtgx",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Mieterhöhung zugestimmt"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "ggo2s"
                        ]
                      },
                      "block": [
                        {
                          "id": "3sh9c",
                          "alias": "Exit: Mieterhöhung zugestimmt",
                          "text": "",
                          "type": "Exit"
                        }
                      ]
                    }
                  ],
                  "alternate": []
                },
                {
                  "id": "6wrc9",
                  "type": "Question",
                  "alias": "Mietart",
                  "text": "Ist in deinem Mietvertrag eine Staffelmiete oder Indexmiete vereinbart?",
                  "info": "Du kannst diese Information in deinem Mietvertrag finden.",
                  "answer": {
                    "type": "ChoiceAnswer",
                    "options": [
                      {
                        "id": "8dx4p",
                        "alias": "Staffelmiete",
                        "text": "Staffelmiete"
                      },
                      {
                        "id": "jwmlg",
                        "alias": "Indexmiete",
                        "text": "Indexmiete"
                      },
                      {
                        "id": "h1ddm",
                        "alias": "Normal",
                        "text": "Keins von beiden"
                      }
                    ]
                  },
                  "required": true
                },
                {
                  "id": "stoxy",
                  "type": "If",
                  "cases": [
                    {
                      "id": "uxl3k",
                      "type": "IfCase",
                      "test": {
                        "id": "ffd0m",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Mietart"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "8dx4p"
                        ]
                      },
                      "block": [
                        {
                          "id": "m53kn",
                          "type": "Question",
                          "alias": "Staffelmietvertrag aktiv",
                          "text": "Befindest du dich aktuell noch in dem Zeitraum mit vereinbarten Mietstaffeln?",
                          "info": "Das ist der Fall, wenn im Mietvertrag noch mindestens eine weitere Mietstaffel in der Zukunft festgelegt ist.",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "ggo2s",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "b8nwa",
                                "alias": "Nein",
                                "text": "Nein"
                              }
                            ]
                          },
                          "required": true
                        }
                      ]
                    }
                  ],
                  "alternate": []
                },
                {
                  "id": "sokgp",
                  "type": "If",
                  "cases": [
                    {
                      "id": "dpott",
                      "type": "IfCase",
                      "test": {
                        "id": "7kgyii",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Mietart"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "jwmlg"
                        ]
                      },
                      "block": [
                        {
                          "id": "trqbx",
                          "type": "If",
                          "cases": [
                            {
                              "id": "m63za",
                              "type": "IfCase",
                              "test": {
                                "id": "5r13k",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "a2giz"
                                ]
                              },
                              "block": [
                                {
                                  "id": "gjsnwf",
                                  "alias": "Exit: Mieterhöhung wegen Mietspiegel bei Indexmiete",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            },
                            {
                              "id": "9zixg",
                              "type": "IfCase",
                              "test": {
                                "id": "tkf2j",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "k7vmz"
                                ]
                              },
                              "block": [
                                {
                                  "id": "08kxa",
                                  "type": "Question",
                                  "alias": "Mieterhöhung wegen  Indexmiete maximal bis zu Inflationsrate",
                                  "text": "Soll die Miete maximal um die angegebene Inflationsrate angehoben werden?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "md03a",
                                        "alias": "Ja",
                                        "text": "Ja, die Miete soll maximal um die Inflationsrate angehoben werden"
                                      },
                                      {
                                        "id": "o5fcc",
                                        "alias": "Nein",
                                        "text": "Nein, die Miete soll über die Inflationsrate hinaus angehoben werden"
                                      }
                                    ]
                                  },
                                  "required": true
                                },
                                {
                                  "id": "yc7cs",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "lrb9q",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "wxhf7",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Mieterhöhung wegen  Indexmiete maximal bis zu Inflationsrate"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "md03a"
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "l192g",
                                          "alias": "Exit: Mieterhöhung wegen Indexmiete rechtens",
                                          "text": "Wenn eine Indexmiete vereinbart ist, hat der Vermieter immer das Recht die Miete um die jeweilige Inflationsrate zu erhöhen. In diesem Falle kann man nur die Miethöhe zu Beginn des Vertrages überprüfen. Falls du dies noch nicht getan hast, gehe noch einmal zurück und wähle bei der ersten Frage \"Die Miethöhe zu Beginn des Mietvertrages.\" und gib als deine Miete an, was du zu Beginn des Mietverhältnisses ohne Betriebskosten gezahlt hast.",
                                          "type": "Exit"
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": [
                                    {
                                      "id": "fc7k3",
                                      "alias": "Exit: Mieterhöhung wegen Indexmiete über Inflationsrate hinaus",
                                      "text": "",
                                      "type": "Exit"
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "id": "wns4u",
                              "type": "IfCase",
                              "test": {
                                "id": "fh3m9",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "bkyug"
                                ]
                              },
                              "block": [
                                {
                                  "id": "ppuq2",
                                  "alias": "Exit: Staffelmieterhöhung bei Indexmiete",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            },
                            {
                              "id": "awh64",
                              "type": "IfCase",
                              "test": {
                                "id": "wy4sl",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "808h4"
                                ]
                              },
                              "block": [
                                {
                                  "id": "2c6f8",
                                  "alias": "Exit: Mieterhöhung wegen Modernisierung bei Indexmiete",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            },
                            {
                              "id": "ns1yt",
                              "type": "IfCase",
                              "test": {
                                "id": "df955",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "1jbj5"
                                ]
                              },
                              "block": [
                                {
                                  "id": "gvsv7",
                                  "alias": "Exit: Mieterhöhung wegen Betriebskosten bei Indexmiete",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            },
                            {
                              "id": "2qswq",
                              "type": "IfCase",
                              "test": {
                                "id": "aj7w4",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "0jaa7"
                                ]
                              },
                              "block": [
                                {
                                  "id": "o12ki",
                                  "alias": "Exit: Freiwillige Mieterhöhung bei Indexmiete",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            }
                          ],
                          "alternate": [
                            {
                              "id": "00ezm",
                              "alias": "Exit: Mieterhöhung andere Begründung bei Indexmiete",
                              "text": "",
                              "type": "Exit"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "6cadj",
                      "type": "IfCase",
                      "test": {
                        "id": "ymxq8",
                        "type": "LogicalOperation",
                        "operator": "and",
                        "negated": false,
                        "conditions": [
                          {
                            "id": "474z8",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Mietart"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "8dx4p"
                            ]
                          },
                          {
                            "id": "474z8",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Staffelmietvertrag aktiv"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "ggo2s"
                            ]
                          }
                        ]
                      },
                      "block": [
                        {
                          "id": "2dlwxk",
                          "type": "If",
                          "cases": [
                            {
                              "id": "2s8lk",
                              "type": "IfCase",
                              "test": {
                                "id": "ns6l3",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "a2giz"
                                ]
                              },
                              "block": [
                                {
                                  "id": "8f9a3",
                                  "alias": "Exit: Mieterhöhung wegen Mietspiegel bei Staffelmietvertrag",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            },
                            {
                              "id": "ntxyy",
                              "type": "IfCase",
                              "test": {
                                "id": "18ko9l",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "k7vmz"
                                ]
                              },
                              "block": [
                                {
                                  "id": "gyk28g",
                                  "alias": "Exit: Mieterhöhung wegen Indexmiete bei Staffelmietvertrag",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            },
                            {
                              "id": "sjcv3",
                              "type": "IfCase",
                              "test": {
                                "id": "vtkke",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "bkyug"
                                ]
                              },
                              "block": [
                                {
                                  "id": "09g2n",
                                  "type": "Question",
                                  "alias": "Mieterhöhung wegen  Staffelmiete maximal bis zu Staffel",
                                  "text": "Soll die Miete maximal um den Mietvertrag vereinbarten Vertrag angehoben werden?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "4jt6j",
                                        "alias": "Ja",
                                        "text": "Ja, die Miete soll maximal um den vereinbarten Betrag angehoben werden"
                                      },
                                      {
                                        "id": "o5b28",
                                        "alias": "Nein",
                                        "text": "Nein, die Miete soll über den vereinbarten Betrag hinaus angehoben werden"
                                      }
                                    ]
                                  },
                                  "required": true
                                },
                                {
                                  "id": "9ypn3",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "s1nx3",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "qeab8",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Mieterhöhung wegen  Staffelmiete maximal bis zu Staffel"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "4jt6j"
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "r9xfp",
                                          "alias": "Exit: Mieterhöhung wegen Staffelmiete rechtens",
                                          "text": "",
                                          "type": "Exit"
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": [
                                    {
                                      "id": "6f3phg",
                                      "alias": "Exit: Mieterhöhung wegen Staffelmiete über Staffel hinaus",
                                      "text": "",
                                      "type": "Exit"
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "id": "t4bvu",
                              "type": "IfCase",
                              "test": {
                                "id": "miabv",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "808h4"
                                ]
                              },
                              "block": [
                                {
                                  "id": "udu4l",
                                  "alias": "Exit: Mieterhöhung wegen Modernisierung bei Staffelmietvertrag",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            },
                            {
                              "id": "3s7ie",
                              "type": "IfCase",
                              "test": {
                                "id": "8oxrq",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "1jbj5"
                                ]
                              },
                              "block": [
                                {
                                  "id": "4l2g",
                                  "alias": "Exit: Mieterhöhung wegen Betriebskosten bei Staffelmietvertrag",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            },
                            {
                              "id": "o18nhj",
                              "type": "IfCase",
                              "test": {
                                "id": "poqzu",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung Grund"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "0jaa7"
                                ]
                              },
                              "block": [
                                {
                                  "id": "v2rh9",
                                  "alias": "Exit: Freiwillige Mieterhöhung bei Staffelmiete",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            }
                          ],
                          "alternate": [
                            {
                              "id": "ehvf",
                              "alias": "Exit: Mieterhöhung andere Begründung bei Staffelmiete",
                              "text": "",
                              "type": "Exit"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "alternate": [
                    {
                      "id": "zylzr",
                      "type": "If",
                      "cases": [
                        {
                          "id": "s8jc",
                          "type": "IfCase",
                          "test": {
                            "id": "sw2ks",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Mieterhöhung Grund"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "k7vmz"
                            ]
                          },
                          "block": [
                            {
                              "id": "7c1zn",
                              "alias": "Exit: TODO",
                              "text": "",
                              "type": "Exit"
                            }
                          ]
                        },
                        {
                          "id": "wx20d",
                          "type": "IfCase",
                          "test": {
                            "id": "21v4hg",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Mieterhöhung Grund"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "bkyug"
                            ]
                          },
                          "block": [
                            {
                              "id": "pbzfn",
                              "alias": "Exit: TODO",
                              "text": "",
                              "type": "Exit"
                            }
                          ]
                        },
                        {
                          "id": "bqfou",
                          "type": "IfCase",
                          "test": {
                            "id": "om9t2",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Mieterhöhung Grund"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "808h4"
                            ]
                          },
                          "block": [
                            {
                              "id": "9pxsr",
                              "alias": "Exit: Mieterhöhung wegen Modernisierung",
                              "text": "",
                              "type": "Exit"
                            }
                          ]
                        },
                        {
                          "id": "jqeqhg",
                          "type": "IfCase",
                          "test": {
                            "id": "k2aix",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Mieterhöhung Grund"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "1jbj5"
                            ]
                          },
                          "block": [
                            {
                              "id": "apzwj",
                              "alias": "Exit: Mieterhöhung wegen Betriebskosten",
                              "text": "",
                              "type": "Exit"
                            }
                          ]
                        },
                        {
                          "id": "0flrn",
                          "type": "IfCase",
                          "test": {
                            "id": "1safu",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Mieterhöhung Grund"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "0jaa7"
                            ]
                          },
                          "block": [
                            {
                              "id": "om8o5",
                              "alias": "Exit: Freiwillige Mieterhöhung",
                              "text": "",
                              "type": "Exit"
                            }
                          ]
                        },
                        {
                          "id": "27s6pi",
                          "type": "IfCase",
                          "test": {
                            "id": "f37iv",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Mieterhöhung Grund"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "7oedm"
                            ]
                          },
                          "block": [
                            {
                              "id": "8hdzy",
                              "alias": "Exit: Mieterhöhung andere Begründung",
                              "text": "",
                              "type": "Exit"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                },
                {
                  "id": "ez0nm",
                  "type": "Question",
                  "alias": "Nettokaltmiete",
                  "text": "Wie hoch ist die aktuelle Nettokaltmiete pro Monat?",
                  "info": "Wichtig: Die Nettokaltmiete ist etwas anderes als die \"normale\" Kaltmiete. Sie enthält keine Betriebskosten, wie z.B. Kosten für Heizung oder Wasser. Du findest den Betrag in deinem Mietvertrag.",
                  "answer": {
                    "type": "NumberAnswer"
                  },
                  "required": true
                },
                {
                  "id": "587d",
                  "type": "Question",
                  "alias": "Geforderte Nettokaltmiete",
                  "text": "Wie hoch ist die  Nettokaltmiete pro Monat, welche der Vermieter zukünftig fordert?",
                  "info": "Diese Information solltest du im Schreiben zur Mieterhöhung finden.",
                  "answer": {
                    "type": "NumberAnswer"
                  },
                  "required": true
                }
              ]
            },
            {
              "id": "x6ydr",
              "type": "Group",
              "category": "Page",
              "alias": "Kappungsgrenze und Sperrfristen",
              "block": [
                {
                  "id": "fnzn6",
                  "type": "Question",
                  "alias": "Kappungsgrenze durch aktuelle Mieterhöhung überschritten",
                  "text": "[Hidden Question]",
                  "info": null,
                  "answer": {
                    "type": "BooleanAnswer"
                  },
                  "required": true,
                  "note": ""
                },
                {
                  "id": "q4nlyh",
                  "type": "If",
                  "cases": [
                    {
                      "id": "cokbv",
                      "type": "IfCase",
                      "test": {
                        "id": "0s24g",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Kappungsgrenze durch aktuelle Mieterhöhung überschritten"
                        },
                        "negated": false,
                        "type": "AnswerBooleanComparison",
                        "operator": "is",
                        "value": true
                      },
                      "block": [
                        {
                          "id": "p3uir",
                          "alias": "Exit: Kappungsgrenze durch aktuelle Mieterhöhung überschritten",
                          "text": "",
                          "type": "Exit"
                        }
                      ]
                    }
                  ],
                  "alternate": []
                },
                {
                  "id": "knmz2k",
                  "type": "Question",
                  "alias": "Mieterhöhung in letzten 33 Monaten",
                  "text": "Hat der Vermieter seit dem $DATUM_MIETERHOEHUNG_MINUS_33_MONATE$ mindestens eine Mieterhöhung erfolgreich durchgesetzt?",
                  "info": null,
                  "answer": {
                    "type": "ChoiceAnswer",
                    "options": [
                      {
                        "id": "ggo2s",
                        "alias": "Ja",
                        "text": "Ja"
                      },
                      {
                        "id": "b8nwa",
                        "alias": "Nein",
                        "text": "Nein"
                      }
                    ]
                  },
                  "required": true
                },
                {
                  "id": "hu6h5",
                  "type": "If",
                  "cases": [
                    {
                      "id": "pnio6",
                      "type": "IfCase",
                      "test": {
                        "id": "i2o8h",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Mieterhöhung in letzten 33 Monaten"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "ggo2s"
                        ]
                      },
                      "block": [
                        {
                          "id": "aohxx",
                          "type": "Question",
                          "alias": "Kappungsgrenze überschritten",
                          "text": "Überschreiten die Mieterhöhungen seit dem $DATUM_MIETERHOEHUNG_MINUS_33_MONATE$ die gesetzliche Kappungsgrenze? ",
                          "info": "Dies ist der Fall, wenn die neue geforderte Nettokaltmiete mindestens 15% höher ist als die Nettokaltmiete am $DATUM_MIETERHOEHUNG_MINUS_33_MONATE$. Erhöhungen wegen Modernisierungen zählen nicht zur Kappungsgrenze und dürfen bei der Berechnung nicht mitgezählt werden.",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "ggo2s",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "b8nwa",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "whpa6",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": true
                        },
                        {
                          "id": "fvuje",
                          "type": "If",
                          "cases": [
                            {
                              "id": "x6g41k",
                              "type": "IfCase",
                              "test": {
                                "id": "hnpeni",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Kappungsgrenze überschritten"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "ggo2s"
                                ]
                              },
                              "block": [
                                {
                                  "id": "6o4f1",
                                  "alias": "Exit: Kappungsgrenze überschritten",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        }
                      ]
                    }
                  ],
                  "alternate": []
                }
              ]
            },
            {
              "id": "udq5",
              "type": "Group",
              "category": null,
              "alias": "Sperrfristen",
              "block": [
                {
                  "id": "h7ngdj",
                  "type": "If",
                  "cases": [
                    {
                      "id": "xglyn",
                      "type": "IfCase",
                      "test": {
                        "id": "p7e6g",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Mieterhöhung in letzten 33 Monaten"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "ggo2s"
                        ]
                      },
                      "block": [
                        {
                          "id": "28yusg",
                          "type": "Question",
                          "alias": "Mieterhöhung innerhalb der letzten 15 Monaten",
                          "text": "Gab es seit dem $DATUM_MIETERHOEHUNG_MINUS_15_MONATE$  bereits eine Mieterhöhung, die mit dem Mietspiegel, Vergleichsmieten oder § 558 BGB begründet wurde?",
                          "info": null,
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "ggo2s",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "b8nwa",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "whpa6",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false
                        },
                        {
                          "id": "pg576",
                          "type": "If",
                          "cases": [
                            {
                              "id": "6dtd9",
                              "type": "IfCase",
                              "test": {
                                "id": "fecq1",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Mieterhöhung innerhalb der letzten 15 Monaten"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "ggo2s"
                                ]
                              },
                              "block": [
                                {
                                  "id": "3moz9h",
                                  "alias": "Exit: Sperrfristen nicht eingehalten",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        }
                      ]
                    }
                  ],
                  "alternate": []
                }
              ]
            }
          ]
        },
        {
          "id": "op3kd",
          "type": "Question",
          "alias": "Qm",
          "text": "Wie groß ist die Wohnung in qm?",
          "info": "Diese Information findest du in deinem Mietvertrag. Du kannst du den Wert auch schätzen und später korrigieren.",
          "answer": {
            "type": "NumberAnswer"
          },
          "required": true
        },
        {
          "id": "twn6w",
          "type": "Question",
          "alias": "Dachgeschoss",
          "text": "Liegt deine Wohnung in einem nachträglich ausgebauten Dachgeschoss?",
          "info": null,
          "answer": {
            "type": "ChoiceAnswer",
            "options": [
              {
                "id": "uiajj",
                "alias": "",
                "text": "Ja"
              },
              {
                "id": "qzhja",
                "alias": "",
                "text": "Nein"
              },
              {
                "id": "8i22j",
                "alias": "Nicht sicher",
                "text": "Ich bin mir nicht sicher"
              }
            ]
          },
          "required": true
        },
        {
          "id": "d7pvvg",
          "type": "If",
          "cases": [
            {
              "id": "pkc7m",
              "type": "IfCase",
              "test": {
                "id": "k20quf",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Dachgeschoss"
                },
                "negated": false,
                "type": "AnswerOptionComparison",
                "operator": "is",
                "comparands": [
                  "uiajj"
                ]
              },
              "block": [
                {
                  "id": "2s3ou",
                  "type": "Question",
                  "alias": "Baujahr vor 1991",
                  "text": "Wann wurde das Dachgeschoss ausgebaut? ",
                  "info": "Das Baujahr des Hauses findest du in dem Energieausweis, welchen du bei Abschluss des Mietvertrages erhalten haben solltest. Alternativ kannst du das Baujahr auch schätzen und später korrigieren.",
                  "answer": {
                    "type": "ChoiceAnswer",
                    "options": [
                      {
                        "id": "var1rl",
                        "alias": "-1918",
                        "text": "Bis einschließlich 1918"
                      },
                      {
                        "id": "ameym",
                        "alias": "1919-1949",
                        "text": "1919-1949"
                      },
                      {
                        "id": "bsegni",
                        "alias": "1950-1964",
                        "text": "1950-1964"
                      },
                      {
                        "id": "gyz0y",
                        "alias": "1965-1972",
                        "text": "1965-1972"
                      },
                      {
                        "id": "adc2e",
                        "alias": "1973-1985",
                        "text": "1973-1985"
                      },
                      {
                        "id": "cjm4t",
                        "alias": "1986-1990",
                        "text": "1986-1990"
                      },
                      {
                        "id": "ig2go",
                        "alias": "1991-",
                        "text": "Ab einschließlich 1991"
                      }
                    ]
                  },
                  "required": true
                },
                {
                  "id": "maea4",
                  "type": "If",
                  "cases": [
                    {
                      "id": "stfen",
                      "type": "IfCase",
                      "test": {
                        "id": "k4qp8",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Baujahr vor 1991"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "ig2go"
                        ]
                      },
                      "block": [
                        {
                          "id": "kxpn1",
                          "type": "Question",
                          "alias": "Baujahr ab 1991",
                          "text": "In welchem Jahr wurde das Dachgeschoss ausgebaut.",
                          "info": null,
                          "answer": {
                            "type": "NumberAnswer"
                          },
                          "required": true
                        }
                      ]
                    }
                  ],
                  "alternate": []
                }
              ]
            }
          ],
          "alternate": [
            {
              "id": "ugy1hg",
              "type": "Question",
              "alias": "Baujahr vor 1991",
              "text": "Wann wurde das Haus, in dem sich deine Wohnung befindet, erbaut?",
              "info": "Das Baujahr des Hauses findest du in dem Energieausweis, welchen du bei Abschluss des Mietvertrages erhalten haben solltest. Alternativ kannst du das Baujahr auch schätzen und später korrigieren.",
              "answer": {
                "type": "ChoiceAnswer",
                "options": [
                  {
                    "id": "var1rl",
                    "alias": "-1918",
                    "text": "Bis einschließlich 1918"
                  },
                  {
                    "id": "ameym",
                    "alias": "1919-1949",
                    "text": "1919-1949"
                  },
                  {
                    "id": "bsegni",
                    "alias": "1950-1964",
                    "text": "1950-1964"
                  },
                  {
                    "id": "gyz0y",
                    "alias": "1965-1972",
                    "text": "1965-1972"
                  },
                  {
                    "id": "adc2e",
                    "alias": "1973-1985",
                    "text": "1973-1985"
                  },
                  {
                    "id": "cjm4t",
                    "alias": "1986-1990",
                    "text": "1986-1990"
                  },
                  {
                    "id": "ig2go",
                    "alias": "1991-",
                    "text": "Ab einschließlich 1991"
                  }
                ]
              },
              "required": true,
              "note": ""
            },
            {
              "id": "rvbx2",
              "type": "If",
              "cases": [
                {
                  "id": "2sqxxj",
                  "type": "IfCase",
                  "test": {
                    "id": "d540q",
                    "questionRef": {
                      "type": "AliasRef",
                      "value": "Baujahr vor 1991"
                    },
                    "negated": false,
                    "type": "AnswerOptionComparison",
                    "operator": "is",
                    "comparands": [
                      "ig2go"
                    ]
                  },
                  "block": [
                    {
                      "id": "pyb2z",
                      "type": "Question",
                      "alias": "Baujahr ab 1991",
                      "text": "In welchem Jahr wurde das Haus, in dem sich die Wohnung befindet, erbaut?",
                      "info": null,
                      "answer": {
                        "type": "NumberAnswer"
                      },
                      "required": true
                    }
                  ]
                }
              ],
              "alternate": []
            }
          ]
        },
        {
          "id": "drpbm",
          "type": "Question",
          "alias": "Baujahr",
          "text": "",
          "info": null,
          "answer": {
            "type": "NumberAnswer"
          },
          "required": false,
          "note": "Diese Frage wird nicht angezeigt"
        },
        {
          "id": "nejuz",
          "type": "If",
          "cases": [
            {
              "id": "j0vf3",
              "type": "IfCase",
              "test": {
                "id": "mc0ref",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Typ"
                },
                "negated": false,
                "type": "AnswerOptionComparison",
                "operator": "is",
                "comparands": [
                  "wb3w3"
                ]
              },
              "block": [
                {
                  "id": "26zie",
                  "type": "If",
                  "cases": [
                    {
                      "id": "xihob",
                      "type": "IfCase",
                      "test": {
                        "id": "llc80h",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Baujahr"
                        },
                        "negated": false,
                        "type": "AnswerNumberComparison",
                        "operator": "gt",
                        "comparands": [
                          {
                            "type": "NumberLiteral",
                            "value": 2014
                          }
                        ]
                      },
                      "block": [
                        {
                          "id": "8xdme",
                          "alias": "Exit: Neubauwohnung",
                          "text": "",
                          "type": "Exit"
                        }
                      ]
                    },
                    {
                      "id": "seaql",
                      "type": "IfCase",
                      "test": {
                        "id": "s4w6r",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Baujahr"
                        },
                        "negated": false,
                        "type": "AnswerNumberComparison",
                        "operator": "is",
                        "comparands": [
                          {
                            "type": "NumberLiteral",
                            "value": 2014
                          }
                        ]
                      },
                      "block": [
                        {
                          "id": "vwe93k",
                          "type": "If",
                          "cases": [
                            {
                              "id": "yermv",
                              "type": "IfCase",
                              "test": {
                                "id": "37vmr",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Dachgeschoss"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "uiajj"
                                ]
                              },
                              "block": [
                                {
                                  "id": "iu3bt",
                                  "type": "Question",
                                  "alias": "Baujahr vor 1.10.2014",
                                  "text": "Wurde das Dachgeschoss vor dem 01.10.2014 ausgebaut?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "q2aer",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "xx5lz",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "9wzd8",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": true
                                }
                              ]
                            }
                          ],
                          "alternate": [
                            {
                              "id": "oa8jh",
                              "type": "Question",
                              "alias": "Baujahr vor 1.10.2014",
                              "text": "Wurde das Haus, in dem sich die Wohnung befindet, vor dem 01.10.2014 erbaut?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "q2aer",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "xx5lz",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "9wzd8",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": true
                            }
                          ]
                        },
                        {
                          "id": "1upxp",
                          "type": "If",
                          "cases": [
                            {
                              "id": "552mk",
                              "type": "IfCase",
                              "test": {
                                "id": "8souu",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr vor 1.10.2014"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "xx5lz"
                                ]
                              },
                              "block": [
                                {
                                  "id": "wuhshh",
                                  "alias": "Exit: Neubauwohnung",
                                  "text": "",
                                  "type": "Exit"
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        }
                      ]
                    }
                  ],
                  "alternate": []
                }
              ]
            }
          ],
          "alternate": []
        },
        {
          "id": "nhn6k",
          "type": "If",
          "cases": [
            {
              "id": "drq0aj",
              "type": "IfCase",
              "test": {
                "id": "p93py",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Vertragsdatum"
                },
                "negated": false,
                "type": "AnswerOptionComparison",
                "operator": "is",
                "comparands": [
                  "wejo0k"
                ]
              },
              "block": [
                {
                  "id": "3wc2a",
                  "type": "If",
                  "cases": [
                    {
                      "id": "i9tpif",
                      "type": "IfCase",
                      "test": {
                        "id": "l4oh7",
                        "type": "LogicalOperation",
                        "operator": "or",
                        "negated": false,
                        "conditions": [
                          {
                            "id": "j9iar",
                            "type": "LogicalOperation",
                            "operator": "and",
                            "negated": false,
                            "conditions": [
                              {
                                "id": "9wld1",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "gte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 1973
                                  }
                                ]
                              },
                              {
                                "id": "qobz5",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 1990
                                  }
                                ]
                              },
                              {
                                "id": "afq81",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Ost"
                                },
                                "negated": false,
                                "type": "AnswerBooleanComparison",
                                "operator": "is",
                                "value": false
                              },
                              {
                                "id": "jy77v",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Qm"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lt",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 40
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "id": "cd7u4",
                            "type": "LogicalOperation",
                            "operator": "and",
                            "negated": false,
                            "conditions": [
                              {
                                "id": "ieeft",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "gte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 1991
                                  }
                                ]
                              },
                              {
                                "id": "d3m5u",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 2002
                                  }
                                ]
                              },
                              {
                                "id": "lcjvs",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Qm"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lt",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 40
                                  }
                                ]
                              },
                              {
                                "id": "ox6qd",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Wohnlage"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "8ktp",
                                  "pi77s"
                                ]
                              }
                            ]
                          },
                          {
                            "id": "bmdrr",
                            "type": "LogicalOperation",
                            "operator": "and",
                            "negated": false,
                            "conditions": [
                              {
                                "id": "zpmra",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "gte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 2003
                                  }
                                ]
                              },
                              {
                                "id": "0cocs",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 2013
                                  }
                                ]
                              },
                              {
                                "id": "jx5po",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Qm"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lt",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 40
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "id": "bky94",
                            "type": "LogicalOperation",
                            "operator": "and",
                            "negated": false,
                            "conditions": [
                              {
                                "id": "qwto6k",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "gte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 2003
                                  }
                                ]
                              },
                              {
                                "id": "xlqf4",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 2013
                                  }
                                ]
                              },
                              {
                                "id": "nj6k",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Qm"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "gte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 40
                                  }
                                ]
                              },
                              {
                                "id": "e44g",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Qm"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lt",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 60
                                  }
                                ]
                              },
                              {
                                "id": "b502s",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Wohnlage"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "8ktp"
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      "block": [
                        {
                          "id": "rrp6g",
                          "alias": "Exit: Mietspiegel Feld Leer",
                          "text": "",
                          "type": "Exit"
                        }
                      ]
                    }
                  ],
                  "alternate": []
                }
              ]
            },
            {
              "id": "g5xat",
              "type": "IfCase",
              "test": {
                "id": "dtp6i",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Vertragsdatum"
                },
                "negated": false,
                "type": "AnswerOptionComparison",
                "operator": "is",
                "comparands": [
                  "7np1"
                ]
              },
              "block": [
                {
                  "id": "i7kls",
                  "type": "If",
                  "cases": [
                    {
                      "id": "yli9u",
                      "type": "IfCase",
                      "test": {
                        "id": "07161",
                        "type": "LogicalOperation",
                        "operator": "or",
                        "negated": false,
                        "conditions": [
                          {
                            "id": "3t3zb",
                            "type": "LogicalOperation",
                            "operator": "and",
                            "negated": false,
                            "conditions": [
                              {
                                "id": "ob3z1",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "gte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 1991
                                  }
                                ]
                              },
                              {
                                "id": "dwssb",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 2002
                                  }
                                ]
                              },
                              {
                                "id": "1sdyk",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Qm"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lt",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 40
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "id": "yz1thl",
                            "type": "LogicalOperation",
                            "operator": "and",
                            "negated": false,
                            "conditions": [
                              {
                                "id": "d9cpdi",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "gte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 2003
                                  }
                                ]
                              },
                              {
                                "id": "8t0gr",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 2013
                                  }
                                ]
                              },
                              {
                                "id": "0vdnd",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Qm"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lt",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 40
                                  }
                                ]
                              },
                              {
                                "id": "15ep7i",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Wohnlage"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "v4s5m"
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      "block": [
                        {
                          "id": "piqre",
                          "alias": "Exit: Mietspiegel Feld Leer",
                          "text": "",
                          "type": "Exit"
                        }
                      ]
                    }
                  ],
                  "alternate": []
                }
              ]
            },
            {
              "id": "rsk7x",
              "type": "IfCase",
              "test": {
                "id": "buma6",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Vertragsdatum"
                },
                "negated": false,
                "type": "AnswerOptionComparison",
                "operator": "is",
                "comparands": [
                  "m2jo",
                  "4obam",
                  "oqyrs"
                ]
              },
              "block": [
                {
                  "id": "l1wqb",
                  "type": "If",
                  "cases": [
                    {
                      "id": "gcrvt",
                      "type": "IfCase",
                      "test": {
                        "id": "ctana",
                        "type": "LogicalOperation",
                        "operator": "or",
                        "negated": false,
                        "conditions": [
                          {
                            "id": "6pyio",
                            "type": "LogicalOperation",
                            "operator": "and",
                            "negated": false,
                            "conditions": [
                              {
                                "id": "ibmbn",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "gte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 1991
                                  }
                                ]
                              },
                              {
                                "id": "7psuz",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 2017
                                  }
                                ]
                              },
                              {
                                "id": "yqni1",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Qm"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lt",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 40
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "id": "v9a9y",
                            "type": "LogicalOperation",
                            "operator": "and",
                            "negated": false,
                            "conditions": [
                              {
                                "id": "jk6s2",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "gte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 1950
                                  }
                                ]
                              },
                              {
                                "id": "6k7uk",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 1964
                                  }
                                ]
                              },
                              {
                                "id": "2z7m",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Qm"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "gte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 90
                                  }
                                ]
                              },
                              {
                                "id": "wzyt3",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Wohnlage"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "8ktp"
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      "block": [
                        {
                          "id": "6o6x3",
                          "alias": "Exit: Mietspiegel Feld Leer",
                          "text": "",
                          "type": "Exit"
                        }
                      ]
                    }
                  ],
                  "alternate": []
                }
              ]
            }
          ],
          "alternate": []
        },
        {
          "id": "i2nl3",
          "type": "If",
          "cases": [
            {
              "id": "s4lja",
              "type": "IfCase",
              "test": {
                "id": "u9327",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Baujahr"
                },
                "negated": false,
                "type": "AnswerNumberComparison",
                "operator": "lte",
                "comparands": [
                  {
                    "type": "NumberLiteral",
                    "value": 1964
                  }
                ]
              },
              "block": [
                {
                  "id": "icpny",
                  "type": "Question",
                  "alias": "Wohnung hat Sammelheizung",
                  "text": "Hat die Wohnung eine Zentralheizung, Etagenheizung, oder Wohnungsheizung (Gas, Öl, Elektro)?",
                  "info": "Beachte: Dies trifft auf fast alle Wohnungen in Berlin zu.",
                  "answer": {
                    "type": "ChoiceAnswer",
                    "options": [
                      {
                        "id": "uiajj",
                        "alias": "Ja",
                        "text": "Ja"
                      },
                      {
                        "id": "qzhja",
                        "alias": "Nein",
                        "text": "Nein"
                      },
                      {
                        "id": "8i22j",
                        "alias": "Nicht sicher",
                        "text": "Ich bin mir nicht sicher"
                      }
                    ]
                  },
                  "required": true
                },
                {
                  "id": "hzqza",
                  "type": "Question",
                  "alias": "Badezimmer in Wohnung",
                  "text": "Hat die Wohnung ein Badezimmer?",
                  "info": "Beachte: Dies trifft auf fast alle Wohnungen in Berlin zu.",
                  "answer": {
                    "type": "ChoiceAnswer",
                    "options": [
                      {
                        "id": "uiajj",
                        "alias": "Ja",
                        "text": "Ja"
                      },
                      {
                        "id": "qzhja",
                        "alias": "Nein",
                        "text": "Nein"
                      },
                      {
                        "id": "8i22j",
                        "alias": "Nicht sicher",
                        "text": "Ich bin mir nicht sicher"
                      }
                    ]
                  },
                  "required": true
                }
              ]
            }
          ],
          "alternate": []
        },
        {
          "id": "8mage",
          "type": "Question",
          "alias": "Ausnahmen",
          "text": "Trifft eine dieser Aussagen auf die Wohnung zu?",
          "info": null,
          "answer": {
            "type": "ChoiceAnswer",
            "options": [
              {
                "id": "g7tps",
                "alias": "Sozialwohnung",
                "text": "Die Wohnung ist eine Sozialwohnung"
              },
              {
                "id": "3e0a4",
                "alias": "Reihenhaus",
                "text": "Die Wohnung liegt in einem Einfamilienhaus, Zweifamilienhaus oder Reihenhaus"
              },
              {
                "id": "jcjul",
                "alias": "Wohnung ohne WC ",
                "text": "Es gibt kein WC innerhalb der Wohnung "
              },
              {
                "id": "94gwk",
                "alias": "Möbliert",
                "text": "Die Wohnung wird möbliert vermietet"
              },
              {
                "id": "nl5be",
                "alias": "Keine",
                "text": "Keine der Aussagen trifft zu"
              }
            ]
          },
          "required": true
        },
        {
          "id": "yoc33",
          "type": "If",
          "cases": [
            {
              "id": "hzpedl",
              "type": "IfCase",
              "test": {
                "id": "x8vtj",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Ausnahmen"
                },
                "negated": false,
                "type": "AnswerOptionComparison",
                "operator": "is",
                "comparands": [
                  "g7tps"
                ]
              },
              "block": [
                {
                  "id": "86xo",
                  "type": "If",
                  "cases": [
                    {
                      "id": "2bmcp",
                      "type": "IfCase",
                      "test": {
                        "id": "twtco",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Typ"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "wb3w3"
                        ]
                      },
                      "block": [
                        {
                          "id": "z5pz1g",
                          "alias": "Exit: Sozialwohnung",
                          "text": "",
                          "type": "Exit"
                        }
                      ]
                    }
                  ],
                  "alternate": [
                    {
                      "id": "6g45o",
                      "alias": "Exit: Sozialwohnung bei Mieterhöhung [TODO]",
                      "text": "",
                      "type": "Exit"
                    }
                  ]
                }
              ]
            },
            {
              "id": "8xr6x",
              "type": "IfCase",
              "test": {
                "id": "1x4",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Ausnahmen"
                },
                "negated": false,
                "type": "AnswerOptionComparison",
                "operator": "is",
                "comparands": [
                  "3e0a4"
                ]
              },
              "block": [
                {
                  "id": "ytfq8",
                  "type": "If",
                  "cases": [
                    {
                      "id": "ka1s2h",
                      "type": "IfCase",
                      "test": {
                        "id": "hatho",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Typ"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "wb3w3"
                        ]
                      },
                      "block": [
                        {
                          "id": "a0enbl",
                          "alias": "Exit: Ein-/Zweifamilienhäuser oder Reihenhäuser",
                          "text": "",
                          "type": "Exit"
                        }
                      ]
                    }
                  ],
                  "alternate": [
                    {
                      "id": "98jmti",
                      "alias": "Exit: Ein-/Zweifamilienhäuser oder Reihenhäuser bei Mieterhöhung [TODO]",
                      "text": "",
                      "type": "Exit"
                    }
                  ]
                }
              ]
            },
            {
              "id": "6ge18i",
              "type": "IfCase",
              "test": {
                "id": "b07cs",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Ausnahmen"
                },
                "negated": false,
                "type": "AnswerOptionComparison",
                "operator": "is",
                "comparands": [
                  "jcjul"
                ]
              },
              "block": [
                {
                  "id": "sg3s5",
                  "type": "If",
                  "cases": [
                    {
                      "id": "lq2rn",
                      "type": "IfCase",
                      "test": {
                        "id": "z6fbm",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Typ"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "wb3w3"
                        ]
                      },
                      "block": [
                        {
                          "id": "4jl5a",
                          "alias": "Exit: Wohnung ohne WC",
                          "text": "",
                          "type": "Exit"
                        }
                      ]
                    }
                  ],
                  "alternate": [
                    {
                      "id": "xexdbl",
                      "alias": "Exit: Wohnung ohne WC bei Mieterhöhung [TODO]",
                      "text": "",
                      "type": "Exit"
                    }
                  ]
                }
              ]
            },
            {
              "id": "dh9dj",
              "type": "IfCase",
              "test": {
                "id": "zz6lk",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Ausnahmen"
                },
                "negated": false,
                "type": "AnswerOptionComparison",
                "operator": "is",
                "comparands": [
                  "94gwk"
                ]
              },
              "block": [
                {
                  "id": "xfyg1",
                  "alias": "Exit: Möblierte Wohnung",
                  "text": "",
                  "type": "Exit"
                }
              ]
            }
          ],
          "alternate": []
        },
        {
          "id": "y8fot",
          "alias": "Einschätzung",
          "text": "",
          "type": "Info",
          "title": ""
        }
      ]
    },
    {
      "id": "loro8f",
      "type": "Group",
      "category": "Section",
      "alias": "Details",
      "block": [
        {
          "id": "7zl9i",
          "type": "Group",
          "category": "Page",
          "alias": "Bisherige Angaben",
          "block": []
        },
        {
          "id": "ofbvt",
          "type": "If",
          "cases": [
            {
              "id": "x5kyd",
              "type": "IfCase",
              "test": {
                "id": "mcsut",
                "questionRef": {
                  "type": "AliasRef",
                  "value": "Typ"
                },
                "negated": false,
                "type": "AnswerOptionComparison",
                "operator": "is",
                "comparands": [
                  "wb3w3"
                ]
              },
              "block": [
                {
                  "id": "9ve5k",
                  "type": "Group",
                  "category": "Page",
                  "alias": "Mietvertrag",
                  "block": [
                    {
                      "id": "8c7r4",
                      "type": "Group",
                      "category": "Section",
                      "alias": "Vormiete",
                      "block": [
                        {
                          "id": "gm5dd",
                          "type": "Question",
                          "alias": "Vermieter hat über Vormiete informiert",
                          "text": "Hat die Vermieterin sich bei Abschluss des Mietvertrages darauf berufen, dass die Mietpreisbremse nicht gilt, weil die Vormieterin bereits eine höhere Miete gezahlt hat?",
                          "info": null,
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "y4lgh",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "o2xpn",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "gbreq",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false
                        },
                        {
                          "id": "bp4e7f",
                          "type": "If",
                          "cases": [
                            {
                              "id": "rnetgi",
                              "type": "IfCase",
                              "test": {
                                "id": "uwgna",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Vermieter hat über Vormiete informiert"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "y4lgh"
                                ]
                              },
                              "block": [
                                {
                                  "id": "akjqpk",
                                  "type": "Question",
                                  "alias": "Vermiete hat Vormiete mitgeteilt",
                                  "text": "Hat die Vermieterin dir mitgeteilt wie hoch die Miete der Vormieterin war?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "z988p",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "eof0v",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "dmi7j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false
                                },
                                {
                                  "id": "f4r5r",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "c6q02",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "vt1kdk",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Vermiete hat Vormiete mitgeteilt"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "z988p"
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "t1fpcj",
                                          "type": "Question",
                                          "alias": "Vermieter hat Vormiete schriftlich mitgeteilt",
                                          "text": "Wurde dir die Höhe der Miete schriftlich mitgeteilt? ",
                                          "info": "Dazu zählt Papier, Email, Fax, WhatsApp, SMS oder irgendeine nicht rein mündliche Mitteilung.",
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "nqrd8",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "kurhg",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "r6jkug",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false
                                        },
                                        {
                                          "id": "vu3zv",
                                          "type": "If",
                                          "cases": [
                                            {
                                              "id": "75n6p",
                                              "type": "IfCase",
                                              "test": {
                                                "id": "dxdmo",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Vermieter hat Vormiete schriftlich mitgeteilt"
                                                },
                                                "negated": false,
                                                "type": "AnswerOptionComparison",
                                                "operator": "is",
                                                "comparands": [
                                                  "nqrd8"
                                                ]
                                              },
                                              "block": [
                                                {
                                                  "id": "rfggi",
                                                  "type": "Question",
                                                  "alias": "Vormiete",
                                                  "text": "Wie hoch ist die von der Vermieterin genannte Nettokaltmiete der Vormieterin?",
                                                  "info": null,
                                                  "answer": {
                                                    "type": "NumberAnswer"
                                                  },
                                                  "required": false
                                                }
                                              ]
                                            }
                                          ],
                                          "alternate": []
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        },
                        {
                          "id": "xxqgz",
                          "type": "If",
                          "cases": [
                            {
                              "id": "gx6hd",
                              "type": "IfCase",
                              "test": {
                                "id": "7khky",
                                "type": "LogicalOperation",
                                "operator": "or",
                                "negated": false,
                                "conditions": [
                                  {
                                    "id": "x897i",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vermieter hat über Vormiete informiert"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "gbreq"
                                    ]
                                  },
                                  {
                                    "id": "x897i",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vermiete hat Vormiete mitgeteilt"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "dmi7j",
                                      "eof0v"
                                    ]
                                  },
                                  {
                                    "id": "x897i",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vermieter hat Vormiete schriftlich mitgeteilt"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "r6jkug",
                                      "kurhg"
                                    ]
                                  }
                                ]
                              },
                              "block": [
                                {
                                  "id": "lxroz",
                                  "alias": "Wichtig: Vermieterinnen haben unter Umständen das Recht eine höhere Miete zu fordern, wenn die Vormieterin bereits eine höhere Miete gezahlt hat. Wir empfehlen nochmal zu überprüfen, ob die Vermieterin bei Vertragsabschluss über die Vormiete schriftlich informiert hat und dies nochmal bei einem Beratungstermin mit einer Mietrechtsexpertin anzusprechen.",
                                  "text": "",
                                  "type": "Info",
                                  "title": ""
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        }
                      ]
                    },
                    {
                      "id": "mgvv3",
                      "type": "Group",
                      "category": "Section",
                      "alias": "Erste Vermietung nach umfassender Renovierung",
                      "block": [
                        {
                          "id": "zs324",
                          "type": "Question",
                          "alias": "Vermieter hat über umfassende Sanierung informiert",
                          "text": "Hat die Vermieterin sich bei Abschluss des Mietvertrages darauf berufen, dass es sich um die erstmalige Vermietung nach umfassender Renovierung handelt?",
                          "info": null,
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "ck16",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "m5uh5",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "ha0h5",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false
                        },
                        {
                          "id": "397c6",
                          "type": "If",
                          "cases": [
                            {
                              "id": "oxcowf",
                              "type": "IfCase",
                              "test": {
                                "id": "u4y59",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Vermieter hat über umfassende Sanierung informiert"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "ck16"
                                ]
                              },
                              "block": [
                                {
                                  "id": "mjqd6l",
                                  "type": "Question",
                                  "alias": "Vermieter hat Renovierungskosten mitgeteilt",
                                  "text": "Hat die Vermieterin dir Auskunft über die Höhe der Renovierungskosten gegeben?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "movbgk",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "arjqc",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "usg3ll",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false
                                },
                                {
                                  "id": "oqwe9",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "sna3hk",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "i5a0z",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Vermieter hat Renovierungskosten mitgeteilt"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "movbgk"
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "x25e8",
                                          "type": "Question",
                                          "alias": "Vermieter hat Renovierungskosten schriftlich mitgeteilt",
                                          "text": "Wurde dir die Höhe der Renovierungskosten schriftlich mitgeteilt?",
                                          "info": "Dazu zählt Papier, Email, Fax, WhatsApp, SMS oder irgendeine nicht rein mündliche Mitteilung.",
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "fc5zw",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "wgq0r",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "4nz88",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false
                                        },
                                        {
                                          "id": "53vve",
                                          "type": "If",
                                          "cases": [
                                            {
                                              "id": "k086b",
                                              "type": "IfCase",
                                              "test": {
                                                "id": "xyflq",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Vermieter hat Renovierungskosten schriftlich mitgeteilt"
                                                },
                                                "negated": false,
                                                "type": "AnswerOptionComparison",
                                                "operator": "is",
                                                "comparands": [
                                                  "fc5zw"
                                                ]
                                              },
                                              "block": [
                                                {
                                                  "id": "o83ks",
                                                  "type": "Question",
                                                  "alias": "Renovierungskosten ein Drittel des Neubaupreises",
                                                  "text": "Waren die Renovierungskosten mindestens ein Drittel des Neubaupreis?",
                                                  "info": "Den genauen Neubaupreis kann man als Mieter*in meist nur schätzen. Du kannst dafür etwa 800€ pro Quadratmeter veranschlagen.",
                                                  "answer": {
                                                    "type": "ChoiceAnswer",
                                                    "options": [
                                                      {
                                                        "id": "v0z7s",
                                                        "alias": "Ja",
                                                        "text": "Ja"
                                                      },
                                                      {
                                                        "id": "gid5s",
                                                        "alias": "Nein",
                                                        "text": "Nein"
                                                      },
                                                      {
                                                        "id": "8n7lz",
                                                        "alias": "Nicht sicher",
                                                        "text": "Ich bin mir nicht sicher"
                                                      }
                                                    ]
                                                  },
                                                  "required": false
                                                },
                                                {
                                                  "id": "srrya",
                                                  "type": "If",
                                                  "cases": [
                                                    {
                                                      "id": "wmahkh",
                                                      "type": "IfCase",
                                                      "test": {
                                                        "id": "2ov9e",
                                                        "questionRef": {
                                                          "type": "AliasRef",
                                                          "value": "Renovierungskosten ein Drittel des Neubaupreises"
                                                        },
                                                        "negated": false,
                                                        "type": "AnswerOptionComparison",
                                                        "operator": "is",
                                                        "comparands": [
                                                          "v0z7s"
                                                        ]
                                                      },
                                                      "block": [
                                                        {
                                                          "id": "4ofs3",
                                                          "alias": "Die Regelungen der Mietpreisbremse gelten nicht für Wohnungen, die nach einer umfassenden Modernisierung erstmals vermietet werden. Dies könnte bei dir unter Umständen der Fall sein. Wir empfehlen dir, den Fragebogen weiter auszufüllen und dieses Thema mit einer Mietrechtsexpertin zu besprechen.",
                                                          "text": "",
                                                          "type": "Info",
                                                          "title": ""
                                                        }
                                                      ]
                                                    }
                                                  ],
                                                  "alternate": []
                                                }
                                              ]
                                            }
                                          ],
                                          "alternate": []
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                }
                              ]
                            },
                            {
                              "id": "4bzg1",
                              "type": "IfCase",
                              "test": {
                                "id": "uswa6",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Vermieter hat über umfassende Sanierung informiert"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "ha0h5"
                                ]
                              },
                              "block": [
                                {
                                  "id": "kt54d",
                                  "alias": "Die Regelungen der Mietpreisbremse gelten nicht für Wohnungen, die nach einer umfassenden Modernisierung erstmals vermietet werden. Wir empfehlen dir, diese Information nochmal nachzugucken und das Thema gegebenenfalls mit einer Mietrechtsexpertin zu besprechen.",
                                  "text": "",
                                  "type": "Info",
                                  "title": ""
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        },
                        {
                          "id": "cdxlr",
                          "type": "If",
                          "cases": [
                            {
                              "id": "3gjnvi",
                              "type": "IfCase",
                              "test": {
                                "id": "3por4",
                                "type": "LogicalOperation",
                                "operator": "or",
                                "negated": false,
                                "conditions": [
                                  {
                                    "id": "qm01m",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vermieter hat Renovierungskosten mitgeteilt"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "arjqc",
                                      "usg3ll"
                                    ]
                                  },
                                  {
                                    "id": "qm01m",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vermieter hat Renovierungskosten schriftlich mitgeteilt"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wgq0r",
                                      "4nz88"
                                    ]
                                  },
                                  {
                                    "id": "qm01m",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Renovierungskosten ein Drittel des Neubaupreises"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "gid5s",
                                      "8n7lz"
                                    ]
                                  }
                                ]
                              },
                              "block": [
                                {
                                  "id": "rpavt",
                                  "alias": "Die Regelungen der Mietpreisbremse gelten nicht für Wohnungen, die nach einer umfassenden Modernisierung erstmals vermietet werden. Selbst wenn die Vermieterin dies behauptet, muss dies aber nicht unbedingt stimmen. Wir empfehlen dir, den Fragebogen weiter auszufüllen und dieses Thema mit einer Mietrechtsexpertin zu besprechen.",
                                  "text": "",
                                  "type": "Info",
                                  "title": ""
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "alternate": []
        },
        {
          "id": "70mmi",
          "type": "Group",
          "category": "Page",
          "alias": "Merkmalsgruppen",
          "block": [
            {
              "id": "wb48s",
              "type": "If",
              "cases": [
                {
                  "id": "2mtvk",
                  "type": "IfCase",
                  "test": {
                    "id": "c0u7z",
                    "type": "LogicalOperation",
                    "operator": "and",
                    "negated": false,
                    "conditions": [
                      {
                        "id": "orac9i",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Vertragsdatum"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "wejo0k"
                        ]
                      },
                      {
                        "id": "orac9i",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Baujahr"
                        },
                        "negated": false,
                        "type": "AnswerNumberComparison",
                        "operator": "lt",
                        "comparands": [
                          {
                            "type": "NumberLiteral",
                            "value": 2003
                          }
                        ]
                      }
                    ]
                  },
                  "block": [
                    {
                      "id": "jgemg",
                      "type": "Group",
                      "category": "Page",
                      "alias": "Sondermerkmale",
                      "block": [
                        {
                          "id": "yfch2",
                          "type": "Group",
                          "category": "Section",
                          "alias": "Badezimmer",
                          "block": [
                            {
                              "id": "qmgjz",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "bcted",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "t4ral",
                                    "type": "LogicalOperation",
                                    "operator": "and",
                                    "negated": false,
                                    "conditions": [
                                      {
                                        "id": "aqvvf",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "gte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 1991
                                          }
                                        ]
                                      },
                                      {
                                        "id": "aqvvf",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 2002
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "beiwa",
                                      "type": "Question",
                                      "alias": "Sondermerkmal Badezimmer mindestens 4qm",
                                      "text": "Gibt es ein Badezimmer mit mindestens 4 m² Grundfläche?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            },
                            {
                              "id": "4suun",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "7vvxz",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "9kp8u",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Baujahr"
                                    },
                                    "negated": false,
                                    "type": "AnswerNumberComparison",
                                    "operator": "lte",
                                    "comparands": [
                                      {
                                        "type": "NumberLiteral",
                                        "value": 1918
                                      }
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "oli8a",
                                      "type": "Question",
                                      "alias": "Sondermerkmal Dusche Und Badewanne",
                                      "text": "Gibt es in der Wohnung eine Dusche sowie eine Badewanne?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            },
                            {
                              "id": "hdcdy",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "m4ck",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "l324n",
                                    "type": "LogicalOperation",
                                    "operator": "or",
                                    "negated": false,
                                    "conditions": [
                                      {
                                        "id": "n4oe7h",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 1972
                                          }
                                        ]
                                      },
                                      {
                                        "id": "92fig",
                                        "type": "LogicalOperation",
                                        "operator": "and",
                                        "negated": false,
                                        "conditions": [
                                          {
                                            "id": "n4oe7h",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "gte",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 1973
                                              }
                                            ]
                                          },
                                          {
                                            "id": "n4oe7h",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "lte",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 1990
                                              }
                                            ]
                                          },
                                          {
                                            "id": "n4oe7h",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Ost"
                                            },
                                            "negated": false,
                                            "type": "AnswerBooleanComparison",
                                            "operator": "is",
                                            "value": true
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "frmz3",
                                      "type": "Question",
                                      "alias": "Sondermerkmal Modernes Bad",
                                      "text": "Sind die Badezimmer modern ausgestattet?",
                                      "info": "Ein Badezimmer gilt als modern ausgestattet, wenn die Wände neben Waschbecken, Badewanne und Dusche gefliest sind. Bodenfliesen, Einhebelmischbatterie, Strukturheizkörper als Handtuchwärmer und Badewanne oder Dusche vorhanden sind.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            }
                          ]
                        },
                        {
                          "id": "91438",
                          "type": "If",
                          "cases": [
                            {
                              "id": "1nz38",
                              "type": "IfCase",
                              "test": {
                                "id": "88r4f",
                                "type": "LogicalOperation",
                                "operator": "or",
                                "negated": false,
                                "conditions": [
                                  {
                                    "id": "u7inpl",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Baujahr"
                                    },
                                    "negated": false,
                                    "type": "AnswerNumberComparison",
                                    "operator": "lte",
                                    "comparands": [
                                      {
                                        "type": "NumberLiteral",
                                        "value": 1918
                                      }
                                    ]
                                  },
                                  {
                                    "id": "sw4y9",
                                    "type": "LogicalOperation",
                                    "operator": "and",
                                    "negated": false,
                                    "conditions": [
                                      {
                                        "id": "u7inpl",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "gte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 1950
                                          }
                                        ]
                                      },
                                      {
                                        "id": "u7inpl",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 1972
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "id": "sw4y9",
                                    "type": "LogicalOperation",
                                    "operator": "and",
                                    "negated": false,
                                    "conditions": [
                                      {
                                        "id": "u7inpl",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "gte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 1973
                                          }
                                        ]
                                      },
                                      {
                                        "id": "u7inpl",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 1990
                                          }
                                        ]
                                      },
                                      {
                                        "id": "u7inpl",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Ost"
                                        },
                                        "negated": false,
                                        "type": "AnswerBooleanComparison",
                                        "operator": "is",
                                        "value": false
                                      }
                                    ]
                                  },
                                  {
                                    "id": "sw4y9",
                                    "type": "LogicalOperation",
                                    "operator": "and",
                                    "negated": false,
                                    "conditions": [
                                      {
                                        "id": "u7inpl",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "gte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 1991
                                          }
                                        ]
                                      },
                                      {
                                        "id": "u7inpl",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 2002
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              "block": [
                                {
                                  "id": "r7e8b",
                                  "type": "Group",
                                  "category": "Section",
                                  "alias": "Küche",
                                  "block": [
                                    {
                                      "id": "480g6",
                                      "type": "Question",
                                      "alias": "Sondermerkmal Moderne Küche",
                                      "text": "Ist die Küche modern ausgestattet?",
                                      "info": "Dafür sind notwendig: Küchenschränke, Einbauspüle, Dunstabzugshaube, Herd mit Ceran- oder Induktionskochfeld, Backofen, Wandfliesen im Arbeitsbereich, Kühlschrank.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false
                                    }
                                  ]
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        },
                        {
                          "id": "ns86c",
                          "type": "If",
                          "cases": [
                            {
                              "id": "qo526",
                              "type": "IfCase",
                              "test": {
                                "id": "np6d6g",
                                "type": "LogicalOperation",
                                "operator": "and",
                                "negated": false,
                                "conditions": [
                                  {
                                    "id": "hq2w7",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Baujahr"
                                    },
                                    "negated": false,
                                    "type": "AnswerNumberComparison",
                                    "operator": "gte",
                                    "comparands": [
                                      {
                                        "type": "NumberLiteral",
                                        "value": 1965
                                      }
                                    ]
                                  },
                                  {
                                    "id": "hq2w7",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Baujahr"
                                    },
                                    "negated": false,
                                    "type": "AnswerNumberComparison",
                                    "operator": "lte",
                                    "comparands": [
                                      {
                                        "type": "NumberLiteral",
                                        "value": 1972
                                      }
                                    ]
                                  }
                                ]
                              },
                              "block": []
                            }
                          ],
                          "alternate": [
                            {
                              "id": "k0u05k",
                              "type": "Group",
                              "category": "Section",
                              "alias": "Allgemein",
                              "block": [
                                {
                                  "id": "11hvhf",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "88t61",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "29seb",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 1918
                                          }
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "d4lcxl",
                                          "type": "Question",
                                          "alias": "Sondermerkmal Schallschutzfenster",
                                          "text": "Sind in der Wohnung überwiegend Schallschutzfenster oder Isolierverglasung (Einbau ab 1987) eingebaut?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false
                                        },
                                        {
                                          "id": "r5p33",
                                          "type": "Question",
                                          "alias": "Sondermerkmal Aufzug",
                                          "text": "Gibt es im Haus einen Aufzug?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                },
                                {
                                  "id": "83d6t",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "w3wxt",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "oe75t",
                                        "type": "LogicalOperation",
                                        "operator": "or",
                                        "negated": false,
                                        "conditions": [
                                          {
                                            "id": "v36o1",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "lte",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 1964
                                              }
                                            ]
                                          },
                                          {
                                            "id": "afkq9",
                                            "type": "LogicalOperation",
                                            "operator": "and",
                                            "negated": false,
                                            "conditions": [
                                              {
                                                "id": "v36o1",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Baujahr"
                                                },
                                                "negated": false,
                                                "type": "AnswerNumberComparison",
                                                "operator": "gte",
                                                "comparands": [
                                                  {
                                                    "type": "NumberLiteral",
                                                    "value": 1973
                                                  }
                                                ]
                                              },
                                              {
                                                "id": "v36o1",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Baujahr"
                                                },
                                                "negated": false,
                                                "type": "AnswerNumberComparison",
                                                "operator": "lte",
                                                "comparands": [
                                                  {
                                                    "type": "NumberLiteral",
                                                    "value": 1990
                                                  }
                                                ]
                                              },
                                              {
                                                "id": "v36o1",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Ost"
                                                },
                                                "negated": false,
                                                "type": "AnswerBooleanComparison",
                                                "operator": "is",
                                                "value": false
                                              }
                                            ]
                                          },
                                          {
                                            "id": "afkq9",
                                            "type": "LogicalOperation",
                                            "operator": "and",
                                            "negated": false,
                                            "conditions": [
                                              {
                                                "id": "v36o1",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Baujahr"
                                                },
                                                "negated": false,
                                                "type": "AnswerNumberComparison",
                                                "operator": "gte",
                                                "comparands": [
                                                  {
                                                    "type": "NumberLiteral",
                                                    "value": 1991
                                                  }
                                                ]
                                              },
                                              {
                                                "id": "v36o1",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Baujahr"
                                                },
                                                "negated": false,
                                                "type": "AnswerNumberComparison",
                                                "operator": "lte",
                                                "comparands": [
                                                  {
                                                    "type": "NumberLiteral",
                                                    "value": 2002
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "2d8pc",
                                          "type": "Question",
                                          "alias": "Sondermerkmal Bodenbelag",
                                          "text": "Ist in der Mehrheit der Wohnräume einen hochwertiger Bodenbelag verlegt?",
                                          "info": "Hierzu zählt z.B. hochwertiges Parkett, Natur-/Kunststein, Fliesen oder gleichwertiger Bodenbelag",
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ],
              "alternate": []
            },
            {
              "id": "kp858",
              "type": "Group",
              "category": "Page",
              "alias": "Bad & WC",
              "block": [
                {
                  "id": "nrsqz",
                  "type": "If",
                  "cases": [
                    {
                      "id": "tqfuq",
                      "type": "IfCase",
                      "test": {
                        "id": "sfm2v",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Badezimmer in Wohnung"
                        },
                        "negated": true,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "qzhja"
                        ]
                      },
                      "block": [
                        {
                          "id": "27bgf",
                          "type": "Group",
                          "category": "Section",
                          "alias": "Allgemein",
                          "block": [
                            {
                              "id": "ll5uyj",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "pi81n",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "2k1cjl",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "5hoc7",
                                      "type": "If",
                                      "note": "Die Frage \"Badezimmer klein\" soll nur gestellt werden, wenn das Sondermerkmal \"Kleines Bad\" nicht erfüllt ist. \n\nDas Sondermerkmal \"Kleines Bad\" ist nur für das Baujahr \"1991-2002\" relevant.\n\nDa Sondermerkmal und Frage exakt gleich sind, muss die Frage hier nicht wiederholt werden, wenn sie schonmal gefragt wurde:\n- Wenn das Sondermerkmal erfüllt ist, fällt diese Frage raus\n- Wenn das Sondermerkmal nicht erfüllt ist, dann wäre die Antwort auf diese Frage sowieso ebenfalls \"Nein\"\n",
                                      "cases": [
                                        {
                                          "id": "kjzm8l",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "0wbce",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Sondermerkmal Badezimmer mindestens 4qm"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "qzhja"
                                            ]
                                          },
                                          "block": []
                                        }
                                      ],
                                      "alternate": [
                                        {
                                          "id": "uyizu",
                                          "type": "Question",
                                          "alias": "Bad mindestens 4qm",
                                          "text": "Gibt es ein Badezimmer mit mindestens 4 m² Grundfläche?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nNur wenn Sondermerkmal „kleines Bad (kleiner als 4 m2)“ nicht zutrifft: Kleines Bad (kleiner als 4 m2) [--]\n\nMerkmal >=2017:\nKleines Bad (kleiner als 4 m2); gilt nicht in der Baualtersklasse 1973 bis 1990 Ost [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher\n"
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "oszle",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "hl46h",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "lkvw0g",
                                        "type": "LogicalOperation",
                                        "operator": "and",
                                        "negated": false,
                                        "conditions": [
                                          {
                                            "id": "1tanj",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Ost"
                                            },
                                            "negated": false,
                                            "type": "AnswerBooleanComparison",
                                            "operator": "is",
                                            "value": true
                                          },
                                          {
                                            "id": "1tanj",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "gte",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 1973
                                              }
                                            ]
                                          },
                                          {
                                            "id": "1tanj",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "lte",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 1990
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      "block": []
                                    }
                                  ],
                                  "alternate": [
                                    {
                                      "id": "jxswc",
                                      "type": "Question",
                                      "alias": "Bad mindestens 4qm",
                                      "text": "Gibt es ein Badezimmer mit mindestens 4 m² Grundfläche?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nNur wenn Sondermerkmal „kleines Bad (kleiner als 4 m2)“ nicht zutrifft: Kleines Bad (kleiner als 4 m2) [--]\n\nMerkmal >=2017:\nKleines Bad (kleiner als 4 m2); gilt nicht in der Baualtersklasse 1973 bis 1990 Ost [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher\n"
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "id": "bzsmu",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "yc1a3",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "9b8zy",
                                    "type": "LogicalOperation",
                                    "operator": "or",
                                    "negated": false,
                                    "conditions": [
                                      {
                                        "id": "oxt1s",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Bad mindestens 4qm"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "8i22j",
                                          "uiajj"
                                        ]
                                      },
                                      {
                                        "id": "0u2wm",
                                        "type": "LogicalOperation",
                                        "operator": "and",
                                        "negated": false,
                                        "conditions": [
                                          {
                                            "id": "yvv9u",
                                            "type": "LogicalOperation",
                                            "operator": "and",
                                            "negated": false,
                                            "conditions": [
                                              {
                                                "id": "oxt1s",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Vertragsdatum"
                                                },
                                                "negated": true,
                                                "type": "AnswerOptionComparison",
                                                "operator": "is",
                                                "comparands": [
                                                  "wejo0k"
                                                ]
                                              },
                                              {
                                                "id": "oxt1s",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Ost"
                                                },
                                                "negated": false,
                                                "type": "AnswerBooleanComparison",
                                                "operator": "is",
                                                "value": true
                                              }
                                            ]
                                          },
                                          {
                                            "id": "yvv9u",
                                            "type": "LogicalOperation",
                                            "operator": "and",
                                            "negated": false,
                                            "conditions": [
                                              {
                                                "id": "oxt1s",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Baujahr"
                                                },
                                                "negated": false,
                                                "type": "AnswerNumberComparison",
                                                "operator": "gte",
                                                "comparands": [
                                                  {
                                                    "type": "NumberLiteral",
                                                    "value": 1973
                                                  }
                                                ]
                                              },
                                              {
                                                "id": "oxt1s",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Baujahr"
                                                },
                                                "negated": false,
                                                "type": "AnswerNumberComparison",
                                                "operator": "lte",
                                                "comparands": [
                                                  {
                                                    "type": "NumberLiteral",
                                                    "value": 1990
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "vv7dk",
                                      "type": "Question",
                                      "alias": "Bad größer als 8qm",
                                      "text": "Gibt es ein Badezimmer, das größer als 8qm ist?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal:\nMindestens ein Bad größer als 8 m2 [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            }
                          ]
                        },
                        {
                          "id": "zsd53",
                          "type": "Group",
                          "category": "Section",
                          "alias": "Dusche & Badewanne",
                          "block": [
                            {
                              "id": "kxtk1",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "4ks74",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "vz6jsl",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k",
                                      "7np1",
                                      "m2jo",
                                      "4obam",
                                      "oqyrs"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "tg5g3",
                                      "type": "Question",
                                      "alias": "Bad hat Duschmöglichkeit",
                                      "text": "Gibt es in der Wohnung eine Möglichkeit zu Duschen?",
                                      "info": "Dies ist erfüllt, wenn du eine Dusche oder eine Badewanne mit Duschkopf hast.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "vove8",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "y3v95",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "ubu0t",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015-2023:\nKeine Duschmöglichkeit [--]\n\nMerkmal >=2024:\nKeine Duschmöglichkeit (z. B. kein Spritzwasserschutz, keine Duschkopfhalterung, sehr kleine Standfläche) [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "kdwvk",
                                  "type": "Question",
                                  "alias": "Bad hat Duschmöglichkeit",
                                  "text": "Gibt es in der Wohnung eine Möglichkeit zu Duschen? ",
                                  "info": "Die Duschmöglichkeit muss einen Spritzwasserschutz und eine Duschkopfhalterung haben.",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "vove8",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "y3v95",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "ubu0t",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015-2023:\nKeine Duschmöglichkeit [--]\n\nMerkmal >=2024:\nKeine Duschmöglichkeit (z. B. kein Spritzwasserschutz, keine Duschkopfhalterung, sehr kleine Standfläche) [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            },
                            {
                              "id": "r02tok",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "e51xr",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "x8e",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Bad hat Duschmöglichkeit"
                                    },
                                    "negated": true,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "vove8"
                                    ]
                                  },
                                  "block": []
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "rj5pk",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "qhmpfj",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "1k5gx",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Vertragsdatum"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "wejo0k"
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "7r05y",
                                          "type": "If",
                                          "cases": [
                                            {
                                              "id": "04sajg",
                                              "type": "IfCase",
                                              "test": {
                                                "id": "b0smz",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Sondermerkmal Dusche Und Badewanne"
                                                },
                                                "negated": false,
                                                "type": "AnswerOptionComparison",
                                                "operator": "is",
                                                "comparands": [
                                                  "uiajj"
                                                ]
                                              },
                                              "block": []
                                            }
                                          ],
                                          "alternate": [
                                            {
                                              "id": "h492n",
                                              "type": "Question",
                                              "alias": "Bad hat Dusche und Wanne",
                                              "text": "Gibt es in der Wohnung sowohl eine Dusche als auch eine separate Badewanne?",
                                              "info": null,
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "kewsy",
                                                    "alias": "Ja",
                                                    "text": "Ja"
                                                  },
                                                  {
                                                    "id": "wcek6",
                                                    "alias": "Nein",
                                                    "text": "Nein"
                                                  },
                                                  {
                                                    "id": "wx0n",
                                                    "alias": "Nicht sicher",
                                                    "text": "Ich bin mir nicht sicher"
                                                  }
                                                ]
                                              },
                                              "required": false,
                                              "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Von der Badewanne getrennte Dusche“ nicht zutrifft: Von der Badewanne getrennte Dusche [++]\n\nMerkmal >= 2017:\nVon der Badewanne getrennte zusätzliche Duschtasse oder -kabine [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": [
                                    {
                                      "id": "3hedjh",
                                      "type": "Question",
                                      "alias": "Bad hat Dusche und Wanne",
                                      "text": "Gibt es in der Wohnung sowohl eine Dusche als auch eine separate Badewanne?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "kewsy",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "wcek6",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "wx0n",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Von der Badewanne getrennte Dusche“ nicht zutrifft: Von der Badewanne getrennte Dusche [++]\n\nMerkmal >= 2017:\nVon der Badewanne getrennte zusätzliche Duschtasse oder -kabine [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                },
                                {
                                  "id": "ithdtj",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "myvbfj",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "0g5s7i",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Vertragsdatum"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "wejo0k",
                                          "7np1",
                                          "m2jo",
                                          "4obam",
                                          "oqyrs"
                                        ]
                                      },
                                      "block": []
                                    }
                                  ],
                                  "alternate": [
                                    {
                                      "id": "6w6r6",
                                      "type": "Question",
                                      "alias": "Bad hat bodengleiche Dusche",
                                      "text": "Falls die Wohnung eine Dusche hat, ist diese ebenerdig zum Badezimmer oder maximal 3cm tief?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Bodengleiche Dusche (auch flache Duschtasse mit\neiner Tiefe von bis zu 3 cm)\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                },
                                {
                                  "id": "aebtq",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "bi81t",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "qaztt",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Bad hat Dusche und Wanne"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "wcek6",
                                          "wx0n"
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "wbo3g",
                                          "type": "Question",
                                          "alias": "Duschen nur in freistehender Badewanne",
                                          "text": "Gibt es als einzige Duschmöglichkeit eine freistehende Badewanne?",
                                          "info": "Eine Badewanne gilt als freistehend, wenn sie an keiner Seite fest mit der Wand verbunden ist.",
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal:\nBad ohne separate Dusche mit frei stehender Badewanne mit oder ohne Verblendung in nicht modernisiertem Bad [--]"
                                        },
                                        {
                                          "id": "dryf5",
                                          "type": "If",
                                          "cases": [
                                            {
                                              "id": "nvaf0i",
                                              "type": "IfCase",
                                              "test": {
                                                "id": "btohj",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Duschen nur in freistehender Badewanne"
                                                },
                                                "negated": false,
                                                "type": "AnswerOptionComparison",
                                                "operator": "is",
                                                "comparands": [
                                                  "uiajj",
                                                  "8i22j"
                                                ]
                                              },
                                              "block": [
                                                {
                                                  "id": "xz3zd",
                                                  "type": "Question",
                                                  "alias": "Duschen nur in freistehender Badewanne in nicht modernisiertem Bad",
                                                  "text": "Befindet sich die Badewanne in einem nicht modernisierten Bad?",
                                                  "info": "Ein Bad gilt als nicht modernisiert, wenn es z.B. nicht ausreichend im Spritzwasserbereich gefließt ist oder der Boden nicht feuchtigkeitsgeeignet ist.",
                                                  "answer": {
                                                    "type": "ChoiceAnswer",
                                                    "options": [
                                                      {
                                                        "id": "uiajj",
                                                        "alias": "Ja",
                                                        "text": "Ja"
                                                      },
                                                      {
                                                        "id": "qzhja",
                                                        "alias": "Nein",
                                                        "text": "Nein"
                                                      },
                                                      {
                                                        "id": "8i22j",
                                                        "alias": "Nicht sicher",
                                                        "text": "Ich bin mir nicht sicher"
                                                      }
                                                    ]
                                                  },
                                                  "required": false,
                                                  "note": "Merkmal:\nBad ohne separate Dusche mit frei stehender Badewanne mit oder ohne Verblendung in nicht modernisiertem Bad [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                                }
                                              ]
                                            }
                                          ],
                                          "alternate": []
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "alternate": []
                },
                {
                  "id": "wn0p",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Waschbecken",
                  "block": [
                    {
                      "id": "4w8hp",
                      "type": "If",
                      "cases": [
                        {
                          "id": "bmsjy",
                          "type": "IfCase",
                          "test": {
                            "id": "5v853k",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k",
                              "7np1",
                              "m2jo",
                              "4obam",
                              "oqyrs"
                            ]
                          },
                          "block": [
                            {
                              "id": "5y96s",
                              "type": "Question",
                              "alias": "Bad & WC ohne Waschbecken",
                              "text": "Gibt es ein Badezimmer oder WC, welches kein Handwaschbecken hat?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "3naif",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "3t07yi",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "3ayyvg",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015-2023:\nKein Handwaschbecken in Bad oder WC oder im Bad nur ein kleines Handwaschbecken (Außenmaß 50 x 25 cm oder kleiner) [--]\n\nMerkmal >=2024:\nKein Handwaschbecken in Bad oder WC oder im Bad nur ein kleines Handwaschbecken (Außenmaß 50 x 25 cm oder kleiner) [bezieht sich nicht auf Gäste-WCs] [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "1g2qk",
                          "type": "Question",
                          "alias": "Bad & WC ohne Waschbecken",
                          "text": "Gibt es ein Badezimmer oder WC, welches kein Handwaschbecken hat?",
                          "info": "Beachte: Diese Frage bezieht sich nicht auf Gäste-WCs",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "3naif",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "3t07yi",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "3ayyvg",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal 2015-2023:\nKein Handwaschbecken in Bad oder WC oder im Bad nur ein kleines Handwaschbecken (Außenmaß 50 x 25 cm oder kleiner) [--]\n\nMerkmal >=2024:\nKein Handwaschbecken in Bad oder WC oder im Bad nur ein kleines Handwaschbecken (Außenmaß 50 x 25 cm oder kleiner) [bezieht sich nicht auf Gäste-WCs] [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    },
                    {
                      "id": "8mrpx",
                      "type": "If",
                      "cases": [
                        {
                          "id": "eisej",
                          "type": "IfCase",
                          "test": {
                            "id": "53qig",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Badezimmer in Wohnung"
                            },
                            "negated": true,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "qzhja"
                            ]
                          },
                          "block": [
                            {
                              "id": "rrxcvk",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "yilt8",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "ss7u3g",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Bad & WC ohne Waschbecken"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "3t07yi",
                                      "3ayyvg"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "eat3b",
                                      "type": "Question",
                                      "alias": "Bad nur kleines Waschbecken",
                                      "text": "Gibt es ein Badezimmer, welches lediglich ein kleines Handwaschbecken (Außenmaß 50x25cm oder kleiner) hat?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal:\nKein Handwaschbecken in Bad oder WC oder im Bad nur ein kleines Handwaschbecken (Außenmaß 50 x 25 cm oder kleiner) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            },
                            {
                              "id": "efhll",
                              "type": "Question",
                              "alias": "Bad großes Waschbecken",
                              "text": "Gibt es ein Badezimmer, welches entweder ein sehr großes Waschbecken (Außenmaß mindestens 80 cm breit), ein Doppelhandwaschbecken, oder zwei getrennte Waschbecken hat?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal:\nSehr großes Waschbecken (Außenmaß mindestens 80 cm breit) oder Doppelhandwaschbecken oder zwei getrennte Waschbecken [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                },
                {
                  "id": "pl4xj",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Toilette",
                  "block": [
                    {
                      "id": "z6r2d",
                      "type": "Question",
                      "alias": "Mehrere WCs",
                      "text": "Gibt es in der Wohnung zwei oder mehr Toiletten?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "h03u7",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "u5f7u",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "httq4",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nZweites WC in der Wohnung oder Bad und WC getrennt [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "78z1f",
                      "type": "If",
                      "cases": [
                        {
                          "id": "rjeiz",
                          "type": "IfCase",
                          "test": {
                            "id": "6fn49g",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Mehrere WCs"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "h03u7"
                            ]
                          },
                          "block": []
                        }
                      ],
                      "alternate": [
                        {
                          "id": "i6wdil",
                          "type": "Question",
                          "alias": "Getrenntes WC",
                          "text": "Sind Badezimmer und Toilette in zwei getrennten Räumen?",
                          "info": null,
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal:\nZweites WC in der Wohnung oder Bad und WC getrennt [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    },
                    {
                      "id": "g78zj",
                      "type": "If",
                      "cases": [
                        {
                          "id": "3ohtu",
                          "type": "IfCase",
                          "test": {
                            "id": "zyrdxk",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "48wh2",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "2jaam",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "fnr9v",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Sondermerkmal Modernes Bad"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "uiajj"
                                    ]
                                  },
                                  "block": []
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "2nazjh",
                                  "type": "Question",
                                  "alias": "Bad hat wandhängendes WC",
                                  "text": "Sind alle Toiletten wandhängend mit Spülkasten in der Wand (wie z.B. auf diesem Bild)?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015:\nnur wenn Sondermerkmal „Modernes Bad“ nicht zutrifft: Wandhängendes WC mit in der Wand eingelassenem Spülkasten [++]\n\nMerkmal 2017:\nWandhängendes WC mit in der Wand eingelassenem Spülkasten [++]\n\nMerkmal 2019-2023:\nWandhängendes WC mit in der Wand eingelassenem Spülkasten; gilt nicht in der Baualtersklasse ab 2003 [++]\n\nMerkmal >=2024:\nWandhängendes WC mit in der Wand eingelassenem\nSpülkasten (gilt nicht für die Baualtersklassen ab 2002)\noder hochwertiges Stand-WC [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "id": "v3zb4",
                          "type": "IfCase",
                          "test": {
                            "id": "zbgmn",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "7np1"
                            ]
                          },
                          "block": [
                            {
                              "id": "eccd4",
                              "type": "Question",
                              "alias": "Bad hat wandhängendes WC",
                              "text": "Sind alle Toiletten wandhängend mit Spülkasten in der Wand (wie z.B. auf diesem Bild)?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nnur wenn Sondermerkmal „Modernes Bad“ nicht zutrifft: Wandhängendes WC mit in der Wand eingelassenem Spülkasten [++]\n\nMerkmal 2017:\nWandhängendes WC mit in der Wand eingelassenem Spülkasten [++]\n\nMerkmal 2019-2023:\nWandhängendes WC mit in der Wand eingelassenem Spülkasten; gilt nicht in der Baualtersklasse ab 2003 [++]\n\nMerkmal >=2025:\nWandhängendes WC mit in der Wand eingelassenem\nSpülkasten (gilt nicht für die Baualtersklassen ab 2002)\noder hochwertiges Stand-WC [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        },
                        {
                          "id": "c59au",
                          "type": "IfCase",
                          "test": {
                            "id": "5vvsi",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "m2jo",
                              "4obam",
                              "oqyrs"
                            ]
                          },
                          "block": [
                            {
                              "id": "a8ffw",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "ss1f1i",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "ghai4",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Baujahr"
                                    },
                                    "negated": false,
                                    "type": "AnswerNumberComparison",
                                    "operator": "lte",
                                    "comparands": [
                                      {
                                        "type": "NumberLiteral",
                                        "value": 2002
                                      }
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "0evldj",
                                      "type": "Question",
                                      "alias": "Bad hat wandhängendes WC",
                                      "text": "Sind alle Toiletten wandhängend mit Spülkasten in der Wand (wie z.B. auf diesem Bild)?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nnur wenn Sondermerkmal „Modernes Bad“ nicht zutrifft: Wandhängendes WC mit in der Wand eingelassenem Spülkasten [++]\n\nMerkmal 2017:\nWandhängendes WC mit in der Wand eingelassenem Spülkasten [++]\n\nMerkmal 2019-2023:\nWandhängendes WC mit in der Wand eingelassenem Spülkasten; gilt nicht in der Baualtersklasse ab 2003 [++]\n\nMerkmal >=2024:\nWandhängendes WC mit in der Wand eingelassenem\nSpülkasten (gilt nicht für die Baualtersklassen ab 2002)\noder hochwertiges Stand-WC [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "tsoy6",
                          "type": "If",
                          "cases": [
                            {
                              "id": "5myqp",
                              "type": "IfCase",
                              "test": {
                                "id": "yriuz",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 2001
                                  }
                                ]
                              },
                              "block": [
                                {
                                  "id": "xihum",
                                  "type": "Question",
                                  "alias": "Bad hat wandhängendes WC",
                                  "text": "Sind alle Toiletten wandhängend mit Spülkasten in der Wand (wie z.B. auf diesem Bild)?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015:\nnur wenn Sondermerkmal „Modernes Bad“ nicht zutrifft: Wandhängendes WC mit in der Wand eingelassenem Spülkasten [++]\n\nMerkmal 2017:\nWandhängendes WC mit in der Wand eingelassenem Spülkasten [++]\n\nMerkmal 2019-2023:\nWandhängendes WC mit in der Wand eingelassenem Spülkasten; gilt nicht in der Baualtersklasse ab 2003 [++]\n\nMerkmal >=2024:\nWandhängendes WC mit in der Wand eingelassenem\nSpülkasten (gilt nicht für die Baualtersklassen ab 2002)\noder hochwertiges Stand-WC [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        },
                        {
                          "id": "k0ong",
                          "type": "If",
                          "cases": [
                            {
                              "id": "3vg5u",
                              "type": "IfCase",
                              "test": {
                                "id": "jwq98",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Bad hat wandhängendes WC"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "uiajj"
                                ]
                              },
                              "block": []
                            }
                          ],
                          "alternate": [
                            {
                              "id": "vy8d5",
                              "type": "Question",
                              "alias": "Bad hat hochwertiges Stand-WC",
                              "text": "Sind alle Toiletten hochwertige Stand-WCs?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nnur wenn Sondermerkmal „Modernes Bad“ nicht zutrifft: Wandhängendes WC mit in der Wand eingelassenem Spülkasten [++]\n\nMerkmal 2017:\nWandhängendes WC mit in der Wand eingelassenem Spülkasten [++]\n\nMerkmal 2019-2023:\nWandhängendes WC mit in der Wand eingelassenem Spülkasten; gilt nicht in der Baualtersklasse ab 2003 [++]\n\nMerkmal >=2025:\nWandhängendes WC mit in der Wand eingelassenem\nSpülkasten (gilt nicht für die Baualtersklassen ab 2002)\noder hochwertiges Stand-WC [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "zy1jr",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Lüftung",
                  "block": [
                    {
                      "id": "6xcqw",
                      "type": "If",
                      "cases": [
                        {
                          "id": "h6ej2",
                          "type": "IfCase",
                          "test": {
                            "id": "yp1op",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k",
                              "7np1",
                              "m2jo",
                              "4obam",
                              "oqyrs"
                            ]
                          },
                          "block": [
                            {
                              "id": "illba",
                              "type": "Question",
                              "alias": "WC ohne Lüftung",
                              "text": "Gibt es einen Raum mit einer Toilette, in welchem es keine Möglichkeit zur Entlüftung gibt?",
                              "info": "Dies ist der Fall, wenn es in dem Raum kein Fenster und keine Lüftungsanlage gibt.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015-2023:\nWC ohne Lüftungsmöglichkeit und Entlüftung [--]\n\nMerkmal >=2024\nWC ohne Lüftungsmöglichkeit und Entlüftung\n[bezieht sich nicht auf Gäste-WCs] [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "5gkyd",
                          "type": "Question",
                          "alias": "WC ohne Lüftung",
                          "text": "Gibt es einen Raum mit einer Toilette, in welchem es keine Möglichkeit zur Entlüftung gibt?",
                          "info": "Dies ist der Fall, wenn es in dem Raum kein Fenster und keine Lüftungsanlage gibt. Beachte: Diese Frage bezieht sich nicht auf Gäste-WCs.",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal 2015-2023:\nWC ohne Lüftungsmöglichkeit und Entlüftung [--]\n\nMerkmal >=2024\nWC ohne Lüftungsmöglichkeit und Entlüftung [bezieht sich nicht auf Gäste-WCs] [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    },
                    {
                      "id": "vu6qw",
                      "type": "If",
                      "cases": [
                        {
                          "id": "rweyg",
                          "type": "IfCase",
                          "test": {
                            "id": "fkqso",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Badezimmer in Wohnung"
                            },
                            "negated": true,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "qzhja"
                            ]
                          },
                          "block": [
                            {
                              "id": "bdljul",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "gpjga",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "j4igy",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "08tnb",
                                      "wejo0k",
                                      "7np1",
                                      "m2jo",
                                      "4obam",
                                      "oqyrs"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "h0j1f",
                                      "type": "Question",
                                      "alias": "Bad mit WC ohne Fenster",
                                      "text": "Gibt es ein Badezimmer mit einer Toilette, welches kein Fenster hat?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015-2023:\nBad mit WC ohne Fenster [--]\n\nMerkmal >=2025: Bad mit WC ohne Fenster; gilt nicht für die Baualtersklasse 1973 bis 1990 Ost\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "ndkp3",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "a4zj3",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "9yzij",
                                        "type": "LogicalOperation",
                                        "operator": "and",
                                        "negated": false,
                                        "conditions": [
                                          {
                                            "id": "5k04q",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "gte",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 1973
                                              }
                                            ]
                                          },
                                          {
                                            "id": "5k04q",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "lte",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 1990
                                              }
                                            ]
                                          },
                                          {
                                            "id": "5k04q",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Ost"
                                            },
                                            "negated": false,
                                            "type": "AnswerBooleanComparison",
                                            "operator": "is",
                                            "value": true
                                          }
                                        ]
                                      },
                                      "block": []
                                    }
                                  ],
                                  "alternate": [
                                    {
                                      "id": "bosaz",
                                      "type": "Question",
                                      "alias": "Bad mit WC ohne Fenster",
                                      "text": "Gibt es ein Badezimmer mit einer Toilette, welches kein Fenster hat?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal <=2023:\nBad mit WC ohne Fenster [--]\n\nMerkmal >=2025: Bad mit WC ohne Fenster; gilt nicht für die Baualtersklasse 1973 bis 1990 Ost\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "id": "e7czfk",
                              "type": "Question",
                              "alias": "Bad mit moderner Entlüftung",
                              "text": "Gibt es ein innen liegendes Badezimmer mit moderner, gesteuerter Entlüftung (z.B. mittels Feuchtigkeitssensor)?",
                              "info": "Beachte: Eine durch (Licht-)Schalter bediente Entlüftung gilt nicht modern.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal:\nInnen liegendes Badezimmer mit moderner, gesteuerter Entlüftung (z.B. mittels Feuchtigkeitssensor) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                },
                {
                  "id": "x19izk",
                  "type": "If",
                  "cases": [
                    {
                      "id": "jxcsq",
                      "type": "IfCase",
                      "test": {
                        "id": "vxtuw",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Badezimmer in Wohnung"
                        },
                        "negated": true,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "qzhja"
                        ]
                      },
                      "block": [
                        {
                          "id": "pbw21f",
                          "type": "Group",
                          "category": "Section",
                          "alias": "Heizung",
                          "block": [
                            {
                              "id": "npmf4",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "x7oaq",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "aq5ptg",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k",
                                      "7np1",
                                      "m2jo",
                                      "4obam",
                                      "oqyrs"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "4issj",
                                      "type": "Question",
                                      "alias": "Bad ohne Heizung",
                                      "text": "Gibt es ein Badezimmer oder WC, welches nicht beheizbar ist?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "tcod4",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "43bd3",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "36h0m",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015-2023:\nBad oder WC nicht beheizbar oder Holz-/Kohleheizung oder Elektroheizstrahler [--]\n\nMerkmal >=2024:\nBad nicht beheizbar oder Holz-/Kohleheizung oder Elektroheizstrahler [bezieht sich nicht auf Gäste-WCs] [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "tinoy",
                                  "type": "Question",
                                  "alias": "Bad ohne Heizung",
                                  "text": "Gibt es ein Badezimmer welches nicht beheizbar ist?",
                                  "info": "Beachte: Diese Frage bezieht sich nicht auf Gäste-WCs",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "tcod4",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "43bd3",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "36h0m",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015-2023:\nBad oder WC nicht beheizbar oder Holz-/Kohleheizung oder Elektroheizstrahler [--]\n\nMerkmal >=2024:\nBad nicht beheizbar oder Holz-/Kohleheizung oder Elektroheizstrahler [bezieht sich nicht auf Gäste-WCs] [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            },
                            {
                              "id": "f1987",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "rpdk8i",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "nar8wl",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Bad ohne Heizung"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "tcod4"
                                    ]
                                  },
                                  "block": []
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "6w0nq",
                                  "type": "Question",
                                  "alias": "Bad mit alter Heizung",
                                  "text": "Gibt es ein Badezimmer oder WC, welches nur mit einer Holz-/Kohleheizung oder einem Elektroheizstrahler beheizbar ist?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal:\nBad oder WC nicht beheizbar oder Holz-/Kohleheizung oder Elektroheizstrahler [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            },
                            {
                              "id": "e6u4l",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "68q5c",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "aagd2",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "unpd2",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "surg8",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "ddj1p",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Sondermerkmal Modernes Bad"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "uiajj"
                                            ]
                                          },
                                          "block": []
                                        }
                                      ],
                                      "alternate": [
                                        {
                                          "id": "wt1pi",
                                          "type": "Question",
                                          "alias": "Bad mit Strukturheizkörper",
                                          "text": "Gibt es ein Badezimmer mit einem Strukturheizkörper als Handtuchwärmer (wie z.B. auf diesem Bild)?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nnur wenn Sondermerkmal „Modernes Bad“ nicht zutrifft: Strukturheizkörper als Handtuchwärmer [++]\n\nMerkmal 2017-2023:\nStrukturheizkörper als Handtuchwärmer [++]\n\nMerkmal 2025:\nStrukturheizkörper als Handtuchwärmer im Bad\n(gilt für die Baualtersklassen bis einschließlich 2001);\nfalls elektrisch betreibbar: alle Baujahre [++}\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  "id": "y5am1",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "udulw",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "7np1",
                                      "m2jo",
                                      "4obam",
                                      "oqyrs"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "zlcgm",
                                      "type": "Question",
                                      "alias": "Bad mit Strukturheizkörper",
                                      "text": "Gibt es ein Badezimmer mit einem Strukturheizkörper als Handtuchwärmer (wie z.B. auf diesem Bild)?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nnur wenn Sondermerkmal „Modernes Bad“ nicht zutrifft: Strukturheizkörper als Handtuchwärmer [++]\n\nMerkmal 2017-2023:\nStrukturheizkörper als Handtuchwärmer [++]\n\nMerkmal 2025:\nStrukturheizkörper als Handtuchwärmer im Bad\n(gilt für die Baualtersklassen bis einschließlich 2001);\nfalls elektrisch betreibbar: alle Baujahre [++}\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "5z9gv",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "km0tyl",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "unch7i",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 2001
                                          }
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "9er1t",
                                          "type": "Question",
                                          "alias": "Bad mit Strukturheizkörper",
                                          "text": "Gibt es ein Badezimmer mit einem Strukturheizkörper als Handtuchwärmer (wie z.B. auf diesem Bild)?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nnur wenn Sondermerkmal „Modernes Bad“ nicht zutrifft: Strukturheizkörper als Handtuchwärmer [++]\n\nMerkmal 2017-2023:\nStrukturheizkörper als Handtuchwärmer [++]\n\nMerkmal 2025:\nStrukturheizkörper als Handtuchwärmer im Bad\n(gilt für die Baualtersklassen bis einschließlich 2001);\nfalls elektrisch betreibbar: alle Baujahre [++}\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": [
                                    {
                                      "id": "kl1j3",
                                      "type": "Question",
                                      "alias": "Bad mit Strukturheizkörper",
                                      "text": "Gibt es ein Badezimmer mit einen elektrischen Strukturheizkörper als Handtuchwärmer (wie z.B. auf diesem Bild)?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nnur wenn Sondermerkmal „Modernes Bad“ nicht zutrifft: Strukturheizkörper als Handtuchwärmer [++]\n\nMerkmal 2017-2023:\nStrukturheizkörper als Handtuchwärmer [++]\n\nMerkmal 2025:\nStrukturheizkörper als Handtuchwärmer im Bad\n(gilt für die Baualtersklassen bis einschließlich 2001);\nfalls elektrisch betreibbar: alle Baujahre [++}\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "id": "hz9pn",
                              "type": "Question",
                              "alias": "Bad mit Fußbodenheizung",
                              "text": "Gibt es ein Badezimmer mit Fußbodenheizung?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal:\nFußbodenheizung [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        },
                        {
                          "id": "ypgwt",
                          "type": "Group",
                          "category": "Section",
                          "alias": "Wände & Boden",
                          "block": [
                            {
                              "id": "d45by",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "r7nz",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "s2uv5g",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k",
                                      "7np1"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "nzi5c",
                                      "type": "Question",
                                      "alias": "Bad mit Dielenfußboden",
                                      "text": "Gibt es ein Badezimmer mit Dielenfußboden?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nDielenfußboden im Bad [--]\n\nMerkmal >2017:\nDielenfußboden im Bad (wenn nicht feuchtraumgeeignet) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                },
                                {
                                  "id": "wm63f",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "43leo",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "m2jo",
                                      "4obam",
                                      "oqyrs"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "4nqkni",
                                      "type": "Question",
                                      "alias": "Bad mit Dielenfußboden",
                                      "text": "Gibt es ein Badezimmer mit Dielenfußboden, welcher nicht feuchtraumgeeignet ist?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015-2017:\nDielenfußboden im Bad [--]\n\nMerkmal 2019-2023:\nDielenfußboden im Bad (wenn nicht feuchtraumgeeignet) [--]\n\nMerkmal >=2014:\nDielenfußboden im Bad (wenn nicht feuchtraumgeeignet) [bezieht sich nicht auf Gäste-WCs] [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "0k2x7",
                                  "type": "Question",
                                  "alias": "Bad mit Dielenfußboden",
                                  "text": "Gibt es ein Badezimmer mit Dielenfußboden, welcher nicht feuchtraumgeeignet ist?",
                                  "info": "Beachte: Diese Frage bezieht sich nicht auf Gäste-WCs",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015-2017:\nDielenfußboden im Bad [--]\n\nMerkmal 2019-2023:\nDielenfußboden im Bad (wenn nicht feuchtraumgeeignet) [--]\n\nMerkmal >=2014:\nDielenfußboden im Bad (wenn nicht feuchtraumgeeignet) [bezieht sich nicht auf Gäste-WCs] [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            },
                            {
                              "id": "y52rjh",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "usz2p",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "9yjmz",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "eytoo",
                                      "type": "Question",
                                      "alias": "Bad Wände ausreichend gefließt",
                                      "text": "Sind die Wände in den Badezimmern um Dusche, Badewanne und Waschbecken so gefließt, dass die ungeschützte Wand normalerweise nicht nass wird?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nWände nicht überwiegend gefliest [--]\n\nMerkmal >= 2017:\nWände nicht ausreichend im Spritzwasserbereich von Waschbecken, Badewanne und/oder Dusche gefliest [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                                    },
                                    {
                                      "id": "h5xafh",
                                      "type": "Question",
                                      "alias": "Bad Boden und Wand hochwertig",
                                      "text": "Sind in allen Badezimmern hochwertige Boden- oder Wandfliesen verlegt?",
                                      "info": "Dies gilt, wenn die Fliesen nicht einheitlich sind, sondern durch Akzente und Verzierungen aufgewertet wurden (z.B. Mosaikfliesen). Dazu gelten Natursteine wie Marmor, Schiefer oder Granit ebenfalls als hochwertig.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nHochwertige Boden- oder Wandfliesen [++]\n\nMerkmal 2017-2023:\nWandbekleidung und Bodenbelag hochwertig [++]\n\nMerkmal >=2025:\nWandbekleidung und Bodenbelag hochwertig;\ngilt nicht für die Baualtersklasse 2016 bis 2022 [bezieht sich nicht auf Gäste-WCs] [++]\n\nMerkmal >=2026:\nWandverkleidung und Bodenbelag hochwertig (gilt nicht für die Baualtersklassen ab 2010) [bezieht sich nicht auf Gäste-WCs] [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "ph4yq",
                                  "type": "Question",
                                  "alias": "Bad Wände ausreichend gefließt",
                                  "text": "Sind die Wände in den Badezimmern um Dusche, Badewanne und Waschbecken so gefließt, dass die ungeschützte Wand normalerweise nicht nass wird?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015:\nWände nicht überwiegend gefliest [--]\n\nMerkmal >= 2017:\nWände nicht ausreichend im Spritzwasserbereich von Waschbecken, Badewanne und/oder Dusche gefliest [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                                },
                                {
                                  "id": "lsepp",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "opf8j",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "gl163",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Vertragsdatum"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "oqyrs",
                                          "4obam",
                                          "m2jo",
                                          "7np1",
                                          "wejo0k"
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "x2l8rh",
                                          "type": "Question",
                                          "alias": "Bad Boden und Wand hochwertig",
                                          "text": "Ist der Bodenbelag und die Wandbekleidung in allen Badezimmern hochwertig? ",
                                          "info": "Dies gilt, wenn die Fliesen nicht einheitlich sind, sondern durch Akzente und Verzierungen aufgewertet wurden (z.B. Mosaikfliesen). Dazu gelten Natursteine wie Marmor, Schiefer oder Granit ebenfalls als hochwertig.",
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nHochwertige Boden- oder Wandfliesen [++]\n\nMerkmal 2017-2023:\nWandbekleidung und Bodenbelag hochwertig [++]\n\nMerkmal >=2025:\nWandbekleidung und Bodenbelag hochwertig;\ngilt nicht für die Baualtersklasse 2016 bis 2022 [bezieht sich nicht auf Gäste-WCs] [++]\n\nMerkmal >=2026:\nWandverkleidung und Bodenbelag hochwertig (gilt nicht für die Baualtersklassen ab 2010) [bezieht sich nicht auf Gäste-WCs] [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ]
                                    },
                                    {
                                      "id": "proski",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "5r4o8",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Vertragsdatum"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "ve0tek"
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "mq7kv",
                                          "type": "If",
                                          "cases": [
                                            {
                                              "id": "pnw38",
                                              "type": "IfCase",
                                              "test": {
                                                "id": "cncv6",
                                                "type": "LogicalOperation",
                                                "operator": "or",
                                                "negated": false,
                                                "conditions": [
                                                  {
                                                    "id": "r7h0z",
                                                    "questionRef": {
                                                      "type": "AliasRef",
                                                      "value": "Baujahr"
                                                    },
                                                    "negated": false,
                                                    "type": "AnswerNumberComparison",
                                                    "operator": "lt",
                                                    "comparands": [
                                                      {
                                                        "type": "NumberLiteral",
                                                        "value": 2016
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "id": "r7h0z",
                                                    "questionRef": {
                                                      "type": "AliasRef",
                                                      "value": "Baujahr"
                                                    },
                                                    "negated": false,
                                                    "type": "AnswerNumberComparison",
                                                    "operator": "gt",
                                                    "comparands": [
                                                      {
                                                        "type": "NumberLiteral",
                                                        "value": 2022
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              "block": [
                                                {
                                                  "id": "o182r",
                                                  "type": "Question",
                                                  "alias": "Bad Boden und Wand hochwertig",
                                                  "text": "Ist der Bodenbelag und die Wandbekleidung in allen Badezimmern hochwertig? ",
                                                  "info": "Dies gilt, wenn die Fliesen nicht einheitlich sind, sondern durch Akzente und Verzierungen aufgewertet wurden (z.B. Mosaikfliesen). Dazu gelten Natursteine wie Marmor, Schiefer oder Granit ebenfalls als hochwertig.",
                                                  "answer": {
                                                    "type": "ChoiceAnswer",
                                                    "options": [
                                                      {
                                                        "id": "uiajj",
                                                        "alias": "Ja",
                                                        "text": "Ja"
                                                      },
                                                      {
                                                        "id": "qzhja",
                                                        "alias": "Nein",
                                                        "text": "Nein"
                                                      },
                                                      {
                                                        "id": "8i22j",
                                                        "alias": "Nicht sicher",
                                                        "text": "Ich bin mir nicht sicher"
                                                      }
                                                    ]
                                                  },
                                                  "required": false,
                                                  "note": "Merkmal 2015:\nHochwertige Boden- oder Wandfliesen [++]\n\nMerkmal 2017-2023:\nWandbekleidung und Bodenbelag hochwertig [++]\n\nMerkmal >=2025:\nWandbekleidung und Bodenbelag hochwertig; gilt nicht für die Baualtersklasse 2016 bis 2022 [bezieht sich nicht auf Gäste-WCs] [++]\n\nMerkmal >=2026:\nWandverkleidung und Bodenbelag hochwertig (gilt nicht für die Baualtersklassen ab 2010) [bezieht sich nicht auf Gäste-WCs] [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                                }
                                              ]
                                            }
                                          ],
                                          "alternate": []
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": [
                                    {
                                      "id": "rwohg",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "jers1",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "r6c1h",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "lt",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 2010
                                              }
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "tdjgf",
                                              "type": "Question",
                                              "alias": "Bad Boden und Wand hochwertig",
                                              "text": "Ist der Bodenbelag und die Wandbekleidung in allen Badezimmern hochwertig? ",
                                              "info": "Dies gilt, wenn die Fliesen nicht einheitlich sind, sondern durch Akzente und Verzierungen aufgewertet wurden (z.B. Mosaikfliesen). Dazu gelten Natursteine wie Marmor, Schiefer oder Granit ebenfalls als hochwertig.",
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "uiajj",
                                                    "alias": "Ja",
                                                    "text": "Ja"
                                                  },
                                                  {
                                                    "id": "qzhja",
                                                    "alias": "Nein",
                                                    "text": "Nein"
                                                  },
                                                  {
                                                    "id": "8i22j",
                                                    "alias": "Nicht sicher",
                                                    "text": "Ich bin mir nicht sicher"
                                                  }
                                                ]
                                              },
                                              "required": false,
                                              "note": "Merkmal 2015:\nHochwertige Boden- oder Wandfliesen [++]\n\nMerkmal 2017-2023:\nWandbekleidung und Bodenbelag hochwertig [++]\n\nMerkmal >=2025:\nWandbekleidung und Bodenbelag hochwertig;\ngilt nicht für die Baualtersklasse 2016 bis 2022 [bezieht sich nicht auf Gäste-WCs] [++]\n\nMerkmal >=2026:\nWandverkleidung und Bodenbelag hochwertig (gilt nicht für die Baualtersklassen ab 2010) [bezieht sich nicht auf Gäste-WCs] [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                            }
                                          ]
                                        }
                                      ],
                                      "alternate": []
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "id": "j8vt1",
                          "type": "Group",
                          "category": "Section",
                          "alias": "Weitere Ausstattung",
                          "block": [
                            {
                              "id": "fld63",
                              "type": "Question",
                              "alias": "Bad mit hochwertiger Ausstattung",
                              "text": "Gibt es ein Badezimmer mit besonderer und hochwertiger Ausstattung (z.B. hochwertige Sanitärausstattung, hochwertige Badmöbel, Eckwanne/Rundwanne)?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal:\nBesondere und hochwertige Ausstattung (z.B. hochwertige Sanitärausstattung, hochwertige Badmöbel, Eckwanne, Rundwanne) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            },
                            {
                              "id": "dd51c",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "y71jej",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "14819",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "a6m2p",
                                      "type": "Question",
                                      "alias": "Bad hat Einhebelmischbatterie",
                                      "text": "Haben die Waschbecken und Badewannen überwiegend eine  Einhebelmischbatterie (wie z.B. auf diesem Bild)?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "m5uy8",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "4y9rd",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "fwl7w",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nEinhebelmischbatterien [++]\n\nCheck -> Ja\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            },
                            {
                              "id": "eyx6c",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "k0urd",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "3b2tqh",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k",
                                      "7np1",
                                      "m2jo",
                                      "4obam",
                                      "oqyrs"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "ve6xp",
                                      "type": "Question",
                                      "alias": "Bad hat Warmwasser",
                                      "text": "Gibt es im Badezimmer eine ausreichende Warmwasserversorgung?",
                                      "info": "Das ist der Fall, wenn es einen Durchlauferhitzer, einen Boiler mit mehr als 60 Litern oder eine zentrale Warmwasserversorgung vorhanden ist.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015-2023:\nKeine ausreichende Warmwasserversorgung (keine zentrale Warmwasserversorgung, kein Durchlauferhitzer, kein Boiler > 60 Liter) [--]\n\nMekrmal >=2024: \nKeine ausreichende Warmwasserversorgung (keine zentrale Warmwasserversorgung, kein Durchlauferhitzer, kein Boiler > 60 Liter) [bezieht sich nicht auf Gäste-WCs] [--] \n\nNein -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "txd1p",
                                  "type": "Question",
                                  "alias": "Bad hat Warmwasser",
                                  "text": "Gibt es im Badezimmer eine ausreichende Warmwasserversorgung?",
                                  "info": "Das ist der Fall, wenn es einen Durchlauferhitzer, einen Boiler mit mehr als 60 Litern oder eine zentrale Warmwasserversorgung vorhanden ist. Beachte: Diese Frage bezieht sich nicht auf Gäste-WCs.",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015-2023:\nKeine ausreichende Warmwasserversorgung (keine zentrale Warmwasserversorgung, kein Durchlauferhitzer, kein Boiler > 60 Liter) [--]\n\nMekrmal >=2024: \nKeine ausreichende Warmwasserversorgung (keine zentrale Warmwasserversorgung, kein Durchlauferhitzer, kein Boiler > 60 Liter) [bezieht sich nicht auf Gäste-WCs] [--] \n\nNein -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "alternate": []
                }
              ]
            },
            {
              "id": "wzz2n",
              "type": "Group",
              "category": "Page",
              "alias": "Küche",
              "block": [
                {
                  "id": "5cohm",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Allgemein",
                  "block": [
                    {
                      "id": "iir3d",
                      "type": "Question",
                      "alias": "Küche ist groß",
                      "text": "Ist die Küche mindestens 14qm groß?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nWohnküche (separater Raum mit mind. 14 m2 Grundfläche) [++]\n\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "g8u82",
                      "type": "If",
                      "cases": [
                        {
                          "id": "p3hax",
                          "type": "IfCase",
                          "test": {
                            "id": "mjvz1",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Küche ist groß"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "uiajj",
                              "8i22j"
                            ]
                          },
                          "block": [
                            {
                              "id": "jaherg",
                              "type": "Question",
                              "alias": "Küche ist separater Raum",
                              "text": "Handelt es sich bei der Küche um einen separaten Raum?",
                              "info": "Beachte: Offene Küchen und Wohnküchen gelten nicht als separate Räume.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "cou9x",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "hr3m3",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "5gphx",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal:\nWohnküche (separater Raum mit mind. 14 m2 Grundfläche) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    },
                    {
                      "id": "1blo2",
                      "type": "If",
                      "cases": [
                        {
                          "id": "hg0l6l",
                          "type": "IfCase",
                          "test": {
                            "id": "6qt1w",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "ssvoo",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "66un0f",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "1ox53",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Sondermerkmal Moderne Küche"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "uiajj"
                                    ]
                                  },
                                  "block": []
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "wlhgh",
                                  "type": "Question",
                                  "alias": "Küche hat Einbauküche",
                                  "text": "Ist die Küche von der Vermieterin mit einer Einbauküche mit Ober- und Unterschränken, Herd und Spüle ausgestattet worden?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "tcod4",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "43bd3",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "36h0m",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Moderne Küchenausstattung“ nicht zutrifft:\nEinbauküche mit Ober- und Unterschränken sowie Herd und Spüle [++]\n\nMerkmal >=2017:\nEinbauküche mit Ober- und Unter- schränken sowie Herd und Spüle [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "m0lvg",
                          "type": "Question",
                          "alias": "Küche hat Einbauküche",
                          "text": "Ist die Küche von der Vermieterin mit einer Einbauküche mit Ober- und Unterschränken, Herd und Spüle ausgestattet worden?",
                          "info": null,
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "tcod4",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "43bd3",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "36h0m",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Moderne Küchenausstattung“ nicht zutrifft:\nEinbauküche mit Ober- und Unterschränken sowie Herd und Spüle [++]\n\nMerkmal >=2017:\nEinbauküche mit Ober- und Unter- schränken sowie Herd und Spüle [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    },
                    {
                      "id": "a43v3",
                      "type": "If",
                      "cases": [
                        {
                          "id": "kvdrs",
                          "type": "IfCase",
                          "test": {
                            "id": "n75c9",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k",
                              "7np1",
                              "m2jo",
                              "4obam",
                              "oqyrs"
                            ]
                          },
                          "block": []
                        }
                      ],
                      "alternate": [
                        {
                          "id": "x94sm",
                          "type": "Question",
                          "alias": "Küche hat Kücheninsel",
                          "text": "Ist die Küche von der Vermieterin mit einer freistehenden Kücheninsel mit Kochmöglichkeit oder Spüle ausgestattet worden? ",
                          "info": "Freistehend heißt, dass diese nicht mit einer Wand oder einer anderen Arbeitsfläche verbunden ist. L-förmige Küchentheken sind daher nicht freistehend.",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "1xuk8",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "ulivf",
                                "alias": "Nein",
                                "text": "Nein "
                              },
                              {
                                "id": "k0ogk",
                                "alias": "nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal >=2024: Freistehender Küchenblock mit Arbeitsfläche und Kochmöglichkeit oder Spüle [++]\n\nJa -> Check\nNicht sicher -> nicht sicher"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "9h7jb",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Kochen",
                  "block": [
                    {
                      "id": "1fj01",
                      "type": "Question",
                      "alias": "Küche hat Kochmöglichkeit",
                      "text": "Ist die Küche von der Vermieterin mit einem Herd ausgestattet worden?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nKeine Kochmöglichkeit oder Gas-/ Elektroherd ohne Backofen [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "u1p0u",
                      "type": "If",
                      "cases": [
                        {
                          "id": "rx1lr",
                          "type": "IfCase",
                          "test": {
                            "id": "bbf82",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Küche hat Kochmöglichkeit"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "uiajj"
                            ]
                          },
                          "block": [
                            {
                              "id": "9tcd7h",
                              "type": "Question",
                              "alias": "Küche hat Gas/Elektroherd ohne Backofen",
                              "text": "Handelt es sich bei dem Herd um einen Gas- oder Elektroherd ohne Backofen?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal:\nKeine Kochmöglichkeit oder Gas-/ Elektroherd ohne Backofen [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    },
                    {
                      "id": "zq4f2k",
                      "type": "If",
                      "cases": [
                        {
                          "id": "wfkalj",
                          "type": "IfCase",
                          "test": {
                            "id": "siv5q",
                            "type": "LogicalOperation",
                            "operator": "and",
                            "negated": false,
                            "conditions": [
                              {
                                "id": "j5c3p",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Küche hat Kochmöglichkeit"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "8i22j",
                                  "uiajj"
                                ]
                              },
                              {
                                "id": "j5c3p",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Küche hat Gas/Elektroherd ohne Backofen"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "qzhja",
                                  "8i22j"
                                ]
                              }
                            ]
                          },
                          "block": [
                            {
                              "id": "i8xg9l",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "n1ree",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "pdf7u",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "vncyr",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "ntjw9",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "4k6iz",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Sondermerkmal Moderne Küche"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "uiajj"
                                            ]
                                          },
                                          "block": []
                                        }
                                      ],
                                      "alternate": [
                                        {
                                          "id": "qmwfnk",
                                          "type": "Question",
                                          "alias": "Küche hat Ceran-/Induktionsherd",
                                          "text": "Handelt es sich bei dem Herd um ein Ceran- oder Induktions-Kochfeld?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Moderne Küchenausstattung“ nicht zutrifft: Ceran-Kochfeld oder Induktions- Kochfeld [++]\n\nMerkmal 2017-2023:\nCeran-Kochfeld oder Induktions- Kochfeld [++]\n\nMerkmal >=2024: \nCeran-Kochfeld oder Induktions-Kochfeld (gilt für Baualtersklassen bis einschließlich 2001)\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  "id": "t6hvh",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "yk6pl",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "7np1",
                                      "m2jo",
                                      "4obam",
                                      "oqyrs"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "plpr5",
                                      "type": "Question",
                                      "alias": "Küche hat Ceran-/Induktionsherd",
                                      "text": "Handelt es sich bei dem Herd um ein Ceran- oder Induktions-Kochfeld?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Moderne Küchenausstattung“ nicht zutrifft: Ceran-Kochfeld oder Induktions- Kochfeld [++]\n\nMerkmal 2017-2023:\nCeran-Kochfeld oder Induktions- Kochfeld [++]\n\nMerkmal >=2024: \nCeran-Kochfeld oder Induktions-Kochfeld (gilt für Baualtersklassen bis einschließlich 2001)\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "91zivh",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "tqr2t",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "h868v",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 2001
                                          }
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "b8ez6",
                                          "type": "Question",
                                          "alias": "Küche hat Ceran-/Induktionsherd",
                                          "text": "Handelt es sich bei dem Herd um ein Ceran- oder Induktions-Kochfeld?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Moderne Küchenausstattung“ nicht zutrifft: Ceran-Kochfeld oder Induktions- Kochfeld [++]\n\nMerkmal 2017-2023:\nCeran-Kochfeld oder Induktions- Kochfeld [++]\n\nMerkmal >=2024: \nCeran-Kochfeld oder Induktions-Kochfeld (gilt für Baualtersklassen bis einschließlich 2001)\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                },
                {
                  "id": "x9afs",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Spülen",
                  "block": [
                    {
                      "id": "87ahc",
                      "type": "If",
                      "cases": [
                        {
                          "id": "w541j",
                          "type": "IfCase",
                          "test": {
                            "id": "gasa3f",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Küche hat Einbauküche"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "tcod4"
                            ]
                          },
                          "block": []
                        }
                      ],
                      "alternate": [
                        {
                          "id": "h7wij",
                          "type": "Question",
                          "alias": "Küche hat Spüle",
                          "text": "Ist die Küche von der Vermieterin mit einem Spülbecken ausgestattet worden?",
                          "info": null,
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "tcod4",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "43bd3",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "36h0m",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal:\nKeine Spüle [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    },
                    {
                      "id": "qom4",
                      "type": "Question",
                      "alias": "Küche kann Spülmaschine",
                      "text": "Ist es möglich in der Küche einen Geschirrspüler aufzustellen und anzuschließen?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "tcod4",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "43bd3",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "36h0m",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nGeschirrspüler in der Küche nicht stellbar oder anschließbar [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "dmv1k",
                      "type": "Question",
                      "alias": "Küche hat Warmwasser",
                      "text": "Gibt es in der Küche eine ausreichende Warmwasserversorgung?",
                      "info": "Dies ist erfüllt, wenn z.B. eine zentrale Warmwasserversorgung, ein Durchlauferhitzer, oder ein Boiler existiert.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal 2015:\nKeine ausreichende Warmwasserversorgung (keine zentrale Warmwasserversorgung, kein Durchlauferhitzer, kein Boiler an der Spüle) [--]\n\nMerkmal >=2017:\nKeine ausreichende Warmwasserversorgung (z.B. keine zentrale Warmwasserversorgung, kein Durchlauferhitzer, kein Boiler) [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                    }
                  ]
                },
                {
                  "id": "6etdn",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Kühlschrank",
                  "block": [
                    {
                      "id": "0q0iv",
                      "type": "If",
                      "cases": [
                        {
                          "id": "zuvel",
                          "type": "IfCase",
                          "test": {
                            "id": "n4urc",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k",
                              "7np1",
                              "m2jo",
                              "4obam",
                              "oqyrs"
                            ]
                          },
                          "block": [
                            {
                              "id": "qmoiq",
                              "type": "Question",
                              "alias": "Küche hat Kühlschrank",
                              "text": "Ist die Küche von der Vermieterin mit einem Kühlschrank ausgestattet worden?",
                              "info": "Der Kühlschrank zählt nur wenn er bei der Überlassung in einem annähernd neuwertigen Zustand war und der Vermieter keine extra Miete für diesen verlangt.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "tcod4",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "43bd3",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "36h0m",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Moderne Küchenausstattung“ nicht zutrifft: Kühlschrank [++]\n\nMerkmal 2017-2023:\nKühlschrank [++]\n\nMerkmal >=2024: Kühlschrank, Tiefkühlschrank/-truhe oder Geschirrspüler [++] \n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "tte6r",
                          "type": "Question",
                          "alias": "Küche hat Kühlschrank",
                          "text": "Ist die Küche von deiner Vermieterin mit mindestens einem der folgenden Geräte ausgestattet: Kühlschrank, Tiefkühlschrank, Geschirrspüler.",
                          "info": "Diese Geräte zählen nur wenn sie bei der Überlassung in einem annähernd neuwertigen Zustand waren und der Vermieter keine extra Miete für sie verlangt.",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "tcod4",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "43bd3",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "36h0m",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Moderne Küchenausstattung“ nicht zutrifft: Kühlschrank [++]\n\nMerkmal 2017-2023:\nKühlschrank [++]\n\nMerkmal >=2024: Kühlschrank, Tiefkühlschrank/-truhe oder Geschirrspüler [++] \n\nJa -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "ojptcg",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Heizung",
                  "block": [
                    {
                      "id": "sm0t8",
                      "type": "Question",
                      "alias": "Küche hat Heizung",
                      "text": "Ist die Küche beheizbar?",
                      "info": "Beachte: Eine Holz- oder Kohleheizung zählt nicht.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "tcod4",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "43bd3",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "36h0m",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nKüche nicht beheizbar oder Holz-/ Kohleheizung [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                    }
                  ]
                },
                {
                  "id": "ar9oa",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Lüftung",
                  "block": [
                    {
                      "id": "i0bh2",
                      "type": "Question",
                      "alias": "Küche hat Lüftung",
                      "text": "Gibt es in Küche ein Fenster oder eine andere Möglichkeit zur Entlüftung?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "tcod4",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "43bd3",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "36h0m",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nKüche ohne Fenster und ohne ausreichende Entlüftung [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "d3xk4",
                      "type": "If",
                      "cases": [
                        {
                          "id": "ohpir",
                          "type": "IfCase",
                          "test": {
                            "id": "f843d",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Küche hat Lüftung"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "tcod4"
                            ]
                          },
                          "block": [
                            {
                              "id": "p16w6",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "11z97k",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "coygt",
                                    "type": "LogicalOperation",
                                    "operator": "and",
                                    "negated": false,
                                    "conditions": [
                                      {
                                        "id": "w0r6o",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Vertragsdatum"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "wejo0k"
                                        ]
                                      },
                                      {
                                        "id": "w0r6o",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Sondermerkmal Moderne Küche"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "uiajj"
                                        ]
                                      }
                                    ]
                                  },
                                  "block": []
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "u62on",
                                  "type": "Question",
                                  "alias": "Küche hat Dunstabzug",
                                  "text": "Ist die Küche von der Vermieterin mit einer Dunstabzugshaube ausgestattet worden?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "tcod4",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "43bd3",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "36h0m",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal (2015):\nNur wenn Sondermerkmal „Moderne Küchenausstattung“ nicht zutrifft:\nDunstabzugshaube [++]\n\nMerkmal (>=2017)\nDunstabzug [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                },
                {
                  "id": "0aqrq",
                  "type": "If",
                  "cases": [
                    {
                      "id": "cv6aw",
                      "type": "IfCase",
                      "test": {
                        "id": "3bnnc",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Vertragsdatum"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "wejo0k",
                          "7np1",
                          "m2jo",
                          "4obam",
                          "oqyrs"
                        ]
                      },
                      "block": []
                    }
                  ],
                  "alternate": [
                    {
                      "id": "x4mjv",
                      "type": "Group",
                      "category": "Section",
                      "alias": "Wände",
                      "block": []
                    },
                    {
                      "id": "ip9f8",
                      "type": "Question",
                      "alias": "Küche ist gefliest",
                      "text": "Sie die Wände um die Arbeitsbereiche in der Küche gefliest oder mit einem anderen Wandbelag bedeckt, den man gut reinigen kann?",
                      "info": "Dies können etwa Silikonfarbe, Linoleum, Edelstahl oder behandeltes Holz sein.\nDabei geht es um die Bereiche, die bei einer normalen Benutzung häufig dreckig werden",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "axcbu",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "jh7gu",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "pxe25",
                            "alias": "nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal >=2024: Keine Wandfliesen oder vergleichbarer Wandschutz im Arbeitsbereich [--]\n\nNein -> Check\nNicht sicher-> nicht sicher"
                    }
                  ]
                },
                {
                  "id": "ckli2",
                  "type": "If",
                  "cases": [
                    {
                      "id": "poeae",
                      "type": "IfCase",
                      "test": {
                        "id": "tewks",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Vertragsdatum"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "wejo0k",
                          "7np1",
                          "m2jo",
                          "4obam",
                          "oqyrs"
                        ]
                      },
                      "block": [
                        {
                          "id": "q2ng4k",
                          "type": "Group",
                          "category": "Section",
                          "alias": "Fußboden",
                          "block": [
                            {
                              "id": "vgdl4",
                              "type": "Question",
                              "alias": "Küche hat hochwertigen Fußboden",
                              "text": "Ist in der Küche von der Vermieterin ein hochwertiger Fußboden verlegt worden?",
                              "info": "Hierzu zählen z.B. hochwertige Fliesen, hochwertiges Linoleum, hochwertiges Feuchtraumlaminat, Parkett oder Terrazzo. Gilt nur, wenn diese auch in einem guten Zustand sind.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "tcod4",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "43bd3",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "36h0m",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015-2023:\nHochwertige Fliesen, hochwertiges Linoleum, hochwertiges Feuchtraum- laminat, Parkett, Terrazzo als Bodenbelag jeweils in gutem Zustand [++]\n\nMerkmal >=2024: \nHochwertige Fliesen, hochwertiges Linoleum, hoch-\nwertiges Feuchtraumlaminat, Parkett, Terrazzo als Bodenbelag jeweils in gutem Zustand (gilt für Baualtersklassen bis einschließlich 2009) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "alternate": [
                    {
                      "id": "zerqeg",
                      "type": "If",
                      "cases": [
                        {
                          "id": "lhvtf",
                          "type": "IfCase",
                          "test": {
                            "id": "4sh92",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Baujahr"
                            },
                            "negated": false,
                            "type": "AnswerNumberComparison",
                            "operator": "lte",
                            "comparands": [
                              {
                                "type": "NumberLiteral",
                                "value": 2009
                              }
                            ]
                          },
                          "block": [
                            {
                              "id": "9786g",
                              "type": "Group",
                              "category": "Section",
                              "alias": "Fußboden",
                              "block": [
                                {
                                  "id": "q1w2wg",
                                  "type": "Question",
                                  "alias": "Küche hat hochwertigen Fußboden",
                                  "text": "Ist in der Küche von der Vermieterin ein hochwertiger Fußboden verlegt worden?",
                                  "info": "Hierzu zählen z.B. hochwertige Fliesen, hochwertiges Linoleum, hochwertiges Feuchtraumlaminat, Parkett oder Terrazzo. Gilt nur, wenn diese auch in einem guten Zustand sind.",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "tcod4",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "43bd3",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "36h0m",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015-2023:\nHochwertige Fliesen, hochwertiges Linoleum, hochwertiges Feuchtraum- laminat, Parkett, Terrazzo als Bodenbelag jeweils in gutem Zustand [++]\n\nMerkmal >=2024: \nHochwertige Fliesen, hochwertiges Linoleum, hoch-\nwertiges Feuchtraumlaminat, Parkett, Terrazzo als Bodenbelag jeweils in gutem Zustand (gilt für Baualtersklassen bis einschließlich 2009) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                }
              ]
            },
            {
              "id": "dppzs",
              "type": "Group",
              "category": "Page",
              "alias": "Wohnung",
              "block": [
                {
                  "id": "y14j9f",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Räume",
                  "block": [
                    {
                      "id": "p9z7w",
                      "type": "Question",
                      "alias": "Wohnung hat großen Wohnraum",
                      "text": "Gibt es in der Wohnung einen Wohnraum der größer als 40qm ist?",
                      "info": "Beachte: Eine Wohnküche zählt nicht als Wohnraum.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nEin Wohnraum größer als 40 m2 [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "22o7p",
                      "type": "If",
                      "cases": [
                        {
                          "id": "76rjh",
                          "type": "IfCase",
                          "test": {
                            "id": "db3akf",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k",
                              "7np1",
                              "m2jo",
                              "4obam",
                              "oqyrs",
                              "ve0tek"
                            ]
                          },
                          "block": [
                            {
                              "id": "w12vs",
                              "type": "Question",
                              "alias": "Wohnung hat Abstellraum",
                              "text": "Gibt es innerhalb der Wohnung einen Abstellraum oder Einbauschrank?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015-2026:\nEinbauschrank oder Abstellraum innerhalb der Wohnung [++]\n\nMerkmal >=2026:\nAbstellraum innerhalb der Wohnung (mind. 1 m² Grundfläche) oder Einbauschrank [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "10u0w",
                          "type": "Question",
                          "alias": "Wohnung hat Abstellraum",
                          "text": "Gibt es innerhalb der Wohnung einen Abstellraum (mind. 1 m² Grundfläche) oder Einbauschrank?",
                          "info": null,
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal 2015-2026:\nEinbauschrank oder Abstellraum innerhalb der Wohnung [++]\n\nMerkmal >=2026:\nAbstellraum innerhalb der Wohnung (mind. 1 m² Grundfläche) oder Einbauschrank [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    },
                    {
                      "id": "kf62u",
                      "type": "Question",
                      "alias": "Wohnung hat Durchgangszimmer",
                      "text": "Gibt es in der Wohnung ein gefangenes Zimmer oder Durchgangszimmer?",
                      "info": "Ein Durchgangszimmer ist ein Zimmer, durch welches man durchgehen muss um in ein weiteres Zimmer zu kommen. In das dahinterliegende Zimmer darf man also nicht vom Flur aus kommen. Dieses Merkmal ist auch bei einer Einzimmerwohnung gegeben, bei welcher man die Küche nur durch das Wohn- /Schlafzimmer betreten kann.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nSchlechter Schnitt (z.B. gefangener Raum und/oder Durchgangsraum) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    }
                  ]
                },
                {
                  "id": "ojxekl",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Außenbereich",
                  "block": [
                    {
                      "id": "p9mx6j",
                      "type": "Question",
                      "alias": "Wohnung hat Balkon",
                      "text": "Hat die Wohnung einen Außenbereich, wie z.B. Balkon, (Dach-)Terrasse, Loggia, Wintergarten oder Dachgarten?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "tcod4",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "43bd3",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "36h0m",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": ""
                    },
                    {
                      "id": "0yy1s",
                      "type": "If",
                      "cases": [
                        {
                          "id": "e3xzt",
                          "type": "IfCase",
                          "test": {
                            "id": "siz92",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Wohnung hat Balkon"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "tcod4"
                            ]
                          },
                          "block": [
                            {
                              "id": "et74u",
                              "type": "Question",
                              "alias": "Wohnung hat großen Balkon",
                              "text": "Ist dieser Außenbereich mindestens 4qm groß?",
                              "info": "Beachte: Wenn die Wohnung mehrere Balkone (oder ähnliches) hat, wird deren Fläche nicht zusammengerechnet.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "tcod4",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "43bd3",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "36h0m",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal:\nGroßer, geräumiger Balkon, (Dach-) Terrasse, Loggia oder Wintergarten (ab 4 m2) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        },
                        {
                          "id": "x814c",
                          "type": "IfCase",
                          "test": {
                            "id": "t0sbu",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Wohnung hat Balkon"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "43bd3",
                              "36h0m"
                            ]
                          },
                          "block": [
                            {
                              "id": "1mhrk",
                              "type": "Question",
                              "alias": "Wohnung keinen Balkon weil unmöglich",
                              "text": "Gibt es bauliche oder rechtliche Gründe, weshalb ein Außenbereich (wie z.B. ein Balkon) nicht möglich ist?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "tcod4",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "43bd3",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "36h0m",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nKein Balkon (das Merkmal gilt nicht, wenn der Balkon aus baulichen und/oder rechtlichen Gründen nicht möglich oder nicht zulässig ist) [--]\n\nMerkmal >= 2017:\nKein Balkon, (Dach-)Terrasse, Loggia und Winter-/Dachgarten (gilt nicht, wenn das Merkmal aus baulichen und/oder rechtlichen Gründen nicht möglich oder nicht zulässig ist) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                },
                {
                  "id": "59irc",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Fenster",
                  "block": [
                    {
                      "id": "cy75x",
                      "type": "Question",
                      "alias": "Wohnung hat einfach verglaste Fenster",
                      "text": "Sind in der Wohnung überwiegend einfach verglaste Fenster verbaut?",
                      "info": "Beachte: Die in Altbau typischen Doppelkastenfenstern gelten nicht als Einfachverglasung.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "tcod4",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "43bd3",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "36h0m",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal 2015-2023:\nÜberwiegend Einfachverglasung [--]\n\nMerkmal >=2024:\nÜberwiegend Fenster mit Einfachverglasung (Doppel-Kastenfenster sind nicht gemeint) [--]\n\nJa -> Check\nNicht sicher -> Check"
                    },
                    {
                      "id": "wvdjy",
                      "type": "If",
                      "note": "Wenn die Wohnung überwiegend einfach verglaste Fenster hat, ist die Frage zu Schall- und Wärmeschutzfenster nicht mehr notwenig.",
                      "cases": [
                        {
                          "id": "6pkpb",
                          "type": "IfCase",
                          "test": {
                            "id": "g5bu6",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Wohnung hat einfach verglaste Fenster"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "43bd3",
                              "36h0m"
                            ]
                          },
                          "block": [
                            {
                              "id": "kp48i",
                              "type": "If",
                              "note": "",
                              "cases": [
                                {
                                  "id": "22yywl",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "rmq0a",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "te85i",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "drm9a",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "kxyvi",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Sondermerkmal Schallschutzfenster"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "uiajj"
                                            ]
                                          },
                                          "block": []
                                        }
                                      ],
                                      "alternate": [
                                        {
                                          "id": "g6atu",
                                          "type": "Question",
                                          "alias": "Wohnung hat Schallschutzfenster",
                                          "text": "Sind in der Wohnung überwiegend Fenster mit Wärmeschutzverglasung (Einbau ab 1987) oder Schallschutzfenster verbaut?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "tcod4",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "43bd3",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "36h0m",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Überwiegend Isolierverglasung (ab 1987) oder Schallschutzfenster“ nicht zutrifft\nÜberwiegend Isolierverglasung (Einbau ab 1987) oder Schallschutzfenster [++]\n\nMerkmal 2017:\nÜberwiegend Wärmeschutzverglasung (Einbau ab 1995) oder Schallschutzfenster für Wohngebäude/Wohnungen, die vor 1995 bezugsfertig geworden sind [++]\n\nMerkmal 2019-2024:\nWohngebäude/Wohnungen die vor 2002 bezugsfertig geworden sind: überwiegend Wärmeschutzverglasung (Einbau ab 2002) oder Schallschutzfenster [++]\n\nMerkmal >=2026:\nWohngebäude/Wohnungen die vor 2002 bezugsfertig geworden sind: überwiegend Wärmeschutzverglasung oder Schallschutzfenster (jeweils Einbau ab 2002)\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  "id": "ykyr4",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "rmq0a",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "7np1"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "mjpxu",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "jiueu",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "dgby8g",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "lt",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 1995
                                              }
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "p7l6ch",
                                              "type": "Question",
                                              "alias": "Wohnung hat Schallschutzfenster",
                                              "text": "Sind in der Wohnung überwiegend Fenster mit Wärmeschutzverglasung (Einbau ab 1995) oder Schallschutzfenster verbaut?",
                                              "info": null,
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "tcod4",
                                                    "alias": "Ja",
                                                    "text": "Ja"
                                                  },
                                                  {
                                                    "id": "43bd3",
                                                    "alias": "Nein",
                                                    "text": "Nein"
                                                  },
                                                  {
                                                    "id": "36h0m",
                                                    "alias": "Nicht sicher",
                                                    "text": "Ich bin mir nicht sicher"
                                                  }
                                                ]
                                              },
                                              "required": false,
                                              "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Überwiegend Isolierverglasung (ab 1987) oder Schallschutzfenster“ nicht zutrifft\nÜberwiegend Isolierverglasung (Einbau ab 1987) oder Schallschutzfenster [++]\n\nMerkmal 2017:\nÜberwiegend Wärmeschutzverglasung (Einbau ab 1995) oder Schallschutzfenster für Wohngebäude/Wohnungen, die vor 1995 bezugsfertig geworden sind [++]\n\nMerkmal 2019-2024:\nWohngebäude/Wohnungen die vor 2002 bezugsfertig geworden sind: überwiegend Wärmeschutzverglasung (Einbau ab 2002) oder Schallschutzfenster [++]\n\nMerkmal >=2026:\nWohngebäude/Wohnungen die vor 2002 bezugsfertig geworden sind: überwiegend Wärmeschutzverglasung oder Schallschutzfenster (jeweils Einbau ab 2002)\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                            }
                                          ]
                                        }
                                      ],
                                      "alternate": []
                                    }
                                  ]
                                },
                                {
                                  "id": "pnx4t",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "ozknbk",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "m2jo",
                                      "4obam",
                                      "oqyrs",
                                      "ve0tek"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "bmn2kf",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "b2zbfj",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "xsbby",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "lt",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 2002
                                              }
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "opdsj",
                                              "type": "Question",
                                              "alias": "Wohnung hat Schallschutzfenster",
                                              "text": "Sind in der Wohnung überwiegend Fenster mit Wärmeschutzverglasung (Einbau ab 2002) oder Schallschutzfenster verbaut?",
                                              "info": null,
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "tcod4",
                                                    "alias": "Ja",
                                                    "text": "Ja"
                                                  },
                                                  {
                                                    "id": "43bd3",
                                                    "alias": "Nein",
                                                    "text": "Nein"
                                                  },
                                                  {
                                                    "id": "36h0m",
                                                    "alias": "Nicht sicher",
                                                    "text": "Ich bin mir nicht sicher"
                                                  }
                                                ]
                                              },
                                              "required": false,
                                              "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Überwiegend Isolierverglasung (ab 1987) oder Schallschutzfenster“ nicht zutrifft\nÜberwiegend Isolierverglasung (Einbau ab 1987) oder Schallschutzfenster [++]\n\nMerkmal 2017:\nÜberwiegend Wärmeschutzverglasung (Einbau ab 1995) oder Schallschutzfenster für Wohngebäude/Wohnungen, die vor 1995 bezugsfertig geworden sind [++]\n\nMerkmal 2019-2024:\nWohngebäude/Wohnungen die vor 2002 bezugsfertig geworden sind: überwiegend Wärmeschutzverglasung (Einbau ab 2002) oder Schallschutzfenster [++]\n\nMerkmal >=2026:\nWohngebäude/Wohnungen die vor 2002 bezugsfertig geworden sind: überwiegend Wärmeschutzverglasung oder Schallschutzfenster (jeweils Einbau ab 2002)\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                            }
                                          ]
                                        }
                                      ],
                                      "alternate": []
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "uavu7",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "r3w29",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "xhijb",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lt",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 2002
                                          }
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "g2zbei",
                                          "type": "Question",
                                          "alias": "Wohnung hat Schallschutzfenster",
                                          "text": "Sind in der Wohnung überwiegend Fenster mit Wärmeschutzverglasung oder Schallschutzfenster verbaut (jeweils Einbau ab 2002)?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "tcod4",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "43bd3",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "36h0m",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Überwiegend Isolierverglasung (ab 1987) oder Schallschutzfenster“ nicht zutrifft\nÜberwiegend Isolierverglasung (Einbau ab 1987) oder Schallschutzfenster [++]\n\nMerkmal 2017:\nÜberwiegend Wärmeschutzverglasung (Einbau ab 1995) oder Schallschutzfenster für Wohngebäude/Wohnungen, die vor 1995 bezugsfertig geworden sind [++]\n\nMerkmal 2019-2024:\nWohngebäude/Wohnungen die vor 2002 bezugsfertig geworden sind: überwiegend Wärmeschutzverglasung (Einbau ab 2002) oder Schallschutzfenster [++]\n\nMerkmal >=2026:\nWohngebäude/Wohnungen die vor 2002 bezugsfertig geworden sind: überwiegend Wärmeschutzverglasung oder Schallschutzfenster (jeweils Einbau ab 2002)\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    },
                    {
                      "id": "5ympj",
                      "type": "Question",
                      "alias": "Wohnung hat Rollläden",
                      "text": "Sind die Fenster überwiegend mit Rollläden ausgestattet?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "tcod4",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "43bd3",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "36h0m",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nRollläden [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    }
                  ]
                },
                {
                  "id": "356xe",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Wände, Decke und Boden",
                  "block": [
                    {
                      "id": "ttqu4",
                      "type": "Question",
                      "alias": "Wohnung hat aufwendige Wand- und Deckenverkleidung",
                      "text": "Gibt es in der Mehrzahl der Wohnräume eine aufwändige Decken- oder Wandverkleidung in einem guten Zustand?",
                      "info": "Hierzu zählt z.B. Stuck oder Täfelung",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal 2015:\nAufwändige Deckenverkleidung (z.B. Stuck) oder getäfelte Wandverkleidung in gutem Zustand in der überwiegenden Anzahl der Wohnräume [++]\n\nMerkmal >=2017:\nAufwändige Decken- und/oder Wandverkleidung (z.B. Stuck, Täfelung) in gutem Zustand in der überwiegenden Anzahl der Wohnräume [++]\n"
                    },
                    {
                      "id": "g6u3t",
                      "type": "If",
                      "cases": [
                        {
                          "id": "9y4kai",
                          "type": "IfCase",
                          "test": {
                            "id": "cg4fv",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "zep1v",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "qqqtd",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "b392xf",
                                    "type": "LogicalOperation",
                                    "operator": "or",
                                    "negated": false,
                                    "conditions": [
                                      {
                                        "id": "snuyi",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 1964
                                          }
                                        ]
                                      },
                                      {
                                        "id": "xu8xi",
                                        "type": "LogicalOperation",
                                        "operator": "and",
                                        "negated": false,
                                        "conditions": [
                                          {
                                            "id": "snuyi",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "gte",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 1973
                                              }
                                            ]
                                          },
                                          {
                                            "id": "snuyi",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "lte",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 1990
                                              }
                                            ]
                                          },
                                          {
                                            "id": "snuyi",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Ost"
                                            },
                                            "negated": false,
                                            "type": "AnswerBooleanComparison",
                                            "operator": "is",
                                            "value": false
                                          }
                                        ]
                                      },
                                      {
                                        "id": "xu8xi",
                                        "type": "LogicalOperation",
                                        "operator": "and",
                                        "negated": false,
                                        "conditions": [
                                          {
                                            "id": "snuyi",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "gte",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 1991
                                              }
                                            ]
                                          },
                                          {
                                            "id": "snuyi",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "lte",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 2002
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "block": []
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "2j5cv",
                                  "type": "Question",
                                  "alias": "Wohnung hat hochwertigen Bodenbelag",
                                  "text": "Gibt es in der überwiegenden Anzahl der Wohnräume einen hochwertigen Bodenbelag?",
                                  "info": "Hierzu zählt z.B. Parkett, Natur-/Kunststein, Fliesen oder gleichwertiger Bodenbelag",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Hochwertiges Parkett, Natur- /Kunststein, Fliesen oder gleichwertiger Boden/-belag in der überwiegenden Zahl der Wohnräume“ nicht zutrifft Hochwertiges Parkett, Natur-/Kunststein, Fliesen oder gleichwertiger Boden/-belag in der überwiegenden Zahl der Wohnräume [++]\n\nMerkmal >=2017:\nHochwertiges Parkett, Natur- /Kunststein, Fliesen oder gleichwertiger Boden/-belag in der überwie- genden Zahl der Wohnräume [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "id": "7o1qx",
                          "type": "IfCase",
                          "test": {
                            "id": "6m0tx",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "7np1",
                              "m2jo",
                              "4obam",
                              "oqyrs",
                              "ve0tek"
                            ]
                          },
                          "block": [
                            {
                              "id": "qim56",
                              "type": "Question",
                              "alias": "Wohnung hat hochwertigen Bodenbelag",
                              "text": "Gibt es in der überwiegenden Anzahl der Wohnräume einen hochwertigen Bodenbelag?",
                              "info": "Hierzu zählt z.B. Parkett, Natur-/Kunststein, Fliesen oder gleichwertiger Bodenbelag",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Hochwertiges Parkett, Natur- /Kunststein, Fliesen oder gleichwertiger Boden/-belag in der überwiegenden Zahl der Wohnräume“ nicht zutrifft Hochwertiges Parkett, Natur-/Kunststein, Fliesen oder gleichwertiger Boden/-belag in der überwiegenden Zahl der Wohnräume [++]\n\nMerkmal 2017-2024:\nHochwertiges Parkett, Natur- /Kunststein, Fliesen oder gleichwertiger Boden/-belag in der überwiegenden Zahl der Wohnräume [++]\n\nMerkmal >=2026:\nHochwertiges Parkett, Natur-/Kunststein, Fliesen oder gleichwertiger Boden/-belag in der überwiegenden Zahl der Wohnräume (inklusive Flur, ohne Küche, ohne Bad) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher\n\n"
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "f36vl",
                          "type": "Question",
                          "alias": "Wohnung hat hochwertigen Bodenbelag",
                          "text": "Gibt es in der überwiegenden Anzahl der Wohnräume (inkl. Flur, ohne Küche, ohne Bad) einen hochwertigen Bodenbelag?",
                          "info": "Hierzu zählt z.B. Parkett, Natur-/Kunststein, Fliesen oder gleichwertiger Bodenbelag",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Hochwertiges Parkett, Natur- /Kunststein, Fliesen oder gleichwertiger Boden/-belag in der überwiegenden Zahl der Wohnräume“ nicht zutrifft Hochwertiges Parkett, Natur-/Kunststein, Fliesen oder gleichwertiger Boden/-belag in der überwiegenden Zahl der Wohnräume [++]\n\nMerkmal 2017-2024:\nHochwertiges Parkett, Natur- /Kunststein, Fliesen oder gleichwertiger Boden/-belag in der überwiegenden Zahl der Wohnräume [++]\n\nMerkmal >=2026:\nHochwertiges Parkett, Natur-/Kunststein, Fliesen oder gleichwertiger Boden/-belag in der überwiegenden Zahl der Wohnräume (inklusive Flur, ohne Küche, ohne Bad) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher\n\n"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "9bgrb",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Heizung & Sanitär",
                  "block": [
                    {
                      "id": "vn7mj",
                      "type": "Question",
                      "alias": "Wohnung hat Fußbodenheizung",
                      "text": "Ist in der Wohnung überwiegend eine Fußbodenheizung verbaut?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nÜberwiegend Fußbodenheizung [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "dy6a5",
                      "type": "If",
                      "cases": [
                        {
                          "id": "zenu1",
                          "type": "IfCase",
                          "test": {
                            "id": "gr18z",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k",
                              "7np1",
                              "m2jo",
                              "4obam",
                              "oqyrs"
                            ]
                          },
                          "block": [
                            {
                              "id": "zuq80j",
                              "type": "Question",
                              "alias": "Wohnung hat sichtbare Heizungsrohe",
                              "text": "Sind die Heizungsrohre überwiegend sichtbar verlegt?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nHeizungsrohre überwiegend unter Putz [++]\n\nMerkmal 2017-2023:\nHeizungsrohre überwiegend nicht sichtbar [++]\n\nMerkmal 2024:\nHeizungsrohre überwiegend nicht sichtbar (gilt für\nBaualtersklassen bis einschließlich 1990) [++]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "a62l4",
                          "type": "If",
                          "cases": [
                            {
                              "id": "ok8gf",
                              "type": "IfCase",
                              "test": {
                                "id": "bh3fof",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lte",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 1990
                                  }
                                ]
                              },
                              "block": [
                                {
                                  "id": "dmazi",
                                  "type": "Question",
                                  "alias": "Wohnung hat sichtbare Heizungsrohe",
                                  "text": "Sind die Heizungsrohre überwiegend sichtbar verlegt?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015:\nHeizungsrohre überwiegend unter Putz [++]\n\nMerkmal 2017-2023:\nHeizungsrohre überwiegend nicht sichtbar [++]\n\nMerkmal 2024:\nHeizungsrohre überwiegend nicht sichtbar (gilt für\nBaualtersklassen bis einschließlich 1990) [++]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        }
                      ]
                    },
                    {
                      "id": "pgwm8",
                      "type": "Question",
                      "alias": "Wohnnung hat sichtbare Bewässerungsleitungen",
                      "text": "Sind die Be- und Entwässerungleitungen überwiegend sichtbar verlegt?",
                      "info": "Zu den Be- und Entwässerungleitungen gehören zum Beispiel Wasserleitungen im Badezimmer, der Küche oder zu einer Therme.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nBe- und Entwässerungsinstallation überwiegend auf Putz [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "krf7z",
                      "type": "Question",
                      "alias": "Wohnung kann Waschmaschiene",
                      "text": "Ist es möglich eine Waschmaschine in der Küche oder dem Bad aufzustellen und anzuschließen?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nWaschmaschine weder in Bad noch Küche stellbar oder nicht anschließbar [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                    }
                  ]
                },
                {
                  "id": "ghffw",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Elektronik",
                  "block": [
                    {
                      "id": "35hw",
                      "type": "Question",
                      "alias": "Wohnung hat nicht sichtbare Elektroinstallation",
                      "text": "Verlaufen die Stromkabel in der Wohnung überwiegend innerhalb der Wand?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nElektroinstallation überwiegend sichtbar auf Putz [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "4ki3hk",
                      "type": "If",
                      "cases": [
                        {
                          "id": "56hd6",
                          "type": "IfCase",
                          "test": {
                            "id": "4eki",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "wware",
                              "type": "Question",
                              "alias": "Wohnung hat ausreichende Elektroinstallation",
                              "text": "Ist es möglich zwei oder mehr größere haushaltsübliche Elektrogeräten (z.B. Waschmaschine und Staubsauger) gleichzeitiger zu betreiben?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nUnzureichende Elektroinstallation: Kein gleichzeitiger Betrieb von mindestens zwei haushaltsüblichen größeren Elektrogeräten (z.B. Waschmaschine und Staubsauger) möglich oder weniger als zwei Steckdosen in Wohnräumen [--]\n\nMerkmal >=2017:\nUnzureichende Elektroinstallation, z.B. keine ausreichende Elektrosteigeleitung und/oder VDE-gerechte Elektroinstallation (z.B. kein FI- Schalter, Potentialausgleich) [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                            },
                            {
                              "id": "fwfgwh",
                              "type": "Question",
                              "alias": "Wohnung hat Raum mit <2 Steckdosen",
                              "text": "Gibt es einen Wohnraum, der weniger als zwei Steckdosen hat?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nUnzureichende Elektroinstallation: Kein gleichzeitiger Betrieb von mindestens zwei haushaltsüblichen größeren Elektrogeräten (z.B. Waschmaschine und Staubsauger) möglich oder weniger als zwei Steckdosen in Wohnräumen [--]\n\nMerkmal >=2017:\nUnzureichende Elektroinstallation, z.B. keine ausreichende Elektrosteigeleitung und/oder VDE-gerechte Elektroinstallation (z.B. kein FI- Schalter, Potentialausgleich) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "cge4ck",
                          "type": "Question",
                          "alias": "Wohnung hat ausreichende Elektroinstallation",
                          "text": "Ist in der Wohnung eine ausreichende Elektroinstallation verbaut?",
                          "info": "Eine Elektronistallation gilt als nicht ausreichend, wenn es z.B. keinen FI-Schalter, keinen Potentialausgleich, keine ausreichende Elektrosteigeleitung oder regelmäßige Stromausfälle gibt.",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal 2015:\nUnzureichende Elektroinstallation: Kein gleichzeitiger Betrieb von mindestens zwei haushaltsüblichen größeren Elektrogeräten (z.B. Waschmaschine und Staubsauger) möglich oder weniger als zwei Steckdosen in Wohnräumen [--]\n\nMerkmal >=2017:\nUnzureichende Elektroinstallation, z.B. keine ausreichende Elektrosteigeleitung und/oder VDE-gerechte Elektroinstallation (z.B. kein FI- Schalter, Potentialausgleich) [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "7c3jh",
                  "type": "If",
                  "cases": [
                    {
                      "id": "g5eejk",
                      "type": "IfCase",
                      "test": {
                        "id": "m0des",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Vertragsdatum"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "wejo0k"
                        ]
                      },
                      "block": [
                        {
                          "id": "pqmes",
                          "type": "Group",
                          "category": "Section",
                          "alias": "Internet & Fernsehen",
                          "block": [
                            {
                              "id": "x5vwbh",
                              "type": "Question",
                              "alias": "Wohnung hat Kabelanschluss",
                              "text": "Gibt es einen Kabelanschluss für den Fernseher oder eine Gemeinschaftssatelliten- oder Antennenanlage?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nWeder Breitbandkabelanschluss noch Gemeinschaftssatelliten-/Antennenanlage [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                            },
                            {
                              "id": "ool7rl",
                              "type": "Question",
                              "alias": "Wohnung hat Internetanschluss",
                              "text": "Gibt es in der Wohnung einen Anschluss zum Internet?",
                              "info": "Beachte: Dies gilt nicht vor, wenn der Mieter durch diesen automatisch vertraglich gebunden ist.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nRückkanalfähiger Breitbandkabelanschluss (Nutzung ohne zusätzliche vertragliche Bindung des Mieters mit Dritten) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "alternate": []
                },
                {
                  "id": "fo1tv",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Weitere Fragen",
                  "block": [
                    {
                      "id": "2hckt",
                      "type": "Question",
                      "alias": "Wohnung ist barrierearm",
                      "text": "Ist die Wohnung barrierearm?",
                      "info": "Dies ist erfüllt, wenn Wohnung schwellenfrei ist, der Übergang zu Balkon oder Dachterasse schwellenarm ist, ausreichende Bewegungsfreiheit in Wohnung gegeben ist, und das Bad barreierearm gestaltet ist.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nBarrierearme Wohnungsgestaltung (Schwellenfreiheit in der Wohnung, schwellenarmer Übergang zu Balkon/Terrasse, ausreichende Bewegungsfreiheit in der Wohnung und/oder barrierearme Badgestaltung) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "7k2hi",
                      "type": "If",
                      "cases": [
                        {
                          "id": "4ztj6",
                          "type": "IfCase",
                          "test": {
                            "id": "683tk",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": []
                        }
                      ],
                      "alternate": [
                        {
                          "id": "1rtk3",
                          "type": "Question",
                          "alias": "Wohnung hat verstärkte Tür",
                          "text": "Ist die Wohnungstür verstärkt und verfügt über eine zusätzliche Einbruchsicherung, wie z.B. hochwertige Sperrbügel oder Türschlösser mit Mehrfachverriegelung?",
                          "info": null,
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal >=2019:\nZusätzliche Einbruchssicherung für die Wohnungstür (z.B. hochwertige Sperrbügel und/oder Türschlösser mit Mehrfachverriegelung) bei verstärkten Türen [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    },
                    {
                      "id": "0essm",
                      "type": "If",
                      "cases": [
                        {
                          "id": "re2v2",
                          "type": "IfCase",
                          "test": {
                            "id": "w32o4",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k",
                              "7np1",
                              "m2jo",
                              "4obam",
                              "oqyrs",
                              "ve0tek"
                            ]
                          },
                          "block": []
                        }
                      ],
                      "alternate": [
                        {
                          "id": "3vb8m",
                          "type": "Question",
                          "alias": "Wohnung im Erdgeschoss",
                          "text": "Liegt die Wohnung im Ergeschoss?",
                          "info": null,
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "hgtwu",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "wf5y3g",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "yiqwb",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": true
                        },
                        {
                          "id": "gw7yj",
                          "type": "If",
                          "cases": [
                            {
                              "id": "acxzyl",
                              "type": "IfCase",
                              "test": {
                                "id": "s31pmg",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Wohnung im Erdgeschoss"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "hgtwu",
                                  "yiqwb"
                                ]
                              },
                              "block": [
                                {
                                  "id": "1g6mr",
                                  "type": "Question",
                                  "alias": "Wohnung hat Einbruchsicherung oder Sichtschutz",
                                  "text": "Hat die Wohnung ein Einbruchs- oder Sichtschutzsystem an allen Fenstern der Wohnung (z. B. Gitter, Rollläden, Fensteralarm)?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "hgtwu",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "wf5y3g",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "yiqwb",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": true,
                                  "note": "Merkmal >=2026:\nBei Erdgeschosswohnung: Kein Einbruchs- und/oder Sichtschutzsystem an allen Fenstern der Wohnung\n(z. B. Gitter, Rollläden, Fensteralarm) [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        }
                      ]
                    },
                    {
                      "id": "st50e",
                      "type": "If",
                      "cases": [
                        {
                          "id": "q7ioqk",
                          "type": "IfCase",
                          "test": {
                            "id": "e54yj",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "atmjv",
                              "type": "Question",
                              "alias": "Wohnung hat Kaltwasserzähler",
                              "text": "Hat die Wohnung einen wohnungsbezogenen Kaltwasserzähler?",
                              "info": "Ein wohnungbezogener Kaltwasserzähler ermöglicht den Wasserverbrauch jeder Wohnung einzeln zu messen und somit auch die Wasserkosten für jede Wohnung einzeln abzurechnen.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": ""
                            }
                          ]
                        },
                        {
                          "id": "9or9e",
                          "type": "IfCase",
                          "test": {
                            "id": "e54yj",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "7np1"
                            ]
                          },
                          "block": [
                            {
                              "id": "djk2yi",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "cj48n",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "xlzx4",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Baujahr"
                                    },
                                    "negated": false,
                                    "type": "AnswerNumberComparison",
                                    "operator": "lt",
                                    "comparands": [
                                      {
                                        "type": "NumberLiteral",
                                        "value": 1998
                                      }
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "0e2adl",
                                      "type": "Question",
                                      "alias": "Wohnung hat Kaltwasserzähler",
                                      "text": "Hat die Wohnung einen wohnungsbezogenen Kaltwasserzähler?",
                                      "info": "Ein wohnungbezogener Kaltwasserzähler ermöglicht den Wasserverbrauch jeder Wohnung einzeln zu messen und somit auch die Wasserkosten für jede Wohnung einzeln abzurechnen.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": ""
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            }
                          ]
                        },
                        {
                          "id": "uble",
                          "type": "IfCase",
                          "test": {
                            "id": "fsjpek",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "m2jo",
                              "4obam",
                              "oqyrs"
                            ]
                          },
                          "block": [
                            {
                              "id": "do9fh",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "mpdsn",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "v539b",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Baujahr"
                                    },
                                    "negated": false,
                                    "type": "AnswerNumberComparison",
                                    "operator": "lt",
                                    "comparands": [
                                      {
                                        "type": "NumberLiteral",
                                        "value": 1991
                                      }
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "qncu1",
                                      "type": "Question",
                                      "alias": "Wohnung hat Kaltwasserzähler",
                                      "text": "Hat die Wohnung einen wohnungsbezogenen Kaltwasserzähler?",
                                      "info": "Ein wohnungbezogener Kaltwasserzähler ermöglicht den Wasserverbrauch jeder Wohnung einzeln zu messen und somit auch die Wasserkosten für jede Wohnung einzeln abzurechnen.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": ""
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    },
                    {
                      "id": "i0xm5",
                      "type": "If",
                      "cases": [
                        {
                          "id": "bd8vr",
                          "type": "IfCase",
                          "test": {
                            "id": "6e3j6",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Wohnung hat Kaltwasserzähler"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "uiajj"
                            ]
                          },
                          "block": [
                            {
                              "id": "4r68yi",
                              "type": "Question",
                              "alias": "Mieter zahlt für Kaltwasserzähler",
                              "text": "Zahlt die Mieterin der Wohnung die Kosten für die Miete des wohnungbezogenen Kaltwasserzählers?",
                              "info": "Falls dies der Fall ist, findest du die Kosten hierfür in der Betriebskostenabrechnung.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nWohnungsbezogener Kaltwasserzähler, wenn der Mieter nicht die Kosten für Miete oder Leasing im Rahmen der Betriebskosten trägt [++]\n\nMerkmal 2017:\nWohnungsbezogener Kaltwasserzähler in vor 1998 bezugsfertigen Gebäuden/ Wohnungen, wenn der Mieter nicht die Kosten für Miete oder Leasing im Rahmen der Betriebskosten trägt [++]\n\nMerkmal 2019-2023:\nWohnungsbezogener Kaltwasserzähler in vor 1991 bezugsfertigen Gebäuden/ Wohnungen, wenn der Mieter nicht die Kosten für Miete oder Leasing im Rahmen der Betriebskosten trägt [++]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                }
              ]
            },
            {
              "id": "iwbfc",
              "type": "Group",
              "category": "Page",
              "alias": "Gebäude",
              "block": [
                {
                  "id": "51snk",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Haustür",
                  "block": [
                    {
                      "id": "j33tt",
                      "type": "Question",
                      "alias": "Gebäude Hauseingangstür ist nicht abschließbar",
                      "text": "Ist es jederzeit möglich ohne Schlüssel bis zu deiner Wohnungstür zu kommen?",
                      "info": "Dies ist etwa der Fall wenn das Treppenhaus keine Eingangstür hat. Es reicht nicht aus, dass der Gebäude-Eingang kurzzeitig kaputt ist.\nWenn du im Hinterhaus wohnst, reicht es wenn man das Vorderhaus abschließen kannst.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal 2015-2023:\nHauseingangstür nicht abschließbar [--]\n\nMerkmal 2024:\nJederzeit von außen frei zugänglicher Hauseingang [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "h19i5g",
                      "type": "If",
                      "cases": [
                        {
                          "id": "2pi3dk",
                          "type": "IfCase",
                          "test": {
                            "id": "jrapd",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "t608xk",
                              "type": "Question",
                              "alias": "Gebäude hat sichere Haustür",
                              "text": "Hat das Gebäude eine einbruchssichere Haustür?",
                              "info": "Hierzu zählt z.B. mehrere Schließbolzen, automatische Alarmanlage oder Aufbohrschutz",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nEinbruchhemmende Wohnungs- und Haustür (zusätzliche moderne Einbruchsicherungsmaßnahmen) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    },
                    {
                      "id": "5mf28",
                      "type": "Question",
                      "alias": "Gebäude hat Gegensprechanlage",
                      "text": "Gibt es eine Gegensprechanlage mit elektrischem Türöffner?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nKeine Gegen-/Wechselsprechanlage mit elektrischem Türöffner [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "31sbj",
                      "type": "If",
                      "cases": [
                        {
                          "id": "ttwkq",
                          "type": "IfCase",
                          "test": {
                            "id": "28a0gl",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Gebäude hat Gegensprechanlage"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "uiajj"
                            ]
                          },
                          "block": [
                            {
                              "id": "x8vlc",
                              "type": "Question",
                              "alias": "Gebäude hat Gegensprechanlage mit Kamera",
                              "text": "Hat die Gegensprechanlage eine Kamera?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal:\nGegen-/Wechselsprechanlage mit Videokontakt und elektrischem Türöffner [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                },
                {
                  "id": "uc0pq",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Treppenhaus & Eingangsbereich",
                  "block": [
                    {
                      "id": "waxnyf",
                      "type": "Question",
                      "alias": "Gebäude hat Treppenhaus in schlechtem Zustand",
                      "text": "Sind das Treppenhaus oder der Eingangsbereich stark abgenutzt und renovierungsbedürftig?",
                      "info": null,
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nTreppenhaus/Eingangsbereich überwiegend in schlechtem Zustand [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "wjiesi",
                      "type": "If",
                      "cases": [
                        {
                          "id": "n9fre",
                          "type": "IfCase",
                          "test": {
                            "id": "q125r",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Gebäude hat Treppenhaus in schlechtem Zustand"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "qzhja",
                              "8i22j"
                            ]
                          },
                          "block": [
                            {
                              "id": "s3up4",
                              "type": "Question",
                              "alias": "Gebäude hat Treppenhaus in gutem Zustand",
                              "text": "Sind das Treppenhaus und der Eingangsbereich hochwertig saniert oder repräsentativ?",
                              "info": "Beachte: Nur ein guter Zustand reicht nicht aus. Anzeichen für repräsentatives Treppenhaus oder Eingangsbereich sind z.B.: Läufer im gesamten Bereich, Marmor, Spiegel, aufwändige Wand- und Deckengestaltung.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal:\nRepräsentativer/s oder hochwertig sanierter/s Eingangsbereich/Treppenhaus (z.B. Spiegel, Marmor, exklusive Beleuchtung, hochwertiger Anstrich / Wandbelag, Läufer im gesamten Flur- und Treppenbereich) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                },
                {
                  "id": "g3886",
                  "type": "If",
                  "cases": [
                    {
                      "id": "3q7ky",
                      "type": "IfCase",
                      "test": {
                        "id": "uzqd2",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Vertragsdatum"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "wejo0k",
                          "7np1",
                          "m2jo",
                          "4obam",
                          "oqyrs"
                        ]
                      },
                      "block": []
                    }
                  ],
                  "alternate": [
                    {
                      "id": "h4hrn",
                      "type": "Group",
                      "category": "Section",
                      "alias": "Barrierefreiheit",
                      "block": [
                        {
                          "id": "ft3tfh",
                          "type": "Question",
                          "alias": "Gebäude hat schwellenarmen Zugang",
                          "text": "Ist ein schwellenarmer Zugang zum Gebäude (max. 1 Stufe) und der Wohnung (max. 1 Stufe) möglich?",
                          "info": "Beachte: Es kommt nicht darauf an, dass du auf den schwellenarmen Zugang angewiesen bist.",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "msxpi",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "w5whii",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "pbcku",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal >=2024:\nSchwellenarmer Zugang zum Gebäude (max. eine Stufe)\nund zur Wohnung einschließlich Treppenhaus (max. eine\nStufe) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "5sfu2",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Gebäude",
                  "block": [
                    {
                      "id": "1b9mt",
                      "type": "Question",
                      "alias": "Gebäude ist in schlechtem Zustand",
                      "text": "Ist das Gebäude, in dem sich die Wohnung befindet, in einem schlechten Zustand?",
                      "info": "Hierzu zählen z.B.: dauernde Durchfeuchtung des Mauerwerks (auch im Keller), große Putzschäden oder erhebliche Schäden am Dach.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nSchlechter Instandhaltungszustand (z.B. dauernde Durchfeuchtung des Mauerwerks - auch Keller -, große Putzschäden, erhebliche Schäden an der Dacheindeckung) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "l28ub",
                      "type": "If",
                      "cases": [
                        {
                          "id": "4mchoi",
                          "type": "IfCase",
                          "test": {
                            "id": "0mhjc",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Gebäude ist in schlechtem Zustand"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "qzhja",
                              "8i22j"
                            ]
                          },
                          "block": [
                            {
                              "id": "5sykm",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "az5yz",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "ye0fw",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k",
                                      "7np1",
                                      "m2jo",
                                      "4obam",
                                      "oqyrs"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "s6877i",
                                      "type": "Question",
                                      "alias": "Gebäude ist in gutem Zustand",
                                      "text": "Ist das Gebäude, in dem sich die Wohnung befindet, in einem sehr guten Zustand?",
                                      "info": "Insgesamt sollte der Eindruck eines frisch renovierten Hauses entstehen. Das ist dann anzunehmen, wenn sowohl Fassade als auch Dach den Eindruck machen frisch renoviert zu sein.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015-2023:\nÜberdurchschnittlich guter Instandhaltungszustand des Gebäude(-teil)s, indem sich die Wohnung befindet (z.B. erneuerte Fassade, Dach) [++]\n\nMerkmal >=2024:\nÜberdurchschnittlich guter Instandhaltungszustand des\nGebäude (-teil-)s, in dem sich die Wohnung befindet (z.B. erneuerte Fassade, Dach); gilt für die Baualtersklassen bis einschließlich 2015\n\nJa -> Check\nNicht sicher -> Nicht sicher \n"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "ciipi",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "i9bwul",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "5846m",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lte",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 2015
                                          }
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "eiemr",
                                          "type": "Question",
                                          "alias": "Gebäude ist in gutem Zustand",
                                          "text": "Ist das Gebäude, in dem sich die Wohnung befindet, in einem sehr guten Zustand?",
                                          "info": "Insgesamt sollte der Eindruck eines frisch renovierten Hauses entstehen. Das ist dann anzunehmen, wenn sowohl Fassade als auch Dach den Eindruck machen frisch renoviert zu sein.",
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015-2023:\nÜberdurchschnittlich guter Instandhaltungszustand des Gebäude(-teil)s, indem sich die Wohnung befindet (z.B. erneuerte Fassade, Dach) [++]\n\nMerkmal >=2024:\nÜberdurchschnittlich guter Instandhaltungszustand des\nGebäude (-teil-)s, in dem sich die Wohnung befindet (z.B. erneuerte Fassade, Dach); gilt für die Baualtersklassen bis einschließlich 2015\n\nJa -> Check\nNicht sicher -> Nicht sicher \n"
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                },
                {
                  "id": "mswja",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Fahrstuhl",
                  "block": [
                    {
                      "id": "3dng9",
                      "type": "If",
                      "alternate": [
                        {
                          "id": "6zl04j",
                          "type": "Question",
                          "alias": "Gebäude hat Fahrstuhl",
                          "text": "Gibt es einen Fahrstuhl, mit dem deine Wohnung erreichbar ist?",
                          "info": null,
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": ""
                        },
                        {
                          "id": "yrqu4",
                          "type": "If",
                          "cases": [
                            {
                              "id": "8h8t5",
                              "type": "IfCase",
                              "test": {
                                "id": "jouct",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Gebäude hat Fahrstuhl"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "uiajj"
                                ]
                              },
                              "block": [
                                {
                                  "id": "z4edm",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "7wr6c",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "np07e",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "lt",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 2010
                                          }
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "hdpeq",
                                          "type": "Question",
                                          "alias": "Gebäude hat <5 Stockwerke und Fahrstuhl",
                                          "text": "Hat das Gebäude höchstens vier Obergeschosse?",
                                          "info": "Zähle die Obergeschosse des gesamten Gebäudes, nicht nur bis zu deiner Wohnung. Das Erdgeschoss zählt nicht mit.",
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Aufzug im Haus“ nicht zutrifft Personenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2017:\nPersonenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2024:\nPersonenaufzug bei weniger als fünf Obergeschossen; gilt nicht für die Baualtersklassen ab 2010 [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                }
                              ]
                            },
                            {
                              "id": "yankg",
                              "type": "IfCase",
                              "test": {
                                "id": "zqjfy",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Gebäude hat Fahrstuhl"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "qzhja"
                                ]
                              },
                              "block": [
                                {
                                  "id": "h4cq7",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "3g7wn",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "ztsa3",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Baujahr"
                                        },
                                        "negated": false,
                                        "type": "AnswerNumberComparison",
                                        "operator": "gt",
                                        "comparands": [
                                          {
                                            "type": "NumberLiteral",
                                            "value": 1949
                                          }
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "s5vfsj",
                                          "type": "Question",
                                          "alias": "Gebäude hat >=5 Stockwerke und kein Fahrstuhl",
                                          "text": "Liegt deine Wohnung im fünften Obergeschoss oder höher?",
                                          "info": "Das Erdgeschoss zählt nicht als Obergeschoss.",
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2017-2023:\nWohnung ab fünftem Obergeschoss  ohne Personenaufzug [--]\n\nMerkmal >=2024:\nWohnung ab fünftem Obergeschoss ohne Personenaufzug (gilt nicht für die Baualtersklassen bis 1949) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                }
                              ]
                            }
                          ],
                          "alternate": [
                            {
                              "type": "If",
                              "id": "rm458",
                              "alternate": [],
                              "cases": [
                                {
                                  "type": "IfCase",
                                  "id": "jxd9ql",
                                  "block": [
                                    {
                                      "id": "f9f1q",
                                      "type": "Question",
                                      "alias": "Gebäude hat <5 Stockwerke und Fahrstuhl",
                                      "text": "Hat das Gebäude höchstens vier Obergeschosse?",
                                      "info": "Zähle die Obergeschosse des gesamten Gebäudes, nicht nur bis zu deiner Wohnung. Das Erdgeschoss zählt nicht mit.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Aufzug im Haus“ nicht zutrifft Personenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2017:\nPersonenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2024:\nPersonenaufzug bei weniger als fünf Obergeschossen; gilt nicht für die Baualtersklassen ab 2010 [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ],
                                  "test": {
                                    "id": "fyhsv",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Baujahr"
                                    },
                                    "operator": "lt",
                                    "negated": false,
                                    "type": "AnswerNumberComparison",
                                    "comparands": [
                                      {
                                        "type": "NumberLiteral",
                                        "value": 2010
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            {
                              "type": "If",
                              "id": "du5c",
                              "alternate": [],
                              "cases": [
                                {
                                  "type": "IfCase",
                                  "id": "f5ij4",
                                  "test": {
                                    "id": "s8kax",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Baujahr"
                                    },
                                    "operator": "gt",
                                    "negated": false,
                                    "type": "AnswerNumberComparison",
                                    "comparands": [
                                      {
                                        "type": "NumberLiteral",
                                        "value": 1949
                                      }
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "5r0gc",
                                      "type": "Question",
                                      "alias": "Gebäude hat >=5 Stockwerke und kein Fahrstuhl",
                                      "text": "Liegt deine Wohnung im fünften Obergeschoss oder höher?",
                                      "info": "Das Erdgeschoss zählt nicht als Obergeschoss.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2017-2023:\nWohnung ab fünftem Obergeschoss  ohne Personenaufzug [--]\n\nMerkmal >=2024:\nWohnung ab fünftem Obergeschoss ohne Personenaufzug (gilt nicht für die Baualtersklassen bis 1949) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "cases": [
                        {
                          "id": "j8o8a",
                          "type": "IfCase",
                          "test": {
                            "id": "rlgcs",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "t04m9",
                              "type": "If",
                              "note": "Das Sondermerkmal „Aufzug im Haus“ wird nur für Gebäude mit einem Baujahr vor 1918 abgefragt.",
                              "cases": [
                                {
                                  "id": "qk5ls",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "fs5ns",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Sondermerkmal Aufzug"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "uiajj"
                                    ]
                                  },
                                  "block": []
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "pft7r",
                                  "type": "Question",
                                  "alias": "Gebäude hat Fahrstuhl",
                                  "text": "Gibt es einen Fahrstuhl, mit dem deine Wohnung erreichbar ist?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": ""
                                },
                                {
                                  "id": "x7m57",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "8dfum",
                                      "type": "IfCase",
                                      "block": [
                                        {
                                          "id": "fp2vg",
                                          "type": "Question",
                                          "alias": "Gebäude hat <5 Stockwerke und Fahrstuhl",
                                          "text": "Hat das Gebäude höchstens vier Obergeschosse?",
                                          "info": "Zähle die Obergeschosse des gesamten Gebäudes, nicht nur bis zu deiner Wohnung. Das Erdgeschoss zählt nicht mit.",
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Aufzug im Haus“ nicht zutrifft Personenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2017:\nPersonenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2024:\nPersonenaufzug bei weniger als fünf Obergeschossen; gilt nicht für die Baualtersklassen ab 2010 [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ],
                                      "test": {
                                        "id": "w5m5d",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Gebäude hat Fahrstuhl"
                                        },
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "uiajj"
                                        ]
                                      }
                                    },
                                    {
                                      "type": "IfCase",
                                      "id": "t935h",
                                      "block": [
                                        {
                                          "id": "9fpe4i",
                                          "type": "Question",
                                          "alias": "Gebäude hat >=5 Stockwerke und kein Fahrstuhl",
                                          "text": "Liegt deine Wohnung im fünften Obergeschoss oder höher?",
                                          "info": "Das Erdgeschoss zählt nicht als Obergeschoss.",
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2017-2023:\nWohnung ab fünftem Obergeschoss  ohne Personenaufzug [--]\n\nMerkmal >=2024:\nWohnung ab fünftem Obergeschoss ohne Personenaufzug (gilt nicht für die Baualtersklassen bis 1949) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ],
                                      "test": {
                                        "id": "sadxy",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Gebäude hat Fahrstuhl"
                                        },
                                        "operator": "is",
                                        "negated": false,
                                        "type": "AnswerOptionComparison",
                                        "comparands": [
                                          "qzhja"
                                        ]
                                      }
                                    }
                                  ],
                                  "alternate": [
                                    {
                                      "id": "hzu1yi",
                                      "type": "Question",
                                      "alias": "Gebäude hat <5 Stockwerke und Fahrstuhl",
                                      "text": "Hat das Gebäude höchstens vier Obergeschosse?",
                                      "info": "Zähle die Obergeschosse des gesamten Gebäudes, nicht nur bis zu deiner Wohnung. Das Erdgeschoss zählt nicht mit.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Aufzug im Haus“ nicht zutrifft Personenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2017:\nPersonenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2024:\nPersonenaufzug bei weniger als fünf Obergeschossen; gilt nicht für die Baualtersklassen ab 2010 [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    },
                                    {
                                      "id": "zlk42",
                                      "type": "Question",
                                      "alias": "Gebäude hat >=5 Stockwerke und kein Fahrstuhl",
                                      "text": "Liegt deine Wohnung im fünften Obergeschoss oder höher?",
                                      "info": "Das Erdgeschoss zählt nicht als Obergeschoss.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2017-2023:\nWohnung ab fünftem Obergeschoss  ohne Personenaufzug [--]\n\nMerkmal >=2024:\nWohnung ab fünftem Obergeschoss ohne Personenaufzug (gilt nicht für die Baualtersklassen bis 1949) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "id": "elcml",
                          "type": "IfCase",
                          "test": {
                            "id": "y79f4g",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "7np1",
                              "m2jo",
                              "4obam",
                              "oqyrs"
                            ]
                          },
                          "block": [
                            {
                              "id": "udfm5",
                              "type": "Question",
                              "alias": "Gebäude hat Fahrstuhl",
                              "text": "Gibt es einen Fahrstuhl, mit dem deine Wohnung erreichbar ist?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": ""
                            },
                            {
                              "id": "w44o",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "rxv2l",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "yfm5b",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Gebäude hat Fahrstuhl"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "uiajj"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "9j8in",
                                      "type": "Question",
                                      "alias": "Gebäude hat <5 Stockwerke und Fahrstuhl",
                                      "text": "Hat das Gebäude höchstens vier Obergeschosse?",
                                      "info": "Zähle die Obergeschosse des gesamten Gebäudes, nicht nur bis zu deiner Wohnung. Das Erdgeschoss zählt nicht mit.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Aufzug im Haus“ nicht zutrifft Personenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2017:\nPersonenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2024:\nPersonenaufzug bei weniger als fünf Obergeschossen; gilt nicht für die Baualtersklassen ab 2010 [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                },
                                {
                                  "id": "z1a0v",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "ev4dt",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Gebäude hat Fahrstuhl"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "qzhja"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "dx4kf",
                                      "type": "Question",
                                      "alias": "Gebäude hat >=5 Stockwerke und kein Fahrstuhl",
                                      "text": "Liegt deine Wohnung im fünften Obergeschoss oder höher?",
                                      "info": "Das Erdgeschoss zählt nicht als Obergeschoss.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2017-2023:\nWohnung ab fünftem Obergeschoss  ohne Personenaufzug [--]\n\nMerkmal >=2024:\nWohnung ab fünftem Obergeschoss ohne Personenaufzug (gilt nicht für die Baualtersklassen bis 1949) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "a2byu",
                                  "type": "Question",
                                  "alias": "Gebäude hat <5 Stockwerke und Fahrstuhl",
                                  "text": "Hat das Gebäude höchstens vier Obergeschosse?",
                                  "info": "Zähle die Obergeschosse des gesamten Gebäudes, nicht nur bis zu deiner Wohnung. Das Erdgeschoss zählt nicht mit.",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015:\nNur wenn Sondermerkmal „Aufzug im Haus“ nicht zutrifft Personenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2017:\nPersonenaufzug bei weniger als fünf Obergeschossen [++]\n\nMerkmal >=2024:\nPersonenaufzug bei weniger als fünf Obergeschossen; gilt nicht für die Baualtersklassen ab 2010 [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                },
                                {
                                  "id": "y8mhv",
                                  "type": "Question",
                                  "alias": "Gebäude hat >=5 Stockwerke und kein Fahrstuhl",
                                  "text": "Liegt deine Wohnung im fünften Obergeschoss oder höher?",
                                  "info": "Das Erdgeschoss zählt nicht als Obergeschoss.",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2017-2023:\nWohnung ab fünftem Obergeschoss  ohne Personenaufzug [--]\n\nMerkmal >=2024:\nWohnung ab fünftem Obergeschoss ohne Personenaufzug (gilt nicht für die Baualtersklassen bis 1949) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "cdkv6",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Fahrrad",
                  "block": [
                    {
                      "id": "3hdtc",
                      "type": "If",
                      "cases": [
                        {
                          "id": "we3z9",
                          "type": "IfCase",
                          "test": {
                            "id": "jrapd",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "ma60t",
                              "type": "Question",
                              "alias": "Gebäude hat Fahrradabstellmöglichkeit",
                              "text": "Ist es möglich, auf dem Grundstück des Hauses Fahrräder abzustellen?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nKeine Fahrradabstellmöglichkeit [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                            },
                            {
                              "id": "m2fbk",
                              "type": "Question",
                              "alias": "Gebäude hat Fahrradabstellraum",
                              "text": "Gibt es innerhalb oder außerhalb des Gebäudes einen abschließbaren Raum zum Abstellen von Fahrrädern?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nAbschließbarer Fahrradabstellraum innerhalb oder außerhalb des Gebäudes [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        },
                        {
                          "id": "fj4er",
                          "type": "IfCase",
                          "test": {
                            "id": "jrapd",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "7np1"
                            ]
                          },
                          "block": [
                            {
                              "id": "lgcxi",
                              "type": "Question",
                              "alias": "Gebäude hat Fahrradstellplätze mit Anschließmöglichkeit",
                              "text": "Gibt es einen leicht zugänglichen, abschließbaren Raum zum Abstellen von Fahrrädern?",
                              "info": "Beachte: dieser Raum muss groß genug sein, dass er genug Platz für alle ihn nutzenden Bewohner*innen bietet.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nAbschließbarer Fahrradabstellraum innerhalb oder außerhalb des Gebäudes [++]\n\nMerkmal 2017:\nAbschließbarer leicht zugänglicher Fahrradabstellraum innerhalb des Gebäudes oder Fahrradabstellplätze mit Anschließmöglichkeit außerhalb des Gebäudes auf dem Grundstück [++]\n\nMerkmal >=2019:\nAbschließbarer leicht zugänglicher Fahrradabstellraum innerhalb des Gebäudes oder Fahrradabstellplätze mit Anschließmöglichkeit außerhalb des Gebäudes auf dem Grundstück (ausreichend dimensioniert) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            },
                            {
                              "id": "et39j",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "fq0jy",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "x8zb4",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Gebäude hat Fahrradabstellraum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "qzhja",
                                      "8i22j"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "dfy6sf",
                                      "type": "Question",
                                      "alias": "Gebäude hat Fahrradstellplätze mit Anschließmöglichkeit",
                                      "text": "Gibt es auf dem Grundstück des Hauses ausreichend Stellplätze für Fahrräder, an denen du das Fahrrad sicher anschließen kannst?",
                                      "info": "Beachte: Einfache Fahrradständer an denen lediglich die Vorderräder angeschlossen werden können gelten nicht, da sie nicht sicher sind. Auch diese Stellplätze müssen genug Platz für alle Mieter*innen bieten.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "qqxhk",
                          "type": "Question",
                          "alias": "Gebäude hat Fahrradabstellraum",
                          "text": "Gibt es einen leicht zugänglichen, abschließbaren Raum zum Abstellen von Fahrrädern?",
                          "info": "Beachte: dieser Raum muss groß genug sein, dass er genug Platz für alle ihn nutzenden Bewohner*innen bietet.",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal 2015:\nAbschließbarer Fahrradabstellraum innerhalb oder außerhalb des Gebäudes [++]\n\nMerkmal 2017:\nAbschließbarer leicht zugänglicher Fahrradabstellraum innerhalb des Gebäudes oder Fahrradabstellplätze mit Anschließmöglichkeit außerhalb des Gebäudes auf dem Grundstück [++]\n\nMerkmal >=2019:\nAbschließbarer leicht zugänglicher Fahrradabstellraum innerhalb des Gebäudes oder Fahrradabstellplätze mit Anschließmöglichkeit außerhalb des Gebäudes auf dem Grundstück (ausreichend dimensioniert) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                        },
                        {
                          "id": "gj3c2",
                          "type": "If",
                          "cases": [
                            {
                              "id": "asl8fi",
                              "type": "IfCase",
                              "test": {
                                "id": "x8zb4",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Gebäude hat Fahrradabstellraum"
                                },
                                "negated": false,
                                "type": "AnswerOptionComparison",
                                "operator": "is",
                                "comparands": [
                                  "qzhja",
                                  "8i22j"
                                ]
                              },
                              "block": [
                                {
                                  "id": "5gzio",
                                  "type": "Question",
                                  "alias": "Gebäude hat Fahrradstellplätze mit Anschließmöglichkeit",
                                  "text": "Gibt es auf dem Grundstück des Hauses ausreichend Stellplätze für Fahrräder, an denen du das Fahrrad sicher anschließen kannst?",
                                  "info": "Beachte: Einfache Fahrradständer an denen lediglich die Vorderräder angeschlossen werden können gelten nicht, da sie nicht sicher sind. Auch diese Stellplätze müssen genug Platz für alle Mieter*innen bieten.",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015:\nAbschließbarer Fahrradabstellraum innerhalb oder außerhalb des Gebäudes [++]\n\nMerkmal 2017:\nAbschließbarer leicht zugänglicher Fahrradabstellraum innerhalb des Gebäudes oder Fahrradabstellplätze mit Anschließmöglichkeit außerhalb des Gebäudes auf dem Grundstück [++]\n\nMerkmal >=2019:\nAbschließbarer leicht zugänglicher Fahrradabstellraum innerhalb des Gebäudes oder Fahrradabstellplätze mit Anschließmöglichkeit außerhalb des Gebäudes auf dem Grundstück (ausreichend dimensioniert) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ],
                          "alternate": []
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "rpc7hi",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Keller & Abstellräume",
                  "block": [
                    {
                      "id": "c5o2u",
                      "type": "If",
                      "cases": [
                        {
                          "id": "keq14",
                          "type": "IfCase",
                          "test": {
                            "id": "jrapd",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "tdpy2",
                              "type": "Question",
                              "alias": "Gebäude hat privaten Abstellraum",
                              "text": "Gibt es einen privaten Keller, Dachboden oder Abstellraum, der zu der Wohnung gehört?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nKein nur dem Mieter zugänglicher, bestimmungsgemäß nutzbarer Abstellraum im Gebäude außerhalb der Wohnung vorhanden [--]\n\nMerkmal 2017-2023:\nKein Mieterkeller oder Kellerersatzraum zur alleinigen Nutzung des Mieters vorhanden\n\nMerkmal 2024:\nKein Abstellraum außerhalb der Wohnung zur alleinigen Nutzung ohne Zusatzkosten [++]\n\nMerkmal 2026:\nKein Abstellraum außerhalb der Wohnung zur alleinigen Nutzung ohne Zusatzkosten (z. B. kein abschließbarer Keller) [++]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        },
                        {
                          "id": "zm0i9i",
                          "type": "IfCase",
                          "test": {
                            "id": "f17wk",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "7np1",
                              "m2jo",
                              "4obam",
                              "oqyrs"
                            ]
                          },
                          "block": [
                            {
                              "id": "rsga8",
                              "type": "Question",
                              "alias": "Gebäude hat privaten Keller",
                              "text": "Gibt es einen privaten Keller oder Abstellraum, der zu der Wohnung gehört?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nKein nur dem Mieter zugänglicher, bestimmungsgemäß nutzbarer Abstellraum im Gebäude außerhalb der Wohnung vorhanden [--]\n\nMerkmal 2017-2023:\nKein Mieterkeller oder Kellerersatzraum zur alleinigen Nutzung des Mieters vorhanden\n\nMerkmal 2024:\nKein Abstellraum außerhalb der Wohnung zur alleinigen Nutzung ohne Zusatzkosten [++]\n\nMerkmal 2026:\nKein Abstellraum außerhalb der Wohnung zur alleinigen Nutzung ohne Zusatzkosten (z. B. kein abschließbarer Keller) [++]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "nv9h1",
                          "type": "Question",
                          "alias": "Gebäude hat privaten Keller",
                          "text": "Gibt es einen privaten Keller oder Abstellraum, der zu der Wohnung gehört?",
                          "info": "Ein solcher Raum zählt nicht, wenn du für diesen eine gesonderte Miete zahlst.",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal 2015:\nKein nur dem Mieter zugänglicher, bestimmungsgemäß nutzbarer Abstellraum im Gebäude außerhalb der Wohnung vorhanden [--]\n\nMerkmal 2017-2023:\nKein Mieterkeller oder Kellerersatzraum zur alleinigen Nutzung des Mieters vorhanden\n\nMerkmal 2024:\nKein Abstellraum außerhalb der Wohnung zur alleinigen Nutzung ohne Zusatzkosten [++]\n\nMerkmal 2026:\nKein Abstellraum außerhalb der Wohnung zur alleinigen Nutzung ohne Zusatzkosten (z. B. kein abschließbarer Keller) [++]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    },
                    {
                      "id": "fdcm2",
                      "type": "Question",
                      "alias": "Gebäude hat zusätzliche Räume",
                      "text": "Werden von der Vermieterin noch zusätzliche Räume angeboten?",
                      "info": "Hierzu zählt z.B. Gemeinschaftsräume, Gemeinschaftsküche oder ein Fitnessraum.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nZusätzliche und in angemessenem Umfang nutzbare Räume außerhalb der Wohnung in fußläufiger Entfernung (z.B. Gemeinschaftsraum) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "2743dk",
                      "type": "If",
                      "cases": [
                        {
                          "id": "13eag",
                          "type": "IfCase",
                          "test": {
                            "id": "jrapd",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "2rbbvj",
                              "type": "Question",
                              "alias": "Gebäude hat Parkplatz",
                              "text": "Gibt es einen kostenlosen Garagen- oder Stellplatz, der ohne zusätzliche Kosten zur Wohnung gehört?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nZur Wohnung gehörige(r) Garage/Stellplatz (ohne zusätzliches Entgelt) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                },
                {
                  "id": "fwt3t",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Weitere Fragen",
                  "block": [
                    {
                      "id": "7t7r5",
                      "type": "Question",
                      "alias": "Gebäude ist dicht bebaut",
                      "text": "Befindet sich die Wohnung im Seitenflügel mit sehr dichter Bebauung?",
                      "info": "Dies ist der Fall, wenn alle Fenster zu einem geschlossenen Hinterhof hinausgehen, bei dem die anderen Häuser nur wenige Meter entfernt stehen.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nLage im Seitenflügel oder Quergebäude bei verdichteter Bebauung [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    }
                  ]
                }
              ]
            },
            {
              "id": "jjvp2f",
              "type": "Group",
              "category": "Page",
              "alias": "Wärmedämmung",
              "block": [
                {
                  "id": "rzjc",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Energieverbrauch",
                  "block": [
                    {
                      "id": "xl45q",
                      "type": "Question",
                      "alias": "Kennt Energieverbrauch oder Energiebedarf",
                      "text": "Kennst du den Energieverbrauchskennwert oder den Energiebedarfskennwert deiner Wohnunng?",
                      "info": "Wenn du beide Werte kennst, wähle am besten den Energieverbrauchskennwer aus. Diese Werte müssen auf dem Energieausweis stehen, welcher dir vor dem Einzug gezeigt wurde.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Energieverbrauchswert",
                            "text": "Ja, ich kenne den Energieverbrauchswert"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Ernergiebedarfswert",
                            "text": "Ja, aber nur den Ernergiebedarfswert"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nein",
                            "text": "Nein"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Kein Merkmal"
                    },
                    {
                      "id": "k8yvcl",
                      "type": "If",
                      "note": "Die Energieverbrauchskennwerte beziehen sich auf Energie für Heizung und Warmwasser. Für die Einordnung eines Endenergiebedarfskennwertes sind die oben angegebenen Verbrauchsenergiekennwert-Grenzen um 20 Prozent zu erhöhen. Für dezentrale Warmwasserversorgung sind vor der Eingruppierung 20 kWh/(m²a) auf den ausgewiesenen Energiekennwert aufzuschlagen.",
                      "cases": [
                        {
                          "id": "1g99h",
                          "type": "IfCase",
                          "test": {
                            "id": "5nto4",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Kennt Energieverbrauch oder Energiebedarf"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "uiajj"
                            ]
                          },
                          "block": [
                            {
                              "id": "jxtn1",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "3jnor",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "8vmzrj",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "gr6yl",
                                      "type": "Question",
                                      "alias": "Energieverbrauchskennwert",
                                      "text": "Wie hoch ist der Energieverbrauchskennwert der Wohnung?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "---",
                                            "text": "Größer als 250 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "--",
                                            "text": "Zwischen 211 und 250 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "-",
                                            "text": "Zwischen 171 und 210 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "mr7pg",
                                            "alias": "0",
                                            "text": "Zwischen 120 und 170 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "3g6th",
                                            "alias": "+",
                                            "text": "Zwischen 100 und 119 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "46zdu",
                                            "alias": "++",
                                            "text": "Zwischen 80 und 99 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "h46t8",
                                            "alias": "+++",
                                            "text": "Kleiner als 80 kWH/(m2*a)"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Energieverbauchskennwert"
                                    }
                                  ]
                                },
                                {
                                  "id": "tbm2v",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "23vns",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "7np1",
                                      "m2jo",
                                      "4obam",
                                      "oqyrs"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "rt275",
                                      "type": "Question",
                                      "alias": "Energieverbrauchskennwert",
                                      "text": "Wie hoch ist der Energieverbrauchskennwert der Wohnung?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "---",
                                            "text": "Größer als 235 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "--",
                                            "text": "Zwischen 196 und 235 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "-",
                                            "text": "Zwischen 156 und 195 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "mr7pg",
                                            "alias": "0",
                                            "text": "Zwischen 120 und 155 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "3g6th",
                                            "alias": "+",
                                            "text": "Zwischen 100 und 119 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "46zdu",
                                            "alias": "++",
                                            "text": "Zwischen 80 und 99 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "h46t8",
                                            "alias": "+++",
                                            "text": "Kleiner als 80 kWH/(m2*a)"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Energieverbrauchskennwert"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "jpf6h",
                                  "type": "Question",
                                  "alias": "Energieverbrauchskennwert",
                                  "text": "Wie hoch ist der Energieverbrauchskennwert der Wohnung?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "---",
                                        "text": "Größer als 235 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "--",
                                        "text": "Zwischen 196 und 235 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "-",
                                        "text": "Zwischen 146 und 195 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "mr7pg",
                                        "alias": "0",
                                        "text": "Zwischen 120 und 145 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "3g6th",
                                        "alias": "+",
                                        "text": "Zwischen 100 und 119 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "46zdu",
                                        "alias": "++",
                                        "text": "Zwischen 80 und 99 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "h46t8",
                                        "alias": "+++",
                                        "text": "Kleiner als 80 kWH/(m2*a)"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Energieverbauchskennwert"
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "id": "hp69tk",
                          "type": "IfCase",
                          "test": {
                            "id": "5nto4",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Kennt Energieverbrauch oder Energiebedarf"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "qzhja"
                            ]
                          },
                          "block": [
                            {
                              "id": "irlq3",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "3lsrh",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "8vmzrj",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "2fqos",
                                      "type": "Question",
                                      "alias": "Energiebedarfskennwert",
                                      "text": "Wie hoch ist der Energiebedarfskennwert der Wohnung?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "zqjx6j",
                                            "alias": "---",
                                            "text": "Größer als 300 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "mcjdh",
                                            "alias": "--",
                                            "text": "Zwischen 253 und 299 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "42xcz",
                                            "alias": "-",
                                            "text": "Zwischen 205 und 252 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "baalbg",
                                            "alias": "0",
                                            "text": "Zwischen 144 und 204 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "4w17nh",
                                            "alias": "+",
                                            "text": "Zwischen 120 und 143 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "tygpg",
                                            "alias": "++",
                                            "text": "Zwischen 96 und 119 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "z4xhx",
                                            "alias": "+++",
                                            "text": "Kleiner als 96 kWH/(m2*a)"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Energieverbauchskennwert"
                                    }
                                  ]
                                },
                                {
                                  "id": "bndd4",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "ai04s",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "7np1",
                                      "m2jo",
                                      "4obam",
                                      "oqyrs"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "8je8w",
                                      "type": "Question",
                                      "alias": "Energiebedarfskennwert",
                                      "text": "Wie hoch ist der Energiebedarfskennwert der Wohnung?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "zqjx6j",
                                            "alias": "---",
                                            "text": "Größer als 282 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "mcjdh",
                                            "alias": "--",
                                            "text": "Zwischen 235 und 282 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "42xcz",
                                            "alias": "-",
                                            "text": "Zwischen 187 und 234 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "baalbg",
                                            "alias": "0",
                                            "text": "Zwischen 144 und 186 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "4w17nh",
                                            "alias": "+",
                                            "text": "Zwischen 120 und 143 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "tygpg",
                                            "alias": "++",
                                            "text": "Zwischen 96 und 119 kWH/(m2*a)"
                                          },
                                          {
                                            "id": "z4xhx",
                                            "alias": "+++",
                                            "text": "Kleiner als 96 kWH/(m2*a)"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Energieverbauchskennwert"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "u9pj1i",
                                  "type": "Question",
                                  "alias": "Energiebedarfskennwert",
                                  "text": "Wie hoch ist dein Energiebedarfskennwert?",
                                  "info": null,
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "zqjx6j",
                                        "alias": "---",
                                        "text": "Größer als 282 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "mcjdh",
                                        "alias": "--",
                                        "text": "Zwischen 235 und 282 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "42xcz",
                                        "alias": "-",
                                        "text": "Zwischen 176 und 234 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "baalbg",
                                        "alias": "0",
                                        "text": "Zwischen 144 und 175 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "4w17nh",
                                        "alias": "+",
                                        "text": "Zwischen 120 und 143 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "tygpg",
                                        "alias": "++",
                                        "text": "Zwischen 96 und 119 kWH/(m2*a)"
                                      },
                                      {
                                        "id": "z4xhx",
                                        "alias": "+++",
                                        "text": "Kleiner als 96 kWH/(m2*a)"
                                      }
                                    ]
                                  },
                                  "required": false
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    }
                  ]
                },
                {
                  "id": "8zr9m",
                  "type": "If",
                  "cases": [
                    {
                      "id": "y0mpq",
                      "type": "IfCase",
                      "test": {
                        "id": "n9gej",
                        "questionRef": {
                          "type": "AliasRef",
                          "value": "Kennt Energieverbrauch oder Energiebedarf"
                        },
                        "negated": false,
                        "type": "AnswerOptionComparison",
                        "operator": "is",
                        "comparands": [
                          "8i22j"
                        ]
                      },
                      "block": [
                        {
                          "id": "5qexu",
                          "type": "Group",
                          "category": "Section",
                          "alias": "Heizanlage",
                          "block": [
                            {
                              "id": "vsf4xf",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "lgt72",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "8vmzrj",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "wejo0k"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "n7j58",
                                      "type": "Question",
                                      "alias": "Gebäude hat Heizanlage mit ungünstigem Wirkungsgrad",
                                      "text": "Wurde die Heizanlage der Wohnung vor 1984 eingebaut?",
                                      "info": "Beachte: Unter der Heizanlage versteht man nur das Gerät, welches die Wärme produziert, wie z.B. Gasheizungen, Ölheizungen oder Wärmepumpen. Die Heizkörper selber gehören nicht zur Heizanlage.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015: Unzureichende Wärmedämmung oder Heizanlage mit ungünstigem Wirkungsgrad (Einbau/Installation vor 1984) [--]\n\nMerkmal 2017-2023:\nUnzureichende Wärmedämmung oder Heizanlage mit ungünstigem Wirkungsgrad (Einbau/Installation vor 1988) [--]\n\nMerkmal 2024:\nUnzureichende Wärmedämmung oder Heizanlage mit\nungünstigem Wirkungsgrad (Einbau/Installation der\nHeizanlage vor 1995) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    },
                                    {
                                      "id": "q4e3w",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "dikkq",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "iv1ii",
                                            "type": "LogicalOperation",
                                            "operator": "and",
                                            "negated": false,
                                            "conditions": [
                                              {
                                                "id": "icq4b",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Gebäude hat Heizanlage mit ungünstigem Wirkungsgrad"
                                                },
                                                "negated": false,
                                                "type": "AnswerOptionComparison",
                                                "operator": "is",
                                                "comparands": [
                                                  "qzhja",
                                                  "8i22j"
                                                ]
                                              },
                                              {
                                                "id": "icq4b",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Baujahr"
                                                },
                                                "negated": false,
                                                "type": "AnswerNumberComparison",
                                                "operator": "lte",
                                                "comparands": [
                                                  {
                                                    "type": "NumberLiteral",
                                                    "value": 1994
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "cwosy",
                                              "type": "Question",
                                              "alias": "Gebäude hat moderne Heizanlage",
                                              "text": "Wurde die Heizanlage der Wohnung nach dem 1.7.1994 erneuert?",
                                              "info": null,
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "uiajj",
                                                    "alias": "Ja",
                                                    "text": "Ja"
                                                  },
                                                  {
                                                    "id": "qzhja",
                                                    "alias": "Nein",
                                                    "text": "Nein"
                                                  },
                                                  {
                                                    "id": "8i22j",
                                                    "alias": "Nicht sicher",
                                                    "text": "Ich bin mir nicht sicher"
                                                  }
                                                ]
                                              },
                                              "required": false,
                                              "note": "Merkmal 2015:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.7.1994 (wenn Baujahr vor diesem Zeitpunkt) [++]\n\nMerkmal 2017-2023:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.1.2003 (wenn Bezugsfertigkeit des Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nMerkmal 2024:\n\"Wärmedämmung zusätzlich zur vorhandenen Bau-\nsubstanz oder Einbau/Installation einer modernen\nHeizanlage ab 2009 (wenn Bezugsfertigkeit\ndes Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                            }
                                          ]
                                        }
                                      ],
                                      "alternate": []
                                    }
                                  ]
                                },
                                {
                                  "id": "k0hjf",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "5vmzv",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Vertragsdatum"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "7np1",
                                      "m2jo",
                                      "4obam",
                                      "oqyrs"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "c5gpt",
                                      "type": "Question",
                                      "alias": "Gebäude hat Heizanlage mit ungünstigem Wirkungsgrad",
                                      "text": "Wurde die Heizanlage der Wohnung vor 1988 eingebaut?",
                                      "info": "Beachte: Unter der Heizanlage versteht man nur das Gerät, welches die Wärme produziert, wie z.B. Gasheizungen, Ölheizungen oder Wärmepumpen. Die Heizkörper selber gehören nicht zur Heizanlage.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015: Unzureichende Wärmedämmung oder Heizanlage mit ungünstigem Wirkungsgrad (Einbau/Installation vor 1984) [--]\n\nMerkmal 2017-2023:\nUnzureichende Wärmedämmung oder Heizanlage mit ungünstigem Wirkungsgrad (Einbau/Installation vor 1988) [--]\n\nMerkmal 2024:\nUnzureichende Wärmedämmung oder Heizanlage mit\nungünstigem Wirkungsgrad (Einbau/Installation der\nHeizanlage vor 1995) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    },
                                    {
                                      "id": "l4ygx",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "1aaq6h",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "zeqiv",
                                            "type": "LogicalOperation",
                                            "operator": "and",
                                            "negated": false,
                                            "conditions": [
                                              {
                                                "id": "1jjtu",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Gebäude hat Heizanlage mit ungünstigem Wirkungsgrad"
                                                },
                                                "negated": false,
                                                "type": "AnswerOptionComparison",
                                                "operator": "is",
                                                "comparands": [
                                                  "8i22j",
                                                  "qzhja"
                                                ]
                                              },
                                              {
                                                "id": "1jjtu",
                                                "questionRef": {
                                                  "type": "AliasRef",
                                                  "value": "Baujahr"
                                                },
                                                "negated": false,
                                                "type": "AnswerNumberComparison",
                                                "operator": "lt",
                                                "comparands": [
                                                  {
                                                    "type": "NumberLiteral",
                                                    "value": 2003
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "lae8ri",
                                              "type": "Question",
                                              "alias": "Gebäude hat moderne Heizanlage",
                                              "text": "Wurde die Heizanlage der Wohnung ab dem 1.1.2003 eingebaut?",
                                              "info": null,
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "uiajj",
                                                    "alias": "Ja",
                                                    "text": "Ja"
                                                  },
                                                  {
                                                    "id": "qzhja",
                                                    "alias": "Nein",
                                                    "text": "Nein"
                                                  },
                                                  {
                                                    "id": "8i22j",
                                                    "alias": "Nicht sicher",
                                                    "text": "Ich bin mir nicht sicher"
                                                  }
                                                ]
                                              },
                                              "required": false,
                                              "note": "Merkmal 2015:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.7.1994 (wenn Baujahr vor diesem Zeitpunkt) [++]\n\nMerkmal 2017-2023:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.1.2003 (wenn Bezugsfertigkeit des Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nMerkmal 2024:\n\"Wärmedämmung zusätzlich zur vorhandenen Bau-\nsubstanz oder Einbau/Installation einer modernen\nHeizanlage ab 2009 (wenn Bezugsfertigkeit\ndes Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                            }
                                          ]
                                        }
                                      ],
                                      "alternate": []
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "kgwau",
                                  "type": "Question",
                                  "alias": "Gebäude hat Heizanlage mit ungünstigem Wirkungsgrad",
                                  "text": "Wurde die Heizanlage der Wohnung vor 1995 eingebaut?",
                                  "info": "Beachte: Unter der Heizanlage versteht man nur das Gerät, welches die Wärme produziert, wie z.B. Gasheizungen, Ölheizungen oder Wärmepumpen. Die Heizkörper selber gehören nicht zur Heizanlage.",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015: Unzureichende Wärmedämmung oder Heizanlage mit ungünstigem Wirkungsgrad (Einbau/Installation vor 1984) [--]\n\nMerkmal 2017-2023:\nUnzureichende Wärmedämmung oder Heizanlage mit ungünstigem Wirkungsgrad (Einbau/Installation vor 1988) [--]\n\nMerkmal 2024:\nUnzureichende Wärmedämmung oder Heizanlage mit\nungünstigem Wirkungsgrad (Einbau/Installation der\nHeizanlage vor 1995) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                },
                                {
                                  "id": "3thr8",
                                  "type": "If",
                                  "cases": [
                                    {
                                      "id": "2pizn",
                                      "type": "IfCase",
                                      "test": {
                                        "id": "zggu",
                                        "type": "LogicalOperation",
                                        "operator": "and",
                                        "negated": false,
                                        "conditions": [
                                          {
                                            "id": "kn2ixf",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Gebäude hat Heizanlage mit ungünstigem Wirkungsgrad"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "qzhja",
                                              "8i22j"
                                            ]
                                          },
                                          {
                                            "id": "kn2ixf",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Baujahr"
                                            },
                                            "negated": false,
                                            "type": "AnswerNumberComparison",
                                            "operator": "lt",
                                            "comparands": [
                                              {
                                                "type": "NumberLiteral",
                                                "value": 2009
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      "block": [
                                        {
                                          "id": "lrsyb",
                                          "type": "Question",
                                          "alias": "Gebäude hat moderne Heizanlage",
                                          "text": "Wurde die Heizanlage der Wohnung ab dem 1.1.2009 erneuert?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.7.1994 (wenn Baujahr vor diesem Zeitpunkt) [++]\n\nMerkmal 2017-2023:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.1.2003 (wenn Bezugsfertigkeit des Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nMerkmal 2024:\n\"Wärmedämmung zusätzlich zur vorhandenen Bau-\nsubstanz oder Einbau/Installation einer modernen\nHeizanlage ab 2009 (wenn Bezugsfertigkeit\ndes Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ]
                                    }
                                  ],
                                  "alternate": []
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "id": "7fqzo",
                          "type": "Group",
                          "category": "Section",
                          "alias": "Wärmedämmung",
                          "block": [
                            {
                              "id": "wk92u",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "fsnje",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "w6p0j",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Gebäude hat Heizanlage mit ungünstigem Wirkungsgrad"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "qzhja",
                                      "8i22j"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "8dymn",
                                      "type": "Question",
                                      "alias": "Gebäude hat schlechte Wärmedämmung",
                                      "text": "Ist die Wärmedämmung der Wohnung sehr schlecht?",
                                      "info": "Hinweise hierfür können etwa sein, dass es in der Wohnung zieht oder dass es sehr schnell wieder kalt wird, nachdem man im Winter die Heizung ausschaltet.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015: Unzureichende Wärmedämmung oder Heizanlage mit ungünstigem Wirkungsgrad (Einbau/Installation vor 1984) [--]\n\nMerkmal 2017-2023:\nUnzureichende Wärmedämmung oder Heizanlage mit ungünstigem Wirkungsgrad (Einbau/Installation vor 1988) [--]\n\nMerkmal 2024:\nUnzureichende Wärmedämmung oder Heizanlage mit\nungünstigem Wirkungsgrad (Einbau/Installation der\nHeizanlage vor 1995) [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            },
                            {
                              "id": "hrhxxi",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "a4vq4",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "opyex",
                                    "type": "LogicalOperation",
                                    "operator": "and",
                                    "negated": false,
                                    "conditions": [
                                      {
                                        "id": "b15p4",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Gebäude hat schlechte Wärmedämmung"
                                        },
                                        "negated": true,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "uiajj"
                                        ]
                                      },
                                      {
                                        "id": "b15p4",
                                        "questionRef": {
                                          "type": "AliasRef",
                                          "value": "Gebäude hat moderne Heizanlage"
                                        },
                                        "negated": true,
                                        "type": "AnswerOptionComparison",
                                        "operator": "is",
                                        "comparands": [
                                          "uiajj"
                                        ]
                                      }
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "m0tm5",
                                      "type": "If",
                                      "cases": [
                                        {
                                          "id": "7xhco",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "zo1t3",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Vertragsdatum"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "wejo0k"
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "2rns5",
                                              "type": "Question",
                                              "alias": "Gebäude hat gute Wärmedämmung",
                                              "text": "Gibt es eine Wärmedämmung zusätzlich zur vorhandenen Bausubstanz?",
                                              "info": null,
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "uiajj",
                                                    "alias": "Ja",
                                                    "text": "Ja"
                                                  },
                                                  {
                                                    "id": "qzhja",
                                                    "alias": "Nein",
                                                    "text": "Nein"
                                                  },
                                                  {
                                                    "id": "8i22j",
                                                    "alias": "Nicht sicher",
                                                    "text": "Ich bin mir nicht sicher"
                                                  }
                                                ]
                                              },
                                              "required": false,
                                              "note": "Merkmal 2015:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.7.1994 (wenn Baujahr vor diesem Zeitpunkt) [++]\n\nMerkmal 2017-2023:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.1.2003 (wenn Bezugsfertigkeit des Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nMerkmal 2024:\n\"Wärmedämmung zusätzlich zur vorhandenen Bau-\nsubstanz oder Einbau/Installation einer modernen\nHeizanlage ab 2009 (wenn Bezugsfertigkeit\ndes Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                            }
                                          ]
                                        },
                                        {
                                          "id": "eatvs",
                                          "type": "IfCase",
                                          "test": {
                                            "id": "9o2deg",
                                            "questionRef": {
                                              "type": "AliasRef",
                                              "value": "Vertragsdatum"
                                            },
                                            "negated": false,
                                            "type": "AnswerOptionComparison",
                                            "operator": "is",
                                            "comparands": [
                                              "7np1",
                                              "m2jo",
                                              "4obam",
                                              "oqyrs"
                                            ]
                                          },
                                          "block": [
                                            {
                                              "id": "mrid8",
                                              "type": "Question",
                                              "alias": "Gebäude hat gute Wärmedämmung",
                                              "text": "Gibt es eine Wärmedämmung zusätzlich zur vorhandenen Bausubstanz?",
                                              "info": null,
                                              "answer": {
                                                "type": "ChoiceAnswer",
                                                "options": [
                                                  {
                                                    "id": "uiajj",
                                                    "alias": "Ja",
                                                    "text": "Ja"
                                                  },
                                                  {
                                                    "id": "qzhja",
                                                    "alias": "Nein",
                                                    "text": "Nein"
                                                  },
                                                  {
                                                    "id": "8i22j",
                                                    "alias": "Nicht sicher",
                                                    "text": "Ich bin mir nicht sicher"
                                                  }
                                                ]
                                              },
                                              "required": false,
                                              "note": "Merkmal 2015:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.7.1994 (wenn Baujahr vor diesem Zeitpunkt) [++]\n\nMerkmal 2017-2023:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.1.2003 (wenn Bezugsfertigkeit des Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nMerkmal 2024:\n\"Wärmedämmung zusätzlich zur vorhandenen Bau-\nsubstanz oder Einbau/Installation einer modernen\nHeizanlage ab 2009 (wenn Bezugsfertigkeit\ndes Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                            }
                                          ]
                                        }
                                      ],
                                      "alternate": [
                                        {
                                          "id": "rtu76j",
                                          "type": "Question",
                                          "alias": "Gebäude hat gute Wärmedämmung",
                                          "text": "Gibt es eine Wärmedämmung zusätzlich zur vorhandenen Bausubstanz?",
                                          "info": null,
                                          "answer": {
                                            "type": "ChoiceAnswer",
                                            "options": [
                                              {
                                                "id": "uiajj",
                                                "alias": "Ja",
                                                "text": "Ja"
                                              },
                                              {
                                                "id": "qzhja",
                                                "alias": "Nein",
                                                "text": "Nein"
                                              },
                                              {
                                                "id": "8i22j",
                                                "alias": "Nicht sicher",
                                                "text": "Ich bin mir nicht sicher"
                                              }
                                            ]
                                          },
                                          "required": false,
                                          "note": "Merkmal 2015:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.7.1994 (wenn Baujahr vor diesem Zeitpunkt) [++]\n\nMerkmal 2017-2023:\nWärmedämmung zusätzlich zur vorhandenen Bausubstanz oder Einbau/Installation einer modernen Heizanlage nach dem 1.1.2003 (wenn Bezugsfertigkeit des Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nMerkmal 2024:\n\"Wärmedämmung zusätzlich zur vorhandenen Bau-\nsubstanz oder Einbau/Installation einer modernen\nHeizanlage ab 2009 (wenn Bezugsfertigkeit\ndes Gebäudes/der Wohnung vor diesem Zeitpunkt) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "alternate": []
                }
              ]
            },
            {
              "id": "duu2v",
              "type": "Group",
              "category": "Page",
              "alias": "Wohnumfeld",
              "block": [
                {
                  "id": "5y6na",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Lärm- und Geruchsbelastung",
                  "block": [
                    {
                      "id": "sw4et",
                      "type": "Question",
                      "alias": "Wohnumfeld ist besonders leise",
                      "text": "Liegt die Wohnung in einer besonders ruhigen Lage?",
                      "info": "Beachte: eine einfache, ruhige Wohnstraße etwa in einer 30er-Zone reicht nicht aus. Nur die Lage an einem ruhigen Park oder in einer Straße mit besonderen (baulichen) Maßnahmen zur Verkehrsberuhigung kommen in Frage. Es darf neben dem Straßenverkehr auch keine anderen Lärmquellen geben, wie etwa Gastronomie.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal 2015:\nLage an einer besonders ruhigen Straße oder besonders ruhige Innenlage\n\nMerkmal >= 2017:\nBesonders ruhige Lage [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "6nhvq",
                      "type": "If",
                      "cases": [
                        {
                          "id": "jzu2s",
                          "type": "IfCase",
                          "test": {
                            "id": "sqpb",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Wohnumfeld ist besonders leise"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "qzhja",
                              "8i22j"
                            ]
                          },
                          "block": [
                            {
                              "id": "xzei8",
                              "type": "Question",
                              "alias": "Wohnumfeld ist besonders laut",
                              "text": "Liegt die Wohnung in einer besonders lauten Lage?",
                              "info": "Dies gilt wenn die Wohnung z.B. an einer Hauptverkehrsstraße, einer lauten Bahnstrecke oder in Flughafennähe in einer Einflugschneise liegt. Zudem kommen auch Lärm erheblicher Lärm durch Industrie und Gastronomie oder Musik in Frage. Diese dürfen aber nicht nur vorübergehend auftreten (etwa Baustellen/Straßenfeste), sondern müssen langfristig und regelmäßig auftreten.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nLage der Wohnung an einer Straße oder Schienenstrecke mit hoher Verkehrslärmbelastung oder Belastung durch Flugverkehr nach Maßgabe der Erläuterungen zur Verkehrslärmbelastung unter Nr. 12 dieses Mietspiegels [--]\n\nMerkmal 2017-2023:\nBesonders lärmbelastete Lage (ein Indiz hierfür kann die Ausweisung einer hohen Verkehrslärmbelastung gemäß Erläuterungen unter Nr. 12\ndes Mietspiegelheftes sein) [--]\n\nMerkmal 2024:\nBesonders lärmbelastete Lage der Wohnung\n(Die Wohnung liegt beispielsweise an einer Haupt-\nverkehrsstraße oder im unmittelbaren Umfeld eines\nFlughafens und erfährt dadurch unangenehme Lärm-\nund Staubemissionen. Daneben können auch große\nFabrik- und Industrieanlagen, aber auch Gewerbe-,\nRestaurant- und Partylärm Ursache für eine besonders\nlärmbelastete Lage sein.)\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    },
                    {
                      "id": "gkjtni",
                      "type": "If",
                      "cases": [
                        {
                          "id": "wwu07",
                          "type": "IfCase",
                          "test": {
                            "id": "1hxgx",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "mtohzj",
                              "type": "Question",
                              "alias": "Wohnumfeld ist geräuschs- oder geruchsbelastet",
                              "text": "Ist die Wohnung regelmäßig und erheblich durch Geräusche oder Gerüche von Gewerbe beeinträchtigt?",
                              "info": "Beachte: Damit ist hier nicht allgemeiner Verkehrlärm, sondern Lärm durch z.B. gewerblichen Liefer- und Kundenverkehr gemeint",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nErhebliche, regelmäßige Beeinträchtigung durch Geräusche oder Gerüche (Gewerbe), z.B. durch Liefer- und Kundenverkehr [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher\n"
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "ibzz9",
                          "type": "Question",
                          "alias": "Wohnumfeld ist geruchsbelastet",
                          "text": "Liegt die Wohnung einer besonders geruchsbelasteten Lage?",
                          "info": null,
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal >= 2017:\nBesonders geruchsbelastete Lage [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "872tj",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Garten & Grundstück",
                  "block": [
                    {
                      "id": "7p6zoi",
                      "type": "If",
                      "cases": [
                        {
                          "id": "3ox58",
                          "type": "IfCase",
                          "test": {
                            "id": "zfagv",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "581yth",
                              "type": "Question",
                              "alias": "Wohnumfeld ist aufwendig gestaltet",
                              "text": "Ist das Grundstück auf dem sich deine Wohnung befindet einladend gestaltetet?",
                              "info": "Das ist etwa der Fall, wenn es Grünflächen mit angelegten Wegen gibt oder Sitzbänke und Ruhezonen. Diese dürfen zudem nicht in einem verwahrlosten Zustand sein.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Sitzbänke oder Ruhezonen, neu angelegte Wegebefestigung mit Grünflächen) [++]\n\nMerkmal 2017-2023:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2024:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2002, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2026:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z. B. Kinderspielplatz - bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        },
                        {
                          "id": "6nlam",
                          "type": "IfCase",
                          "test": {
                            "id": "vfxa1",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "7np1",
                              "m2jo",
                              "4obam",
                              "oqyrs"
                            ]
                          },
                          "block": [
                            {
                              "id": "0hf2m",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "o1sdn",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "ivx6ci",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Baujahr"
                                    },
                                    "negated": false,
                                    "type": "AnswerNumberComparison",
                                    "operator": "lt",
                                    "comparands": [
                                      {
                                        "type": "NumberLiteral",
                                        "value": 2003
                                      }
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "y2o57l",
                                      "type": "Question",
                                      "alias": "Wohnumfeld ist aufwendig gestaltet",
                                      "text": "Ist das Grundstück auf dem sich deine Wohnung befindet einladend gestaltetet?",
                                      "info": "Das ist etwa der Fall, wenn es Grünflächen mit angelegten Wegen gibt, einen Kinderspielplatz oder Sitzbänke und Ruhezonen. Diese dürfen zudem nicht in einem verwahrlosten Zustand sein.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Sitzbänke oder Ruhezonen, neu angelegte Wegebefestigung mit Grünflächen) [++]\n\nMerkmal 2017-2023:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2024:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2002, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2026:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z. B. Kinderspielplatz - bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "wzi2l",
                                  "type": "Question",
                                  "alias": "Wohnumfeld ist aufwendig gestaltet",
                                  "text": "Ist das Grundstück auf dem sich deine Wohnung befindet einladend gestaltetet?",
                                  "info": "Das ist etwa der Fall, wenn es Grünflächen mit angelegten Wegen gibt oder Sitzbänke und Ruhezonen. Diese dürfen zudem nicht in einem verwahrlosten Zustand sein.",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Sitzbänke oder Ruhezonen, neu angelegte Wegebefestigung mit Grünflächen) [++]\n\nMerkmal 2017-2023:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2024:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2002, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2026:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z. B. Kinderspielplatz - bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "id": "vq99q",
                          "type": "IfCase",
                          "test": {
                            "id": "ea2f5",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "ve0tek"
                            ]
                          },
                          "block": [
                            {
                              "id": "71qoy",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "7h71y",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "ruuru",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Baujahr"
                                    },
                                    "negated": false,
                                    "type": "AnswerNumberComparison",
                                    "operator": "lt",
                                    "comparands": [
                                      {
                                        "type": "NumberLiteral",
                                        "value": 2002
                                      }
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "l6xrn",
                                      "type": "Question",
                                      "alias": "Wohnumfeld ist aufwendig gestaltet",
                                      "text": "Ist das Grundstück auf dem sich deine Wohnung befindet einladend gestaltetet?",
                                      "info": "Das ist etwa der Fall, wenn es Grünflächen mit angelegten Wegen gibt, einen Kinderspielplatz oder Sitzbänke und Ruhezonen. Diese dürfen zudem nicht in einem verwahrlosten Zustand sein.",
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Sitzbänke oder Ruhezonen, neu angelegte Wegebefestigung mit Grünflächen) [++]\n\nMerkmal 2017-2023:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2024:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2002, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2026:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z. B. Kinderspielplatz - bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": [
                                {
                                  "id": "ff22o",
                                  "type": "Question",
                                  "alias": "Wohnumfeld ist aufwendig gestaltet",
                                  "text": "Ist das Grundstück auf dem sich deine Wohnung befindet einladend gestaltetet?",
                                  "info": "Das ist etwa der Fall, wenn es Grünflächen mit angelegten Wegen gibt oder Sitzbänke und Ruhezonen. Diese dürfen zudem nicht in einem verwahrlosten Zustand sein.",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Sitzbänke oder Ruhezonen, neu angelegte Wegebefestigung mit Grünflächen) [++]\n\nMerkmal 2017-2023:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2024:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2002, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2026:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z. B. Kinderspielplatz - bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "alternate": [
                        {
                          "id": "6aly",
                          "type": "If",
                          "cases": [
                            {
                              "id": "fei17",
                              "type": "IfCase",
                              "test": {
                                "id": "ve2m",
                                "questionRef": {
                                  "type": "AliasRef",
                                  "value": "Baujahr"
                                },
                                "negated": false,
                                "type": "AnswerNumberComparison",
                                "operator": "lt",
                                "comparands": [
                                  {
                                    "type": "NumberLiteral",
                                    "value": 2003
                                  }
                                ]
                              },
                              "block": [
                                {
                                  "id": "1x9nil",
                                  "type": "Question",
                                  "alias": "Wohnumfeld ist aufwendig gestaltet",
                                  "text": "Ist das Grundstück auf dem sich deine Wohnung befindet einladend gestaltetet?",
                                  "info": "Das ist etwa der Fall, wenn es Grünflächen mit angelegten Wegen gibt, einen Kinderspielplatz oder Sitzbänke und Ruhezonen. Diese dürfen zudem nicht in einem verwahrlosten Zustand sein.",
                                  "answer": {
                                    "type": "ChoiceAnswer",
                                    "options": [
                                      {
                                        "id": "uiajj",
                                        "alias": "Ja",
                                        "text": "Ja"
                                      },
                                      {
                                        "id": "qzhja",
                                        "alias": "Nein",
                                        "text": "Nein"
                                      },
                                      {
                                        "id": "8i22j",
                                        "alias": "Nicht sicher",
                                        "text": "Ich bin mir nicht sicher"
                                      }
                                    ]
                                  },
                                  "required": false,
                                  "note": "Merkmal 2015:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Sitzbänke oder Ruhezonen, neu angelegte Wegebefestigung mit Grünflächen) [++]\n\nMerkmal 2017-2023:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2024:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2002, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2026:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z. B. Kinderspielplatz - bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                }
                              ]
                            }
                          ],
                          "alternate": [
                            {
                              "id": "vtq0y",
                              "type": "Question",
                              "alias": "Wohnumfeld ist aufwendig gestaltet",
                              "text": "Ist das Grundstück auf dem sich deine Wohnung befindet einladend gestaltetet?",
                              "info": "Das ist etwa der Fall, wenn es Grünflächen mit angelegten Wegen gibt oder Sitzbänke und Ruhezonen. Diese dürfen zudem nicht in einem verwahrlosten Zustand sein.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Sitzbänke oder Ruhezonen, neu angelegte Wegebefestigung mit Grünflächen) [++]\n\nMerkmal 2017-2023:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2024:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z.B. Kinderspielplatz – bei Bezugsfertigkeit des Gebäudes vor 2002, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nMerkmal 2026:\nAufwändig gestaltetes Wohnumfeld auf dem Grundstück (z. B. Kinderspielplatz - bei Bezugsfertigkeit des Gebäudes vor 2003, Sitzbänke oder Ruhezonen, gute Gehwegbefestigung mit Grünflächen und Beleuchtung) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "uo3ab",
                      "type": "If",
                      "cases": [
                        {
                          "id": "vwsi3g",
                          "type": "IfCase",
                          "test": {
                            "id": "ml2mb",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "ls5eo",
                              "type": "Question",
                              "alias": "Wohnumfeld hat ungepflegte Müllstandsfläche",
                              "text": "Gibt es auf dem Grundstück des Hauses eine ungepflegte, offene Müllstandsfläche?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015:\nUngepflegte und offene Müllstandfläche [--]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            },
                            {
                              "id": "5pknh",
                              "type": "If",
                              "cases": [
                                {
                                  "id": "6z29zf",
                                  "type": "IfCase",
                                  "test": {
                                    "id": "v5xuz",
                                    "questionRef": {
                                      "type": "AliasRef",
                                      "value": "Wohnumfeld hat ungepflegte Müllstandsfläche"
                                    },
                                    "negated": false,
                                    "type": "AnswerOptionComparison",
                                    "operator": "is",
                                    "comparands": [
                                      "qzhja",
                                      "8i22j"
                                    ]
                                  },
                                  "block": [
                                    {
                                      "id": "vjawm",
                                      "type": "Question",
                                      "alias": "Wohnumfeld hat gepflegte Müllstandsfläche",
                                      "text": "Gibt es auf dem Grundstück des Hauses eine gepflegte Müllstandsfläche mit sichtbegrenzender Gestaltung?",
                                      "info": null,
                                      "answer": {
                                        "type": "ChoiceAnswer",
                                        "options": [
                                          {
                                            "id": "uiajj",
                                            "alias": "Ja",
                                            "text": "Ja"
                                          },
                                          {
                                            "id": "qzhja",
                                            "alias": "Nein",
                                            "text": "Nein"
                                          },
                                          {
                                            "id": "8i22j",
                                            "alias": "Nicht sicher",
                                            "text": "Ich bin mir nicht sicher"
                                          }
                                        ]
                                      },
                                      "required": false,
                                      "note": "Merkmal 2015:\nGepflegte Müllstandsfläche mit sichtbegrenzender Gestaltung; nur den Mietern zugänglich [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                                    }
                                  ]
                                }
                              ],
                              "alternate": []
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    },
                    {
                      "id": "q96ddg",
                      "type": "Question",
                      "alias": "Wohnumfeld hat eigenen Garten",
                      "text": "Gibt einen Garten zur alleinigen Nutzung oder einen Garten, welcher direkt von der Wohnung aus betreten werden kann?",
                      "info": "Beachte: Dieser zählt auch, wenn er zur Miete zusätzlich bezahlt werden muss.",
                      "answer": {
                        "type": "ChoiceAnswer",
                        "options": [
                          {
                            "id": "uiajj",
                            "alias": "Ja",
                            "text": "Ja"
                          },
                          {
                            "id": "qzhja",
                            "alias": "Nein",
                            "text": "Nein"
                          },
                          {
                            "id": "8i22j",
                            "alias": "Nicht sicher",
                            "text": "Ich bin mir nicht sicher"
                          }
                        ]
                      },
                      "required": false,
                      "note": "Merkmal:\nGarten zur alleinigen Nutzung/Mietergarten ohne Entgelt oder zur Wohnung gehörender Garten mit direktem Zugang [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                    },
                    {
                      "id": "m4aoh",
                      "type": "If",
                      "cases": [
                        {
                          "id": "pds8a",
                          "type": "IfCase",
                          "test": {
                            "id": "angir",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Wohnumfeld hat eigenen Garten"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "qzhja",
                              "8i22j"
                            ]
                          },
                          "block": [
                            {
                              "id": "a2n7v",
                              "type": "Question",
                              "alias": "Wohnumfeld hat Gemeinschaftsgarten",
                              "text": "Gibt es einen Gemeinschaftsgarten mit anderen Mieterinnen?",
                              "info": "Beachte: Dieser gilt nur, wenn für den Garten nicht zusätzlich gezahlt werden muss.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal:\nGarten zur alleinigen Nutzung/Mietergarten ohne Entgelt oder zur Wohnung gehörender Garten mit direktem Zugang [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    },
                    {
                      "id": "knopjh",
                      "type": "If",
                      "cases": [
                        {
                          "id": "btbw3",
                          "type": "IfCase",
                          "test": {
                            "id": "hyzzm",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": []
                        }
                      ],
                      "alternate": [
                        {
                          "id": "hdti8",
                          "type": "Question",
                          "alias": "Wohnumfeld hat Fahrradabstellmöglichkeiten",
                          "text": "Ist es möglich auf dem Grundstück des Hauses Fahrräder abzustellen?",
                          "info": "Beachte: Es reicht aus, dass es generell möglich ist Fahrräder irgendwo auf dem Grundstück abzustellen, z.B. im Hinterhof oder einem Fahrradkeller. Es muss hierfür nicht extra Fahrradständer oder ähnliches geben.",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal >=2017:\nKeine Fahrradabstellmöglichkeit auf dem Grundstück [--]\n\nNein -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "1bnxh",
                  "type": "Group",
                  "category": "Section",
                  "alias": "Umgebung",
                  "block": [
                    {
                      "id": "21w4f",
                      "type": "If",
                      "cases": [
                        {
                          "id": "qjkzk",
                          "type": "IfCase",
                          "test": {
                            "id": "a8q0n",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "ve0tek",
                              "oqyrs",
                              "4obam",
                              "m2jo",
                              "7np1",
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "87ope",
                              "type": "Question",
                              "alias": "Wohnumfeld ist stark vernachlässigt",
                              "text": "Liegt die Wohnung in einer eher ungepflegten Gegend oder in einem der folgenden sogenannten kriminalitätsbelasteten Ort?",
                              "info": "Laut Polizei, zählen die folgenden Orte als kriminalitätsbelastet: Wrangelkiez im Umfeld des Görlitzer Parks, Kottbusser Tor, Hermannstraße in direkter Nähe vom S-Bahnhof Neukölln, Donaukiez im Umfeld des Hermannplatzes.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015-2024:\nLage in stark vernachlässigter Umgebung in einfacher Wohnlage [--]\n\nJa -> Check\nNicht sicher -> NIcht sicher"
                            },
                            {
                              "id": "u7n29h",
                              "type": "Question",
                              "alias": "Wohnumfeld ist repräsentativ",
                              "text": "Liegt die Wohnung in der Nähe des Kurfürstendamms oder in Berlin Mitte und in einer repräsentativen und hochwertigen Lage?",
                              "info": "Beachte: die Einschätzung der Wohnlage als gut nach dem Mietspiegelverzeichnis reicht nicht aus.",
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015-2024: \nBevorzugte Citylage (nahe repräsentativen, überregional ausstrahlenden Einkaufs-, Dienstleistungs- und Wohnstandorten) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    },
                    {
                      "id": "c4ilu",
                      "type": "If",
                      "cases": [
                        {
                          "id": "p5v72",
                          "type": "IfCase",
                          "test": {
                            "id": "oe7b5",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": [
                            {
                              "id": "4m9cx",
                              "type": "Question",
                              "alias": "Wohnumfeld hat villenartige Mehrfamilienhäuser",
                              "text": "Befinden sich in der Umgebung des Hauses villenartige Mehrfamilienhäuser?",
                              "info": null,
                              "answer": {
                                "type": "ChoiceAnswer",
                                "options": [
                                  {
                                    "id": "uiajj",
                                    "alias": "Ja",
                                    "text": "Ja"
                                  },
                                  {
                                    "id": "qzhja",
                                    "alias": "Nein",
                                    "text": "Nein"
                                  },
                                  {
                                    "id": "8i22j",
                                    "alias": "Nicht sicher",
                                    "text": "Ich bin mir nicht sicher"
                                  }
                                ]
                              },
                              "required": false,
                              "note": "Merkmal 2015: \nVillenartige Mehrfamilienhäuser [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher\n"
                            }
                          ]
                        }
                      ],
                      "alternate": []
                    },
                    {
                      "id": "hy4uk",
                      "type": "If",
                      "cases": [
                        {
                          "id": "ya3b4",
                          "type": "IfCase",
                          "test": {
                            "id": "h4cor",
                            "questionRef": {
                              "type": "AliasRef",
                              "value": "Vertragsdatum"
                            },
                            "negated": false,
                            "type": "AnswerOptionComparison",
                            "operator": "is",
                            "comparands": [
                              "wejo0k"
                            ]
                          },
                          "block": []
                        }
                      ],
                      "alternate": [
                        {
                          "id": "3cii1",
                          "type": "Question",
                          "alias": "Wohnumfeld hat Parkplatz",
                          "text": "Gibt es ein von der Vermieterin zur Verfügung gestelltes PKW-Parkplatzangebot in der Nähe der Wohnung?",
                          "info": "Beachte: Das Parkplatzangebot darf auch kostenpflichtig sein",
                          "answer": {
                            "type": "ChoiceAnswer",
                            "options": [
                              {
                                "id": "uiajj",
                                "alias": "Ja",
                                "text": "Ja"
                              },
                              {
                                "id": "qzhja",
                                "alias": "Nein",
                                "text": "Nein"
                              },
                              {
                                "id": "8i22j",
                                "alias": "Nicht sicher",
                                "text": "Ich bin mir nicht sicher"
                              }
                            ]
                          },
                          "required": false,
                          "note": "Merkmal 2017-2024:\nVom Vermieter zur Verfügung gestelltes PKW-Parkplatzangebot in der Nähe [++]\n\nMerkmal >=2026:\nVom Vermieter zur Verfügung gestelltes PKW-Parkplatzangebot in der Nähe (ausreichend dimensioniert) [++]\n\nJa -> Check\nNicht sicher -> Nicht sicher"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "xp5wh",
          "type": "Group",
          "category": "Page",
          "alias": "Auswertung",
          "block": []
        }
      ]
    }
  ]
}